import { Link } from "react-router-dom";
import React, { useState } from "react";
//import React from "react";
import Announcement from "../components/Announcement";
import Header from "../components/Header";
import FixMenu from "../components/FixMenu";

const Tender = () => {
  const [show, setShow] = useState(false);
  const [show1, setShow1] = useState(false);
  const [show2, setShow2] = useState(false);
  const [show3, setShow3] = useState(false);
  const [show4, setShow4] = useState(false);
  const [show5, setShow5] = useState(false);
  const [show6, setShow6] = useState(false);
  const [show7, setShow7] = useState(false);
  const [show8, setShow8] = useState(false);
  const [show9, setShow9] = useState(false);
  const [show10, setShow10] = useState(false);
  const [show11, setShow11] = useState(false);
  const [show12, setShow12] = useState(false);
  const [show13, setShow13] = useState(false);
  const [show14, setShow14] = useState(false);
  const [show15, setShow15] = useState(false);
  const [show16, setShow16] = useState(false);
  const [show17, setShow17] = useState(false);
  const [show18, setShow18] = useState(false);
  const [show19, setShow19] = useState(false);
  const [show20, setShow20] = useState(false);
  const [show21, setShow21] = useState(false);
  const [show22, setShow22] = useState(false);
  const [show23, setShow23] = useState(false);
  const [show24, setShow24] = useState(false);
  const [show25, setShow25] = useState(false);
  const [show26, setShow26] = useState(false);
  const [show27, setShow27] = useState(false);
  const [show28, setShow28] = useState(false);
  const [show29, setShow29] = useState(false);

  const [show30, setShow30] = useState(false);
  const [show31, setShow31] = useState(false);
  const [show32, setShow32] = useState(false);
  const [show33, setShow33] = useState(false);
  const [show34, setShow34] = useState(false);

  const [show35, setShow35] = useState(false);
  const [show36, setShow36] = useState(false);
  const [show37, setShow37] = useState(false);
  const [show38, setShow38] = useState(false);
  const [show39, setShow39] = useState(false);
  const [show40, setShow40] = useState(false);
  const [show41, setShow41] = useState(false);
  const [show42, setShow42] = useState(false);
  const [show43, setShow43] = useState(false);
  const [show44, setShow44] = useState(false);
  const [show45, setShow45] = useState(false);
  const [show46, setShow46] = useState(false);
  const [show47, setShow47] = useState(false);
  const [show48, setShow48] = useState(false);
  const [show49, setShow49] = useState(false);
  const [show50, setShow50] = useState(false);
  const [show51, setShow51] = useState(false);
  const [show52, setShow52] = useState(false);
  const [show53, setShow53] = useState(false);
  const [show54, setShow54] = useState(false);
  const [show55, setShow55] = useState(false);
  const [show56, setShow56] = useState(false);
  const [show57, setShow57] = useState(false);
  const [show58, setShow58] = useState(false);
  const [show59, setShow59] = useState(false);
  const [show60, setShow60] = useState(false);
  const [show61, setShow61] = useState(false);
  const [show62, setShow62] = useState(false);
  const [show63, setShow63] = useState(false);
  const [show64, setShow64] = useState(false);
  const [show65, setShow65] = useState(false);
  const [show66, setShow66] = useState(false);
  const [show67, setShow67] = useState(false);
  const [show68, setShow68] = useState(false);
  const [show69, setShow69] = useState(false);
  const [show70, setShow70] = useState(false);
  const [show71, setShow71] = useState(false);
  const [show72, setShow72] = useState(false);
  const [show73, setShow73] = useState(false);
  const [show74, setShow74] = useState(false);
  const [show75, setShow75] = useState(false);
  const [show76, setShow76] = useState(false);
  const [show77, setShow77] = useState(false);
  const [show78, setShow78] = useState(false);
  const [show79, setShow79] = useState(false);
  const [show80, setShow80] = useState(false);
  const [show81, setShow81] = useState(false);
  const [show82, setShow82] = useState(false);
  const [show83, setShow83] = useState(false);
  const [show84, setShow84] = useState(false);
  const [show85, setShow85] = useState(false);
  const [show86, setShow86] = useState(false);
  const [show87, setShow87] = useState(false);
  const [show88, setShow88] = useState(false);
  const [show89, setShow89] = useState(false);
  const [show90, setShow90] = useState(false);
  const [show91, setShow91] = useState(false);
  const [show92, setShow92] = useState(false);
  const [show93, setShow93] = useState(false);
  const [show94, setShow94] = useState(false);
  const [show95, setShow95] = useState(false);
  const [show96, setShow96] = useState(false);
  const [show97, setShow97] = useState(false);
  const [show98, setShow98] = useState(false);
  const [show99, setShow99] = useState(false);
  const [show100, setShow100] = useState(false);
  const [show101, setShow101] = useState(false);
  const [show102, setShow102] = useState(false);
  const [show103, setShow103] = useState(false);
  const [show104, setShow104] = useState(false);
  const [show105, setShow105] = useState(false);
  const [show106, setShow106] = useState(false);
  const [show107, setShow107] = useState(false);
  const [show108, setShow108] = useState(false);
  const [show109, setShow109] = useState(false);
  const [show110, setShow110] = useState(false);
  const [show111, setShow111] = useState(false);
  const [show112, setShow112] = useState(false);
  const [show113, setShow113] = useState(false);
  const [show114, setShow114] = useState(false);
  const [show115, setShow115] = useState(false);
  const [show116, setShow116] = useState(false);
  const [show117, setShow117] = useState(false);
  const [show118, setShow118] = useState(false);
  const [show119, setShow119] = useState(false);
  const [show120, setShow120] = useState(false);
  const [show121, setShow121] = useState(false);
  const [show122, setShow122] = useState(false);
  const [show123, setShow123] = useState(false);
  const [show124, setShow124] = useState(false);
  const [show125, setShow125] = useState(false);
  const [show126, setShow126] = useState(false);
  const [show127, setShow127] = useState(false);
  const [show128, setShow128] = useState(false);
  const [show129, setShow129] = useState(false);
  const [show130, setShow130] = useState(false);
  const [show131, setShow131] = useState(false);
  const [show132, setShow132] = useState(false);
  const [show133, setShow133] = useState(false);
  const [show134, setShow134] = useState(false);
  const [show135, setShow135] = useState(false);
  const [show136, setShow136] = useState(false);
  const [show137, setShow137] = useState(false);
  const [show138, setShow138] = useState(false);
  const [show139, setShow139] = useState(false);
  const [show140, setShow140] = useState(false);
  const [show141, setShow141] = useState(false);
  const [show142, setShow142] = useState(false);
  const [show143, setShow143] = useState(false);
  const [show144, setShow144] = useState(false);
  const [show145, setShow145] = useState(false);
  const [show146, setShow146] = useState(false);
  const [show147, setShow147] = useState(false);
  const [show148, setShow148] = useState(false);
  const [show149, setShow149] = useState(false);
  const [show150, setShow150] = useState(false);
  const [show151, setShow151] = useState(false);
  const [show152, setShow152] = useState(false);
  const [show153, setShow153] = useState(false);
  const [show154, setShow154] = useState(false);
  const [show155, setShow155] = useState(false);
  const [show156, setShow156] = useState(false);
  const [show157, setShow157] = useState(false);
  const [show158, setShow158] = useState(false);
  const [show159, setShow159] = useState(false);
  const [show160, setShow160] = useState(false);
  const [show161, setShow161] = useState(false);
  const [show162, setShow162] = useState(false);
  const [show163, setShow163] = useState(false);
  const [show164, setShow164] = useState(false);
  const [show165, setShow165] = useState(false);
  const [show166, setShow166] = useState(false);
  const [show167, setShow167] = useState(false);
  const [show168, setShow168] = useState(false);
  const [show169, setShow169] = useState(false);
  const [show170, setShow170] = useState(false);
  const [show171, setShow171] = useState(false);
  const [show172, setShow172] = useState(false);
  const [show173, setShow173] = useState(false);
  const [show174, setShow174] = useState(false);
  const [show175, setShow175] = useState(false);
  const [show176, setShow176] = useState(false);
  const [show177, setShow177] = useState(false);
  const [show178, setShow178] = useState(false);
  const [show179, setShow179] = useState(false);
  const [show180, setShow180] = useState(false);
  const [show181, setShow181] = useState(false);
  const [show182, setShow182] = useState(false);
  const [show183, setShow183] = useState(false);
  const [show184, setShow184] = useState(false);
  const [show185, setShow185] = useState(false);
  const [show186, setShow186] = useState(false);
  const [show187, setShow187] = useState(false);
  const [show188, setShow188] = useState(false);
  const [show189, setShow189] = useState(false);
  const [show190, setShow190] = useState(false);
  const [show191, setShow191] = useState(false);
  const [show192, setShow192] = useState(false);
  const [show193, setShow193] = useState(false);
  const [show194, setShow194] = useState(false);
  const [show195, setShow195] = useState(false);
  const [show196, setShow196] = useState(false);
  const [show197, setShow197] = useState(false);
  const [show198, setShow198] = useState(false);
  const [show199, setShow199] = useState(false);
  const [show200, setShow200] = useState(false);
  const [show201, setShow201] = useState(false);
  const [show202, setShow202] = useState(false);
  const [show203, setShow203] = useState(false);
  const [show204, setShow204] = useState(false);
  const [show205, setShow205] = useState(false);
  const [show206, setShow206] = useState(false);
  const [show207, setShow207] = useState(false);
  const [show208, setShow208] = useState(false);
  const [show209, setShow209] = useState(false);
  const [show210, setShow210] = useState(false);
  const [show211, setShow211] = useState(false);
  const [show212, setShow212] = useState(false);
  const [show213, setShow213] = useState(false);
  const [show214, setShow214] = useState(false);
  const [show215, setShow215] = useState(false);
  const [show216, setShow216] = useState(false);
  const [show217, setShow217] = useState(false);
  const [show218, setShow218] = useState(false);
  const [show219, setShow219] = useState(false);
  const [show220, setShow220] = useState(false);
  const [show221, setShow221] = useState(false);
  const [show222, setShow222] = useState(false);
  const [show223, setShow223] = useState(false);
  const [show224, setShow224] = useState(false);
  const [show225, setShow225] = useState(false);
  const [show226, setShow226] = useState(false);
  const [show227, setShow227] = useState(false);
  const [show228, setShow228] = useState(false);
  const [show229, setShow229] = useState(false);

  return (
    <>
      <div id="bodyaddid">
        <Header />
        <FixMenu />

        <section className="main-banner">
          <div
            className="innerpagebanner"
            style={{
              backgroundImage:
                "url(" +
                "assets/img/inner/online-vendor-registration.jpg" +
                ")",
              backgroundSize: "100% auto",
            }}
          ></div>
          <Announcement />
        </section>

        <section className="main_sectiods">
          <div className="container main_bdy">
            <div className="row">
              <div className="col-lg-12 brdcum_designs">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="https://www.noidapower.com/">Home</a>
                    <span className="icondsds">
                      <i className="fa fa-chevron-right" aria-hidden="true"></i>
                    </span>
                  </li>
                  <li className="breadcrumb-item">
                    <a href="#" className="active">
                      Online Vendor Registration
                    </a>
                  </li>
                </ol>
              </div>
            </div>
            <div className="row justify-content-center">
              <div className="col-sm-12 bg_cols">
                <div className="form_div">
                  <ul className="nav nav-tabs nav_tbds">
                    <li className="nav-item">
                      <Link
                        to="/online-vendor-registration"
                        className="nav-link "
                        data-toggle="tab"
                      >
                        Online Vendor Registration
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link
                        to="/contact-for-eprocurement"
                        className="nav-link"
                        data-toggle="tab"
                      >
                        Contact for e-Procurement
                      </Link>
                    </li>
                    <li className="nav-item">
                      <a href="https://iwebapps.noidapower.com:8032/powerProcAddr.aspx"
                        className="nav-link" target="_blank" rel="noreferrer"
                      >
                        Contact for Power Procurement
                      </a>
                    </li>
                    <li className="nav-item">
                      <Link
                        to="/tenders"
                        className="nav-link active"
                        data-toggle="tab"
                      >
                        Tenders
                      </Link>
                    </li>
                  </ul>
                  <div className="tab-content tab_main">

                    <div id="accordion">
                    <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow229(!show229)}
                        >
                          <b>CORRIGENDUM-1 Dated 03.10.2025 against NIT No. NPCL/FY25-26/RMU WORKSHOP/031</b>
                        </div>
                        {show229 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No.</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>NIT No. NPCL/FY25-26/RMU WORKSHOP/031</td>
                                <td>NIT No. NPCL/FY25-26/RMU WORKSHOP/031</td>
                                <td>

                                  <li>
                                    <a
                                      href="https://iwebapps.noidapower.com:8032/download/NIT/Corriegendum-1 (2).pdf"
                                      target="_blank" rel="noreferrer"
                                    >
                                      <img src="assets/img/doc-icon.png" alt="" />
                                    </a>
                                  </li>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>
                    <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow228(!show228)}
                        >
                          <b>CORRIGENDUM-1 Dated 03.10.2025 against NIT No. NPCL/FY25-26/LAB/030</b>
                        </div>
                        {show228 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No.</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>NIT No. NPCL/FY25-26/LAB/030</td>
                                <td>NIT No. NPCL/FY25-26/LAB/030</td>
                                <td>

                                  <li>
                                    <a
                                      href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26LAB030/Corriegendum-1_Metering_Lab.pdf"
                                      target="_blank" rel="noreferrer"
                                    >
                                      <img src="assets/img/doc-icon.png" alt="" />
                                    </a>
                                  </li>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>
                    <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow227(!show227)}
                        >
                          <b>CORRIGENDUM-1 Dated 03.10.2025 against NIT No. NPCL/FY25-26/33KV AIS/028</b>
                        </div>
                        {show227 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No.</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>NIT No. NPCL/FY25-26/33KV AIS/028</td>
                                <td>NIT No. NPCL/FY25-26/33KV AIS/028</td>
                                <td>

                                  <li>
                                    <a
                                      href="https://iwebapps.noidapower.com:8032/download/NIT/Corriegendum-1_dated_03.10.2025_NIT_No._NPCL-FY25-26-33KV_AIS-028_Dated____11.09.2025Extension_of_Bid_Submission_Date.docx"
                                      target="_blank" rel="noreferrer"
                                    >
                                      <img src="assets/img/doc-icon.png" alt="" />
                                    </a>
                                  </li>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>
                    <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow226(!show226)}
                        >
                          <b>Corrigendum-1 against NIT No. NPCL/FY25-26/LAB/030</b>
                        </div>
                        {show226 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No.</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>NIT No. NPCL/FY25-26/LAB/030</td>
                                <td>NIT No. NPCL/FY25-26/LAB/030</td>
                                <td>

                                  <li>
                                    <a
                                      href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26LAB030/Corriegendum-1_dated_03.10.2025_NIT_No._NPCL-FY25-26-LAB-030_Dated____11.09.2025Extension_of_Bid_Submission_Date.docx"
                                      target="_blank" rel="noreferrer"
                                    >
                                      <img src="assets/img/doc-icon.png" alt="" />
                                    </a>
                                  </li>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>
                    <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow225(!show225)}
                        >
                          <b>corrigendum-1 against NIT No. NPCL/FY25-26/RMU WORKSHOP/031</b>
                        </div>
                        {show225 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No.</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>NIT No. NPCL/FY25-26/RMU WORKSHOP/031</td>
                                <td>NIT No. NPCL/FY25-26/RMU WORKSHOP/031</td>
                                <td>

                                  <li>
                                    <a
                                      href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26RMU Workshop31/Corriegendum-1_dated_03.10.2025_NIT_No._NPCL-FY25-26-RMU-031_Dated____11.09.2025Extension_of_Bid_Submission_Date__2_.docx"
                                      target="_blank" rel="noreferrer"
                                    >
                                      <img src="assets/img/doc-icon.png" alt="" />
                                    </a>
                                  </li>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>
                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow224(!show224)}
                        >
                          <b>Corrignedum-01 against NIT No. NPCL/FY25-26/RWH/36</b>
                        </div>
                        {show224 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No.</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>NIT No. NPCL/FY25-26/RWH/36</td>
                                <td>NIT No. NPCL/FY25-26/RWH/36</td>
                                <td>

                                  <li>
                                    <a
                                      href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26RWH36/Corriegendum-1 dated 03.10.2025 Extension of Bid Submission Date.docx"
                                      target="_blank" rel="noreferrer"
                                    >
                                      <img src="assets/img/doc-icon.png" alt="" />
                                    </a>
                                  </li>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>
                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow223(!show223)}
                        >
                          <b>Corrigendum-07 | NPCL/FY25-26/AMI/18 | for â€œCorrignedum-07 against Tender No: NPCL/FY25-26/AMI/18 in our NPLC website.â€</b>
                        </div>
                        {show223 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No.</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>Corrigendum-07 | NPCL/FY25-26/AMI/18 | for â€œCorrignedum-07 against Tender No: NPCL/FY25-26/AMI/18 in our NPLC website.â€</td>
                                <td>Corrigendum-07 | NPCL/FY25-26/AMI/18 |</td>
                                <td>

                                  <li>
                                    <a
                                      href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26AMI18/CORRIGENDUM-7-_AMI_Dated_27.09.2025.pdf"
                                      target="_blank" rel="noreferrer"
                                    >
                                      <img src="assets/img/pdf.png" alt="" />
                                    </a>
                                  </li>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>
                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow222(!show222)}
                        >
                          <b>NIT No. NIT NPCL/FY25-26/11 kV Metering Cubicle/035 for â€œAnnual Rate Contract for the Supply of 11 kV Metering Cubicles.â€</b>
                        </div>
                        {show222 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No.</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>NIT No. NIT NPCL/FY25-26/11 kV Metering Cubicle/035 for â€œAnnual Rate Contract for the Supply of 11 kV Metering Cubicles.â€</td>
                                <td>NIT No. NIT NPCL/FY25-26/11 kV Metering Cubicle/035</td>
                                <td>

                                  <li>
                                    <a
                                      href="https://iwebapps.noidapower.com:8032/download/NIT/NIT_NPCLFY25-2611_kV_Metering_Cubicle035/Bid_Document_Metering_Cubicle.pdf"
                                      target="_blank" rel="noreferrer"
                                    >
                                      <img src="assets/img/pdf.png" alt="" />
                                    </a>
                                  </li>
                                  <li>
                                    <a
                                      href="https://iwebapps.noidapower.com:8032/download/NIT/NIT_NPCLFY25-2611_kV_Metering_Cubicle035/Signed Documents - 11kV CTPT Metering Cubicle Specs.pdf"
                                      target="_blank" rel="noreferrer"
                                    >
                                      <img src="assets/img/pdf.png" alt="" />
                                    </a>
                                  </li>
                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow221(!show221)}
                        >
                          <b>NIT No. NPCL/FY25-26/BOP/37 for â€œSupply of Balance of Plant and Erection, Testing & Commissioning of 33/11kV Substations at Greater Noidaâ€</b>
                        </div>
                        {show221 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No.</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>NIT No. NPCL/FY25-26/BOP/37 for â€œSupply of Balance of Plant and Erection, Testing & Commissioning of 33/11kV Substations at Greater Noidaâ€</td>
                                <td>NIT No. NPCL/FY25-26/BOP/37</td>
                                <td>

                                  <li>
                                    <a
                                      href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26BOP37/Final_Website_BOP_Tender.pdf"
                                      target="_blank" rel="noreferrer"
                                    >
                                      <img src="assets/img/pdf.png" alt="" />
                                    </a>
                                  </li>
                                  <li>
                                    <a
                                      href="https://iwebapps.noidapower.com:8032/download/NIT/GTP/GTP.zip"
                                      target="_blank" rel="noreferrer"
                                    >
                                      <img src="assets/img/pdf.png" alt="" />
                                    </a>
                                  </li>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow220(!show220)}
                        >
                          <b>NIT No. NPCL/IT/FY25-26/dHCI/038  for â€œSUPPLY, INSTALLATION, TESTING & COMMISSIONING OF DHCI SERVERSâ€</b>
                        </div>
                        {show220 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No.</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>NIT No. NPCL/IT/FY25-26/dHCI/038  for â€œSUPPLY, INSTALLATION, TESTING & COMMISSIONING OF DHCI SERVERSâ€</td>
                                <td>NIT No. NPCL/IT/FY25-26/dHCI/038 </td>
                                <td>

                                  <li>
                                    <a
                                      href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLITFY25-26dHCI038/NIT_document_dHCI_servers.pdf"
                                      target="_blank" rel="noreferrer"
                                    >
                                      <img src="assets/img/pdf.png" alt="" />
                                    </a>
                                  </li>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>
                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow219(!show219)}
                        >
                          <b>NIT No. NPCL/FY25-26/IT-CCS/029  for â€œSUPPLY OF CISCO MAKE NETWORK DEVICES FOR CORE SWITCH REFRESH AND NETWORK SEGMENTATION BY UPGRADE FROM LAYER-2 TO LAYER-3â€</b>
                        </div>
                        {show219 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No.</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>NIT No. NPCL/FY25-26/IT-CCS/029  for â€œSUPPLY OF CISCO MAKE NETWORK DEVICES FOR CORE SWITCH REFRESH AND NETWORK SEGMENTATION BY UPGRADE FROM LAYER-2 TO LAYER-3â€</td>
                                <td>NIT No. NPCL/FY25-26/IT-CCS/029 </td>
                                <td>

                                  <li>
                                    <a
                                      href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLITFY25-26CCS029/Corrigendum1.pdf"
                                      target="_blank" rel="noreferrer"
                                    >
                                      <img src="assets/img/pdf.png" alt="" />
                                    </a>
                                  </li>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>
                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow218(!show218)}
                        >
                          <b>NIT No. NPCL/FY25-26/RWH/36</b>
                        </div>
                        {show218 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No.</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>NIT No. NPCL/FY25-26/RWH/36</td>
                                <td>NIT No. NPCL/FY25-26/RWH/36</td>
                                <td>

                                  <li>
                                    <a
                                      href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26RWH36/Tender_Document_RWH_Final.pdf"
                                      target="_blank" rel="noreferrer"
                                    >
                                      <img src="assets/img/pdf.png" alt="" />
                                    </a>
                                  </li>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>
                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow217(!show217)}
                        >
                          <b>NIT No. NPCL/FY25-26/Boundary Wall/32</b>
                        </div>
                        {show217 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No.</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>NIT No. NPCL/FY25-26/Boundary Wall/32</td>
                                <td>NIT No. NPCL/FY25-26/Boundary Wall/32</td>
                                <td>

                                  <li>
                                    <a
                                      href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26Boundary Wall32/Updated_BOQ_Boundary_wall.pdf"
                                      target="_blank" rel="noreferrer"
                                    >
                                      <img src="assets/img/pdf.png" alt="" />
                                    </a>
                                  </li>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>
                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow216(!show216)}
                        >
                          <b>NIT No. NPCL/FY25-26/RMU Workshop/31</b>
                        </div>
                        {show216 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No.</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>NIT No. NPCL/FY25-26/RMU Workshop/31</td>
                                <td>NIT No. NPCL/FY25-26/RMU Workshop/31</td>
                                <td>

                                  <li>
                                    <a
                                      href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26RMU Workshop31/Corrigendum-01 (1).pdf"
                                      target="_blank" rel="noreferrer"
                                    >
                                      <img src="assets/img/pdf.png" alt="" />
                                    </a>
                                  </li>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow215(!show215)}
                        >
                          <b>â€œCorrignedum-06 against Tender No: NPCL/FY25-26/AMI/18 in our NPLC websiteâ€</b>
                        </div>
                        {show215 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No.</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>NIT No. NPCL/FY25-26/AMI/18 for â€œCorrignedum-06 against Tender No: NPCL/FY25-26/AMI/18 in our NPLC websiteâ€</td>
                                <td>NIT No. NPCL/FY25-26/AMI/18</td>
                                <td>

                                  <li>
                                    <a
                                      href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26AMI18/CORRIGENDUM-6-_AMI_Dated_17.09.2025.pdf"
                                      target="_blank" rel="noreferrer"
                                    >
                                      <img src="assets/img/pdf.png" alt="" />
                                    </a>
                                  </li>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>
                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow213(!show213)}
                        >
                          <b>NIT No. NPCL/FY25-26/33kV AIS/28 for â€œSupply of 33kV ID AIS Panel Board â€</b>
                        </div>
                        {show213 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No.</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>NIT No. NPCL/FY25-26/33kV AIS/28 for â€œSupply of 33kV ID AIS Panel Board â€</td>
                                <td>NIT No. NPCL/FY25-26/33kV AIS/28</td>
                                <td>

                                  <li>
                                    <a
                                      href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-2633kVAIS28/Final_33kV_AIS_3_Panel_Board__Website.pdf"
                                      target="_blank" rel="noreferrer"
                                    >
                                      <img src="assets/img/pdf.png" alt="" />
                                    </a>
                                  </li>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>
                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow212(!show212)}
                        >
                          <b>NIT No. NPCL/FY25-26/Boundary Wall/32 for â€œCivil Works of Boundary Wall of Pocket Sub-stations at Residential Sector, Greater Noida.â€</b>
                        </div>
                        {show212 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No.</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>NIT No. NPCL/FY25-26/Boundary Wall/32 for â€œCivil Works of Boundary Wall of Pocket Sub-stations at Residential Sector, Greater Noida.â€</td>
                                <td>NIT No. NPCL/FY25-26/Boundary Wall/32</td>
                                <td>

                                  <li>
                                    <a
                                      href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26Boundary Wall32/Tender Document Pkt Boundary wall Final website.pdf"
                                      target="_blank" rel="noreferrer"
                                    >
                                      <img src="assets/img/pdf.png" alt="" />
                                    </a>
                                  </li>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>
                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow211(!show211)}
                        >
                          <b>NIT No. NPCL/FY25-26/RMU Workshop/31 for â€œConstruction of RMU Workshop at NPCL Greater Noida.â€</b>
                        </div>
                        {show211 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No.</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>NIT No. NPCL/FY25-26/RMU Workshop/31 for â€œConstruction of RMU Workshop at NPCL Greater Noida.â€</td>
                                <td>NIT No. NPCL/FY25-26/RMU Workshop/31</td>
                                <td>

                                  <li>
                                    <a
                                      href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26RMU Workshop31/Final Tender Document_RMU Workshop.pdf"
                                      target="_blank" rel="noreferrer"
                                    >
                                      <img src="assets/img/pdf.png" alt="" />
                                    </a>
                                  </li>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>
                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow210(!show210)}
                        >
                          <b>NIT No. NPCL/FY25-26/Metering Lab/30 for â€œConstruction of HT & LT Metering Lab Zeta-1 Greater Noida.â€</b>
                        </div>
                        {show210 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No.</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>NIT No. NPCL/FY25-26/Metering Lab/30 for â€œConstruction of HT & LT Metering Lab Zeta-1 Greater Noida.â€</td>
                                <td>NIT No. NPCL/FY25-26/Metering Lab/30</td>
                                <td>

                                  <li>
                                    <a
                                      href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26Metering Lab30/Final Tender Doc Metering Lab Website.pdf"
                                      target="_blank" rel="noreferrer"
                                    >
                                      <img src="assets/img/pdf.png" alt="" />
                                    </a>
                                  </li>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow209(!show209)}
                        >
                          <b>CORRIGENDUM-5 Dated 25.08.2025 against NIT No. NPCL/FY25-26/AMI/18 Dated 25.08.2025 and AMI Pre-Bid Clarification</b>
                        </div>
                        {show209 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 25-08-2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>NIT No. NPCL/FY25-26/AMI/18</td>
                                <td>NIT No. NPCL/FY25-26/AMI/18</td>
                              </tr>
                            </table>
                            <ul className="tariff_standard">
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26AMI18/CORRIGENDUM-5- AMI Bid Extension.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                </a>
                              </li>
                            </ul>
                          </div>
                        ) : null}
                      </div>
                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow208(!show208)}
                        >
                          <b>NIT No. NPCL/FY25-26/Vehicle/34 for â€œHiring of Vehicles on Rental Basis.â€</b>
                        </div>
                        {show208 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No.</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>NIT No. NPCL/FY25-26/Vehicle/34 for â€œHiring of Vehicles on Rental Basis.â€</td>
                                <td>NIT No. NPCL/FY25-26/Vehicle/34</td>
                                <td>

                                  <li>
                                    <a
                                      href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26Vehicle34/Bid Document for Hiring of Vehicles 04.09.2025.pdf"
                                      target="_blank" rel="noreferrer"
                                    >
                                      <img src="assets/img/pdf.png" alt="" />
                                    </a>
                                  </li>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>
                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow207(!show207)}
                        >
                          <b>NIT No. NPCL/IT/FY25-26/CCS/029 for â€œSupply of CISCO make Network Devices for core switch refresh and Network segmentation by upgrade from layer-2 to layer-3â€</b>
                        </div>
                        {show207 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No.</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>NIT No. NPCL/IT/FY25-26/CCS/029 for â€œSupply of CISCO make Network Devices for core switch refresh and Network segmentation by upgrade from layer-2 to layer-3â€</td>
                                <td>NIT No. NPCL/IT/FY25-26/CCS/029</td>
                                <td>

                                  <li>
                                    <a
                                      href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLITFY25-26CCS029/Bid_Document_CISCO_Core_Switch.pdf"
                                      target="_blank" rel="noreferrer"
                                    >
                                      <img src="assets/img/pdf.png" alt="" />
                                    </a>
                                  </li>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>
                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow206(!show206)}
                        >
                          <b>CORRIGENDUM-3 Dated 28.08.2025 against NIT No. NPCL/FY25-26/RTU/024 Dated 24.07.2025 for â€œSUPPLY INSTALLATION TESTING & COMMISSIONING OF RTU SYSTEM AT NEW SUBSTATIONâ€</b>
                        </div>
                        {show206 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 28-08-2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>NIT No. NPCL/FY25-26/RTU/024 for â€œSUPPLY INSTALLATION TESTING & COMMISSIONING OF RTU SYSTEM AT NEW SUBSTATIONâ€</td>
                                <td>NIT No. NPCL/FY25-26/RTU/024</td>
                                <td>

                                  <li>
                                    <a
                                      href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26RTU024/Corriegendum-3_dated_28.08.2025_Extension_of_Bid_Submission_Date.pdf"
                                      target="_blank" rel="noreferrer"
                                    >
                                      <img src="assets/img/pdf.png" alt="" />
                                    </a>
                                  </li>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>
                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow205(!show205)}
                        >
                          <b>Corrigendum-2 against NIT No. NPCL/FY25-26/ DRDR Meter/020 -Dated 30.08.2025 â€œAnnual Rate Contract for the Supply of DRDR metersâ€</b>
                        </div>
                        {show205 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 27-08-2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>NIT No. NPCL/FY25-26/ DRDR Meter/020 for â€œAnnual Rate Contract for the Supply of DRDR metersâ€</td>
                                <td>NIT No. NPCL/FY25-26/ DRDR Meter/020</td>
                                <td>

                                  <li>
                                    <a
                                      href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26 DRDR Meter020/CORRIGENDUM-2_Dated_27.08.2025.pdf"
                                      target="_blank" rel="noreferrer"
                                    >
                                      <img src="assets/img/pdf.png" alt="" />
                                    </a>
                                  </li>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>
                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow204(!show204)}
                        >
                          <b>CORRIGENDUM-1 Dated 26.08.2025 Against  TENDER NOTIFICATION :- NPCL/FY25-26/LT CFL/026 Dated 05.08.2025 â€œSUPPLY OF VAN MOUNTED LT CABLE FAULT LOCATORâ€</b>
                        </div>
                        {show204 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 26-08-2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>NIT No. NPCL/FY25-26/LT CFL/026 for â€œSUPPLY OF VAN MOUNTED LT CABLE FAULT LOCATORâ€</td>
                                <td>NIT No. NPCL/FY25-26/LT CFL/026</td>
                                <td>

                                  <li>
                                    <a
                                      href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26LTCFL026/Corriegendum-1_dated_26.08.2025_Extension_of_Bid_Submission_Date (1).pdf"
                                      target="_blank" rel="noreferrer"
                                    >
                                      <img src="assets/img/pdf.png" alt="" />
                                    </a>
                                  </li>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>
                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow203(!show203)}
                        >
                          <b>CORRIGENDUM-4 Dated 25.08.2025 against NIT No. NPCL/FY25-26/AMI/18 Dated 25.08.2025 and AMI Pre-Bid Clarification</b>
                        </div>
                        {show203 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 25-08-2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>NIT No. NPCL/FY25-26/AMI/18</td>
                                <td>NIT No. NPCL/FY25-26/AMI/18</td>
                              </tr>
                            </table>
                            <ul className="tariff_standard">
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26AMI18/CORRIGENDUM-4-_AMI_Dated_25.08.2025.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                </a>
                              </li>
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26AMI18/Undertaking_for_conflict_of_Interest.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                </a>
                              </li>
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26AMI18/Addendum.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                </a>
                              </li>
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26AMI18/Copy_of_Prebid_reply_-AMI_250825.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                </a>
                              </li>
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26AMI18/Financial_Bid_Formats_Updated_250825.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                </a>
                              </li>

                            </ul>
                          </div>
                        ) : null}
                      </div>
                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow202(!show202)}
                        >
                          <b>CORRIGENDUM-2 Dated 21.08.2025 against NIT No. NPCL/FY25-26/RTU/024 Dated 24.07.2025 for â€œSUPPLY INSTALLATION TESTING & COMMISSIONING OF RTU SYSTEM AT NEW SUBSTATIONâ€</b>
                        </div>
                        {show202 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 21-08-2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>NIT No. NPCL/FY25-26/RTU/024 for â€œSUPPLY INSTALLATION TESTING & COMMISSIONING OF RTU SYSTEM AT NEW SUBSTATIONâ€</td>
                                <td>NIT No. NPCL/FY25-26/RTU/024</td>
                                <td>

                                  <li>
                                    <a
                                      href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26RTU024/Corriegendum-2_dated_21.08.2025_Extension_of_Bid_Submission_Date.pdf"
                                      target="_blank" rel="noreferrer"
                                    >
                                      <img src="assets/img/pdf.png" alt="" />
                                    </a>
                                  </li>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>
                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow201(!show201)}
                        >
                          <b>Corrigendum-4 against NIT No. NPCL/FY25-26/PCC POLE /019 -Dated 15.07.2025 for â€œAnnual Rate Contract for the Supply of 9 Mtr. PCC Pole & 11 Mtr. PCC Poleâ€</b>
                        </div>
                        {show201 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 21-08-2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>NIT No. NPCL/FY25-26/PCC POLE /019 for â€œAnnual Rate Contract for the Supply of 9 Mtr. PCC Pole & 11 Mtr. PCC Poleâ€</td>
                                <td>NIT No. NPCL/FY25-26/PCC POLE /019</td>
                                <td>

                                  <li>
                                    <a
                                      href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26PCC_POLE_019/corrigendum-4_dated_21.08.2025.pdf"
                                      target="_blank" rel="noreferrer"
                                    >
                                      <img src="assets/img/pdf.png" alt="" />
                                    </a>
                                  </li>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>
                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow200(!show200)}
                        >
                          <b>CORRIGENDUM-7 Dated 20.08.2025 against NIT No. NPCL/FY25-26/FPI/010 Dated â€“18.06.2025 for â€œARC FOR SUPPLY INSTALLATION TESTING & COMMISSIONING OF NON COMMUNICABLE FAULT PASSAGE INDICATOR (FPI) UPTO 33KV NETWORK SYSTEMâ€</b>
                        </div>
                        {show200 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 20-08-2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>NIT No. NPCL/FY25-26/FPI/010 for â€œARC FOR SUPPLY INSTALLATION TESTING & COMMISSIONING OF NON COMMUNICABLE FAULT PASSAGE INDICATOR (FPI) UPTO 33KV NETWORK SYSTEMâ€</td>
                                <td>NIT No. NPCL/FY25-26/FPI/010</td>
                                <td>

                                  <li>
                                    <a
                                      href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26FPI010/Corriegendum-7_dated_20_08.2025_Extension_of_Bid_Submission_Date.pdf"
                                      target="_blank" rel="noreferrer"
                                    >
                                      <img src="assets/img/pdf.png" alt="" />
                                    </a>
                                  </li>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>
                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow199(!show199)}
                        >
                          <b>SUBMISSION OF PREBID REPLY DATED 19.08.2025 AGAINST TENDER NOTIFICATION :- NPCL/FY25-26/LT CFL/026 Dated 05.08.2025 "SUPPLY OF VAN MOUNTED LT CABLE FAULT LOCATOR"</b>
                        </div>
                        {show199 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 19-08-2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>NIT No. NPCL/FY25-26/LT CFL/026 for â€œSUPPLY OF VAN MOUNTED LT CABLE FAULT LOCATORâ€</td>
                                <td>NIT No. NPCL/FY25-26/LT CFL/026</td>
                                <td>

                                  <li>
                                    <a
                                      href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26LTCFL026/Submission_of_Prebid_Query_LT_Cable_Fault_Van.pdf"
                                      target="_blank" rel="noreferrer"
                                    >
                                      <img src="assets/img/pdf.png" alt="" />
                                    </a>
                                  </li>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>
                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow198(!show198)}
                        >
                          <b>Corrigendum-1 against NIT No. NPCL/FY25-26/ DRDR Meter/020 -Dated 30.07.2025 for â€œAnnual Rate Contract for the Supply of DRDR metersâ€</b>
                        </div>
                        {show198 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 20-08-2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>Corrigendum-1___NPCL/FY25-26/ DRDR Meter/020 for â€œAnnual Rate Contract for the Supply of DRDR metersâ€</td>
                                <td>Corrigendum-1___NPCL/FY25-26/ DRDR Meter/020</td>
                                <td>

                                  <li>
                                    <a
                                      href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26 DRDR Meter020/CORRIGENDUM-1_Dated_20.08.2025.pdf"
                                      target="_blank" rel="noreferrer"
                                    >
                                      <img src="assets/img/pdf.png" alt="" />
                                    </a>
                                  </li>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>
                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow197(!show197)}
                        >
                          <b>CORRIGENDUM-1 Dated 14.08.2025 against NIT No. NPCL/FY25-26/RTU/024 Dated 24.07.2025 for â€œSUPPLY INSTALLATION TESTING & COMMISSIONING OF RTU SYSTEM AT NEW SUBSTATIONâ€</b>
                        </div>
                        {show197 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 14-08-2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>NIT No.  NPCL/FY25-26/RTU/024 for â€œSUPPLY INSTALLATION TESTING & COMMISSIONING OF RTU SYSTEM AT NEW SUBSTATION.â€</td>
                                <td> NIT No.  NPCL/FY25-26/RTU/024</td>
                                <td>

                                  <li>
                                    <a
                                      href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26RTU024/Corriegendum-1_dated_14.08.2025_Extension_of_Bid_Submission_Date.pdf"
                                      target="_blank" rel="noreferrer"
                                    >
                                      <img src="assets/img/pdf.png" alt="" />
                                    </a>
                                  </li>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>
                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow196(!show196)}
                        >
                          <b>Corrigendum-3 against NIT No. NPCL/FY25-26/PCC POLE /019 -Dated 15.07.2025 for â€œAnnual Rate Contract for the Supply of 9 Mtr. PCC Pole & 11 Mtr. PCC Pole.â€</b>
                        </div>
                        {show196 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 14-08-2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>NIT No.  NPCL/FY25-26/PCC POLE /019 for â€œAnnual Rate Contract for the Supply of 9 Mtr. PCC Pole & 11 Mtr. PCC Pole.â€</td>
                                <td> NIT No.  NPCL/FY25-26/PCC POLE /019</td>
                                <td>

                                  <li>
                                    <a
                                      href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26PCC_POLE_019/CORRIGENDUM-3_DAted_14.08.2025.pdf"
                                      target="_blank" rel="noreferrer"
                                    >
                                      <img src="assets/img/pdf.png" alt="" />
                                    </a>
                                  </li>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow195(!show195)}
                        >
                          <b>NIT No. NPCL/FY25-26/OT/On-Site Kitchen Services/027 for â€œRate Contract for On-site Kitchen Servicesâ€</b>
                        </div>
                        {show195 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No.</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>NIT No.  NPCL/FY25-26/OT/On-Site Kitchen Services/027  for â€œRate Contract for On-site Kitchen Servicesâ€</td>
                                <td> NIT No.  NPCL/FY25-26/OT/On-Site Kitchen Services/027</td>
                                <td>

                                  <li>
                                    <a
                                      href="https://iwebapps.noidapower.com:8032/download/NIT/NPNPCLFY25-26OTOn-Site Kitchen Services027/Tender_Document_Kitchen_Final.pdf"
                                      target="_blank" rel="noreferrer"
                                    >
                                      <img src="assets/img/pdf.png" alt="" />
                                    </a>
                                  </li>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>
                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow193(!show193)}
                        >
                          <b>CORRIGENDUM-6 Dated 13.08.2025 against NIT No. NPCL/FY25-26/FPI/010 Dated â€“18.06.2025 for â€œARC FOR SUPPLY INSTALLATION TESTING & COMMISSIONING OF NON COMMUNICABLE FAULT PASSAGE INDICATOR (FPI) UPTO 33KV NETWORK SYSTEMâ€</b>
                        </div>
                        {show193 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 13-08-2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>CORRIGENDUM-6 Dated 13.08.2025 against NIT No. NPCL/FY25-26/FPI/010 Dated â€“18.06.2025 for â€œARC FOR SUPPLY INSTALLATION TESTING & COMMISSIONING OF NON COMMUNICABLE FAULT PASSAGE INDICATOR (FPI) UPTO 33KV NETWORK SYSTEMâ€</td>
                                <td> NIT No. NPCL/FY25-26/FPI/010</td>
                                <td>

                                  <li>
                                    <a
                                      href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26FPI010/Corriegendum-6_dated_13_08.2025_Extension_of_Bid_Submission_Date.pdf"
                                      target="_blank" rel="noreferrer"
                                    >
                                      <img src="assets/img/pdf.png" alt="" />
                                    </a>
                                  </li>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>
                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow194(!show194)}
                        >
                          <b>Prebid Query Dated 30-07-2025 NIT No. NPCL/FY25-26/ DRDR Meter/020 -Dated 30.07.2025 for â€œAnnual Rate Contract for the Supply of DRDR metersâ€</b>
                        </div>
                        {show194 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 30-07-2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>NIT No. NPCL/FY25-26/ DRDR Meter/020 -Dated 30.07.2025 for â€œAnnual Rate Contract for the Supply of DRDR metersâ€</td>
                                <td> NIT No. NPCL/FY25-26/ DRDR Meter/020</td>
                                <td>

                                  <li>
                                    <a
                                      href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26 DRDR Meter020/Pre-Bid_Queries_DRDR_Meter.pdf"
                                      target="_blank" rel="noreferrer"
                                    >
                                      <img src="assets/img/pdf.png" alt="" />
                                    </a>
                                  </li>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>
                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow190(!show190)}
                        >
                          <b>Corrigendum-5 against NIT No. NPCL/FY25-26/FPI/010 Dated â€“18.06.2025 for â€œARC FOR SUPPLY INSTALLATION TESTING & COMMISSIONING OF NON COMMUNICABLE FAULT PASSAGE INDICATOR (FPI) UPTO 33KV NETWORK SYSTEM.â€</b>
                        </div>
                        {show190 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 09-08-2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>Corrigendum-5 against Dated 13.08.2025 against NIT No. NPCL/FY25-26/FPI/010 Dated â€“18.06.2025 for â€œARC FOR SUPPLY INSTALLATION TESTING & COMMISSIONING OF NON COMMUNICABLE FAULT PASSAGE INDICATOR (FPI) UPTO 33KV NETWORK SYSTEM.â€</td>
                                <td> NIT No. NPCL/FY25-26/FPI/010 </td>
                                <td>

                                  <li>
                                    <a
                                      href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26FPI010/Corriegendum-5_dated_06_08.2025_Extension_of_Bid_Submission_Date.pdf"
                                      target="_blank" rel="noreferrer"
                                    >
                                      <img src="assets/img/pdf.png" alt="" />
                                    </a>
                                  </li>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>
                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow189(!show189)}
                        >
                          <b>NIT No. NPCL/FY25-26/LT CFL/026 for â€œSUPPLY OF VAN MOUNTED LT CABLE FAULT LOCATORâ€</b>
                        </div>
                        {show189 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 05-08-2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>SUPPLY OF VAN MOUNTED LT CABLE FAULT LOCATOR</td>
                                <td>NIT No. NPCL/FY25-26/LT CFL/026</td>
                              </tr>
                            </table>
                            <ul className="tariff_standard">
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26LTCFL026/Bid_Document_Supply_of_LT_Cable_Fault_Van.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                </a>
                              </li>
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26LTCFL026/Technical Specification For 1.1 KV Cable Fault Locator_controlled copy.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                </a>
                              </li>
                            </ul>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow188(!show188)}
                        >
                          <b>NPCL/FY25-26/ DRDR Meter/020 for â€œAnnual Rate Contract for the Supply of DRDR meters.â€</b>
                        </div>
                        {show188 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 31-07-2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>TENDER NOTIFICATION FOR â€œAnnual Rate Contract for the Supply of DRDR meters.â€</td>
                                <td> NPCL/FY25-26/ DRDR Meter/020 </td>
                              </tr>
                            </table>
                            <ul className="tariff_standard">
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26 DRDR Meter020/Bid Document DRDR Meter.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                </a>
                              </li>
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26 DRDR Meter020/Specifications DRDR Meters - Signed.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                </a>
                              </li>
                            </ul>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow187(!show187)}
                        >
                          <b>CORRIGENDUM-1 against NIT No. NPCL/FY25-26/PCC POLE /019 for â€œAnnual Rate Contract for the Supply of 9 Mtr. PCC Pole & 11 Mtr. PCC Pole.â€</b>
                        </div>
                        {show187 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 15-07-2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>CORRIGENDUM-1 against TENDER NOTIFICATION FOR â€œAnnual Rate Contract for the Supply of 9 Mtr. PCC Pole & 11 Mtr. PCC Pole.â€</td>
                                <td> NIT No. NPCL/FY25-26/PCC POLE /019 </td>
                              </tr>
                            </table>
                            <ul className="tariff_standard">
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26PCC_POLE_019/CORRIGENDUM-1 Dated 31.07.2025.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                </a>
                              </li>
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26PCC_POLE_019/CORRIGENDUM-2_Dated_07.08.2025.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                </a>
                              </li>
                            </ul>
                          </div>
                        ) : null}
                      </div>
                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow192(!show192)}
                        >
                          <b>CORRIGENDUM-5 against NIT No. NPCL/FY25-26/FPI/010 for â€œARC FOR SUPPLY INSTALLATION TESTING & COMMISSIONING OF NON COMMUNICABLE FAULT PASSAGE INDICATOR (FPI) UPTO 33KV NETWORK SYSTEM.â€</b>
                        </div>
                        {show192 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 18-06-2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>CORRIGENDUM-5 against TENDER NOTIFICATION FOR â€œARC FOR SUPPLY INSTALLATION TESTING & COMMISSIONING OF NON COMMUNICABLE FAULT PASSAGE INDICATOR (FPI) UPTO 33KV NETWORK SYSTEM.â€</td>
                                <td> NIT No. NPCL/FY25-26/FPI/010 </td>
                              </tr>
                            </table>
                            <ul className="tariff_standard">
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26FPI010/Corriegendum-5_dated_06_08.2025_Extension_of_Bid_Submission_Date.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                </a>
                              </li>

                            </ul>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow186(!show186)}
                        >
                          <b>CORRIGENDUM-4 against NIT No. NPCL/FY25-26/FPI/010 for â€œARC FOR SUPPLY INSTALLATION TESTING & COMMISSIONING OF NON COMMUNICABLE FAULT PASSAGE INDICATOR (FPI) UPTO 33KV NETWORK SYSTEM.â€</b>
                        </div>
                        {show186 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 18-06-2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>CORRIGENDUM-4 against TENDER NOTIFICATION FOR â€œARC FOR SUPPLY INSTALLATION TESTING & COMMISSIONING OF NON COMMUNICABLE FAULT PASSAGE INDICATOR (FPI) UPTO 33KV NETWORK SYSTEM.â€</td>
                                <td> NIT No. NPCL/FY25-26/FPI/010 </td>
                              </tr>
                            </table>
                            <ul className="tariff_standard">
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26FPI010/Corriegendum-4 dated 30,07.2025 Extension of Bid Submission Date.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                </a>
                              </li>

                            </ul>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow185(!show185)}
                        >
                          <b>NIT No. NPCL/FY25-26/FEEDER PILLAR/017 for â€œANNUAL RATE CONTRACT OF SUPPLY OF FEEDER PILLAR.â€</b>
                        </div>
                        {show185 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 30-07-2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>TENDER NOTIFICATION FOR â€œANNUAL RATE CONTRACT OF SUPPLY OF FEEDER PILLAR.â€</td>
                                <td> NIT No. NPCL/FY25-26/FEEDER PILLAR/017 </td>
                              </tr>
                            </table>
                            <ul className="tariff_standard">
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26FEEDER PILLAR017/Bid Document Supply of Feeder Pillar.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                </a>
                              </li>
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26FEEDER PILLAR017/TS_MS 8 Way MFP with FSD _R01_Controlled Copy.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                </a>
                              </li>
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26FEEDER PILLAR017/TS_MS 12 Way SFP _R01_Controlled Copy.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                </a>
                              </li>
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26FEEDER PILLAR017/TS_SMC 12 Way SFP _R01_Controlled Copy.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                </a>
                              </li>
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26FEEDER PILLAR017/Drawing -MFP with FSD_Controlled Copy.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                </a>
                              </li>
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26FEEDER PILLAR017/Submission_of_Prebid_Query_feeder_Pillar (2).pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                </a>
                              </li>
                            </ul>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow184(!show184)}
                        >
                          <b>Corrigendum-2 against NIT No. NPCL/FY25-26/Civil R&M/23 Civil R&M for â€œTWO YEAR RATE CONTRACT FOR CIVIL REPAIR & MAINTENACE WORK OF SUB-STATIONS & OFFICE BUILDINGS at VARIOUS LOCATIONS of NPCL.â€</b>
                        </div>
                        {show184 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 28-06-2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>Corrigendum-2 against TENDER NOTIFICATION FOR â€œTWO YEAR RATE CONTRACT FOR CIVIL REPAIR & MAINTENACE WORK OF SUB-STATIONS & OFFICE BUILDINGS at VARIOUS LOCATIONS of NPCL.â€</td>
                                <td> NIT No. NPCL/FY25-26/Civil R&M/23 Civil R&M </td>
                              </tr>
                            </table>
                            <ul className="tariff_standard">
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26Civil_M23/CORRIGENDUM-2 Civil R&M.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                </a>
                              </li>
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26Civil_M23/CORRIGENDUM-3_Civil_R_M.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                </a>
                              </li>
                            </ul>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow183(!show183)}
                        >
                          <b>NIT No. NPCL/FY25-26/RTU/024 for â€œSUPPLY INSTALLATION TESTING & COMMISSIONING OF RTU SYSTEM AT NEW SUBSTATION.â€</b>
                        </div>
                        {show183 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 24-07-2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>TENDER NOTIFICATION FOR â€œSUPPLY INSTALLATION TESTING & COMMISSIONING OF RTU SYSTEM AT NEW SUBSTATION.â€</td>
                                <td> NIT No. NPCL/FY25-26/RTU/024 </td>
                              </tr>
                            </table>
                            <ul className="tariff_standard">
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26RTU024/Bid Document SITC RTU System.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                </a>
                              </li>
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26RTU024/RTU TECH SPECS FY_2025-26-_New Substations.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                </a>
                              </li>
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26RTU024/Submission_of_Prebid_Query.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                </a>
                              </li>
                            </ul>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow182(!show182)}
                        >
                          <b>CORRIGENDUM-3 against NIT No. NPCL/FY25-26/FPI/010 for â€œARC FOR SUPPLY INSTALLATION TESTING & COMMISSIONING OF NON COMMUNICABLE FAULT PASSAGE INDICATOR (FPI) UPTO 33KV NETWORK SYSTEM.â€</b>
                        </div>
                        {show182 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 18-06-2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>CORRIGENDUM-3 against TENDER NOTIFICATION FOR â€œARC FOR SUPPLY INSTALLATION TESTING & COMMISSIONING OF NON COMMUNICABLE FAULT PASSAGE INDICATOR (FPI) UPTO 33KV NETWORK SYSTEM.â€</td>
                                <td> NIT No. NPCL/FY25-26/FPI/010 </td>
                              </tr>
                            </table>
                            <ul className="tariff_standard">
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26FPI010/Corriegendum-3 dated 23,07.2025 Extension of Bid Submission Date.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                </a>
                              </li>
                            </ul>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow181(!show181)}
                        >
                          <b>Corrigendum-1 against NIT No. NPCL/FY25-26/Civil R&M/23 Civil R&M for â€œTWO YEAR RATE CONTRACT FOR CIVIL REPAIR & MAINTENACE WORK OF SUB-STATIONS & OFFICE BUILDINGS at VARIOUS LOCATIONS of NPCL.â€</b>
                        </div>
                        {show181 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 28-06-2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>Corrigendum-1 against TENDER NOTIFICATION FOR â€œTWO YEAR RATE CONTRACT FOR CIVIL REPAIR & MAINTENACE WORK OF SUB-STATIONS & OFFICE BUILDINGS at VARIOUS LOCATIONS of NPCL.â€</td>
                                <td> NIT No. NPCL/FY25-26/Civil R&M/23 Civil R&M </td>
                              </tr>
                            </table>
                            <ul className="tariff_standard">
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26Civil_M23/CORRIGENDUM-1 Civil R&M.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                </a>
                              </li>
                            </ul>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow180(!show180)}
                        >
                          <b>Corrigendum-2 against NIT No. NPCL/FY25-26/AMI/18 for â€œADVANCED METERING INFRASTRUCTURE (AMI) DEPLOYMENT IN NOIDA POWER COMPANY LTD.â€</b>
                        </div>
                        {show180 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 28-06-2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>Corrigendum-2 against TENDER NOTIFICATION FOR â€œADVANCED METERING INFRASTRUCTURE (AMI) DEPLOYMENT IN NOIDA POWER COMPANY LTD.â€</td>
                                <td> NIT No. NPCL/FY25-26/AMI/18 </td>
                              </tr>
                            </table>
                            <ul className="tariff_standard">
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26AMI18/CORRIGENDUM-2-Bid Extension.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                </a>
                              </li>
                            </ul>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow179(!show179)}
                        >
                          <b>NIT No. NPCL/FY25-26/FENCING/015 for â€œSupply and Erection of M S Fencing Around Electrical Structure and Other M S Repair Work.â€</b>
                        </div>
                        {show179 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 16-07-2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>TENDER NOTIFICATION FOR â€œSupply and Erection of M S Fencing Around Electrical Structure and Other M S Repair Work.â€</td>
                                <td> NIT No. NPCL/FY25-26/FENCING/015 </td>
                              </tr>
                            </table>
                            <ul className="tariff_standard">
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26FENCING015/Bid Document for Supply of Fencing and Erection.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                </a>
                              </li>
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26FENCING015/M.S. Fencing Details_Controlled Copy.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                </a>
                              </li>
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26FENCING015/Pre_Bid_Clarification_NPCL_25-26_Fencing_15.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                </a>
                              </li>
                            </ul>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow178(!show178)}
                        >
                          <b>NIT No. NPCL/FY25-26/HDD/022 for â€œHDD (Horizontal Directional Drilling) Services For Electrical And Optical Fiber Cables (OFC) and Allied Work.â€</b>
                        </div>
                        {show178 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 16-07-2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>TENDER NOTIFICATION FOR â€œHDD (Horizontal Directional Drilling) Services For Electrical And Optical Fiber Cables (OFC) and Allied Work.â€</td>
                                <td> NIT No. NPCL/FY25-26/HDD/022 </td>
                              </tr>
                            </table>
                            <ul className="tariff_standard">
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26HDD022/Bid Document for HDD.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                </a>
                              </li>
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26HDD022/Pre_Bid_Clarification_NPCL_25-26_HDD_22.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                </a>
                              </li>
                            </ul>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow177(!show177)}
                        >
                          <b>CORRIGENDUM-2 against NIT No. NPCL/FY25-26/DT/016 for â€œ2 YRS  RATE CONTRACT FOR SUPPLY OF DISTRIBUTION TRANSFORMERS.â€</b>
                        </div>
                        {show177 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 18-06-2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>CORRIGENDUM-2 against TENDER NOTIFICATION FOR â€œ2 YRS  RATE CONTRACT FOR SUPPLY OF DISTRIBUTION TRANSFORMERS.â€</td>
                                <td> NIT No. NPCL/FY25-26/DT/016 </td>
                              </tr>
                            </table>
                            <ul className="tariff_standard">
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26DT016/Corriegendum-2 dated 16,07.2025 Extension of Bid Submission Date_016.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                </a>
                              </li>
                            </ul>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow176(!show176)}
                        >
                          <b>CORRIGENDUM-2 against NIT No. NPCL/FY25-26/FPI/010 for â€œARC FOR SUPPLY INSTALLATION TESTING & COMMISSIONING OF NON COMMUNICABLE FAULT PASSAGE INDICATOR (FPI) UPTO 33KV NETWORK SYSTEM.â€</b>
                        </div>
                        {show176 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 18-06-2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>CORRIGENDUM-2 against TENDER NOTIFICATION FOR â€œARC FOR SUPPLY INSTALLATION TESTING & COMMISSIONING OF NON COMMUNICABLE FAULT PASSAGE INDICATOR (FPI) UPTO 33KV NETWORK SYSTEM.â€</td>
                                <td> NIT No. NPCL/FY25-26/FPI/010 </td>
                              </tr>
                            </table>
                            <ul className="tariff_standard">
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26FPI010/Corriegendum-2 dated 16,07.2025 Extension of Bid Submission Date.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                </a>
                              </li>
                            </ul>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow175(!show175)}
                        >
                          <b>CORRIGENDUM-1 against NIT No. NPCL/FY25-26/12.5 & 16 MVA PTR/013 for â€œSITC of 12.5 MVA & 16 MVA PTR.â€</b>
                        </div>
                        {show175 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 24-06-2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>CORRIGENDUM-1 against TENDER NOTIFICATION FOR â€œSITC of 12.5 MVA & 16 MVA PTR.â€</td>
                                <td> NIT No. NPCL/FY25-26/12.5 & 16 MVA PTR/013 </td>
                              </tr>
                            </table>
                            <ul className="tariff_standard">
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-2612.5_16_MVA_PTR013/CORRIGENDUM-1 - PTR.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                </a>
                              </li>
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-2612.5_16_MVA_PTR013/PTR Pre-Bid Clarification.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                </a>
                              </li>
                            </ul>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow174(!show174)}
                        >
                          <b>NIT No. NPCL/FY25-26/PCC POLE /019 for â€œAnnual Rate Contract for the Supply of 9 Mtr. PCC Pole & 11 Mtr. PCC Pole.â€</b>
                        </div>
                        {show174 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 15-07-2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>TENDER NOTIFICATION FOR â€œAnnual Rate Contract for the Supply of 9 Mtr. PCC Pole & 11 Mtr. PCC Pole.â€</td>
                                <td> NIT No. NPCL/FY25-26/PCC POLE /019 </td>
                              </tr>
                            </table>
                            <ul className="tariff_standard">
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26PCC_POLE_019/Bid Document PCC Pole.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                </a>
                              </li>
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26PCC_POLE_019/GTP- 9 Mtr PCC Pole.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                </a>
                              </li>
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26PCC_POLE_019/GTP-11Mtr Long 400kGf PCC Pole_Controlled Copy.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                </a>
                              </li>
                            </ul>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow173(!show173)}
                        >
                          <b>CORRIGENDUM-1 against NIT No. NPCL/FY25-26/DT/016 for â€œ2 YRS  RATE CONTRACT FOR SUPPLY OF DISTRIBUTION TRANSFORMERS.â€</b>
                        </div>
                        {show173 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 18-06-2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>CORRIGENDUM-1 against TENDER NOTIFICATION FOR â€œ2 YRS  RATE CONTRACT FOR SUPPLY OF DISTRIBUTION TRANSFORMERS.â€</td>
                                <td> NIT No. NPCL/FY25-26/DT/016 </td>
                              </tr>
                            </table>
                            <ul className="tariff_standard">
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26DT016/Corriegendum-1 dated 08,07.2025 Extension of Bid Submission Date DTR.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                </a>
                              </li>
                            </ul>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow172(!show172)}
                        >
                          <b>CORRIGENDUM-1 against NIT No. NPCL/FY25-26/FPI/010 for â€œARC FOR SUPPLY INSTALLATION TESTING & COMMISSIONING OF NON COMMUNICABLE FAULT PASSAGE INDICATOR (FPI) UPTO 33KV NETWORK SYSTEM.â€</b>
                        </div>
                        {show172 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 18-06-2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>CORRIGENDUM-1 against TENDER NOTIFICATION FOR â€œARC FOR SUPPLY INSTALLATION TESTING & COMMISSIONING OF NON COMMUNICABLE FAULT PASSAGE INDICATOR (FPI) UPTO 33KV NETWORK SYSTEM.â€</td>
                                <td> NIT No. NPCL/FY25-26/FPI/010 </td>
                              </tr>
                            </table>
                            <ul className="tariff_standard">
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26FPI010/Corriegendum-1 dated 08,07.2025 Extension of Bid Submission Date (1).pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                </a>
                              </li>
                            </ul>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow171(!show171)}
                        >
                          <b>Corrigendum-1 against NIT No. NPCL/FY25-26/AMI/18 for â€œADVANCED METERING INFRASTRUCTURE (AMI) DEPLOYMENT IN NOIDA POWER COMPANY LTD.â€</b>
                        </div>
                        {show171 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 28-06-2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>Corrigendum-1 against TENDER NOTIFICATION FOR â€œADVANCED METERING INFRASTRUCTURE (AMI) DEPLOYMENT IN NOIDA POWER COMPANY LTD.â€</td>
                                <td> NIT No. NPCL/FY25-26/AMI/18 </td>
                              </tr>
                            </table>
                            <ul className="tariff_standard">
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26AMI18/CORRIGENDUM-1 AMI.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                </a>
                              </li>
                            </ul>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow170(!show170)}
                        >
                          <b>Corrigendum-2 against NIT No. NPCL/FY25-26/MS ITEMS (GALVANISED)/011 for â€œCorriegendum-2 dated 02,07.2025 Extension of Bid Submission Date.â€</b>
                        </div>
                        {show170 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 04-06-2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>Corrigendum-2 against TENDER NOTIFICATION FOR â€œCorriegendum-2 dated 02,07.2025 Extension of Bid Submission Date.â€</td>
                                <td> NIT No. NPCL/FY25-26/MS ITEMS(GALVANISED)/011 </td>
                              </tr>
                            </table>
                            <ul className="tariff_standard">
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26MSITEMS011/Corriegendum-2 dated 02,07.2025 Extension of Bid Submission Date.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                </a>
                              </li>
                            </ul>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow169(!show169)}
                        >
                          <b>NIT No. NPCL/IT/FY25-26/LDW/12 for â€œPURCHASE OF LAPTOPS, DESKTOPS & WORKSTATIONS.â€</b>
                        </div>
                        {show169 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 01-07-2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>TENDER NOTIFICATION FOR â€œPURCHASE OF LAPTOPS, DESKTOPS & WORKSTATIONS.â€</td>
                                <td> NIT No. NPCL/IT/FY25-26/LDW/12 </td>
                              </tr>
                            </table>
                            <ul className="tariff_standard">
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLITFY25-26LDW12/Tender Document for Laptop-Desktop.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                </a>
                              </li>
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLITFY25-26LDW12/Pre-bid query.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                </a>
                              </li>
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLITFY25-26LDW12/CORRIGENDUM1.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                </a>
                              </li>
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLITFY25-26LDW12/CORRIGENDUM2.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                </a>
                              </li>
                            </ul>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow168(!show168)}
                        >
                          <b>NIT No. NPCL/IT/FY25-26/VMW/021 for â€œSUBSCRIPTION OF VMWARE ENTERPRISE PLUS LICENSES.â€</b>
                        </div>
                        {show168 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 01-07-2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>TENDER NOTIFICATION FOR â€œSUBSCRIPTION OF VMWARE ENTERPRISE PLUS LICENSES.â€</td>
                                <td> NIT No. NPCL/IT/FY25-26/VMW/021 </td>
                              </tr>
                            </table>
                            <ul className="tariff_standard">
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLITFY25-26VMW021/Bid Document Vmware.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                </a>
                              </li>
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLITFY25-26VMW021/Corrigendum1.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                </a>
                              </li>
                            </ul>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow167(!show167)}
                        >
                          <b>Corrigendum-3 against NIT No. NPCL/FY25-26/IT-FMS/08 for â€œTENDER NOTIFICATION FOR IMPLEMENTATION OF FUND MANAGEMENT SYSTEM.â€</b>
                        </div>
                        {show167 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 29-04-2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>Corrigendum-3 against TENDER NOTIFICATION FOR â€œTENDER NOTIFICATION FOR IMPLEMENTATION OF FUND MANAGEMENT SYSTEM".</td>
                                <td>NIT No. NPCL/FY25-26/IT-FMS/08 </td>
                              </tr>
                            </table>
                            <ul className="tariff_standard">
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26IT-FMS08/Corrigendum3.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                </a>
                              </li>
                            </ul>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow166(!show166)}
                        >
                          <b>NIT No. NPCL/FY25-26/Civil R&M/23 Civil R&M for â€œTWO YEAR RATE CONTRACT FOR CIVIL REPAIR & MAINTENACE WORK OF SUB-STATIONS & OFFICE BUILDINGS at VARIOUS LOCATIONS of NPCL.â€</b>
                        </div>
                        {show166 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 28-06-2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>TENDER NOTIFICATION FOR â€œTWO YEAR RATE CONTRACT FOR CIVIL REPAIR & MAINTENACE WORK OF SUB-STATIONS & OFFICE BUILDINGS at VARIOUS LOCATIONS of NPCL.â€</td>
                                <td> NIT No. NPCL/FY25-26/Civil R&M/23 Civil R&M </td>
                              </tr>
                            </table>
                            <ul className="tariff_standard">
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26Civil_M23/R&M Civil Maintenance Work Tender 280625 Website.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                </a>
                              </li>
                            </ul>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow165(!show165)}
                        >
                          <b>NIT No. NPCL/FY25-26/AMI/18 for â€œADVANCED METERING INFRASTRUCTURE (AMI) DEPLOYMENT IN NOIDA POWER COMPANY LTD.â€</b>
                        </div>
                        {show165 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 28-06-2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>TENDER NOTIFICATION FOR â€œADVANCED METERING INFRASTRUCTURE (AMI) DEPLOYMENT IN NOIDA POWER COMPANY LTD.â€</td>
                                <td> NIT No. NPCL/FY25-26/AMI/18 </td>
                              </tr>
                            </table>
                            <ul className="tariff_standard">
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26AMI18/NPCL AMI Tender Doc Final_Website 28062025.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                </a>
                              </li>
                            </ul>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow164(!show164)}
                        >
                          <b>Corrigendum-1 against NIT No. NPCL/FY25-26/MS ITEMS (GALVANISED)/011 for â€œANNUAL RATE CONTRACT FOR SUPPLY OF MS ITEMS(GALVANISED).â€</b>
                        </div>
                        {show164 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 04-06-2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>Corrigendum-1 against TENDER NOTIFICATION FOR â€œANNUAL RATE CONTRACT FOR SUPPLY OF MS ITEMS(GALVANISED).â€</td>
                                <td> NIT No. NPCL/FY25-26/MS ITEMS(GALVANISED)/011 </td>
                              </tr>
                            </table>
                            <ul className="tariff_standard">
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26MSITEMS011/Corriegendum-1 dated 25,06.2025 Extension of Bid Submission Date.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                </a>
                              </li>
                            </ul>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow163(!show163)}
                        >
                          <b>NIT No. NPCL/FY25-26/12.5 & 16 MVA PTR/013 for â€œSITC of 12.5 MVA & 16 MVA PTR.â€</b>
                        </div>
                        {show163 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 24-06-2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>TENDER NOTIFICATION FOR â€œSITC of 12.5 MVA & 16 MVA PTR.â€</td>
                                <td> NIT No. NPCL/FY25-26/12.5 & 16 MVA PTR/013 </td>
                              </tr>
                            </table>
                            <ul className="tariff_standard">
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-2612.5_16_MVA_PTR013/PTR BID DOC. Final UPLOADED NPCL WEBSITE.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                </a>
                              </li>
                            </ul>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow162(!show162)}
                        >
                          <b>Corrigendum-2 against NIT No. NPCL/FY25-26/IT-FMS/08 for â€œTENDER NOTIFICATION FOR IMPLEMENTATION OF FUND MANAGEMENT SYSTEM.â€</b>
                        </div>
                        {show162 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 29-04-2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>Corrigendum-2 against TENDER NOTIFICATION FOR â€œTENDER NOTIFICATION FOR IMPLEMENTATION OF FUND MANAGEMENT SYSTEM".</td>
                                <td>NIT No. NPCL/FY25-26/IT-FMS/08 </td>
                              </tr>
                            </table>
                            <ul className="tariff_standard">
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26IT-FMS08/Corrigendum2.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                </a>
                              </li>
                            </ul>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow161(!show161)}
                        >
                          <b>NIT No. NPCL/FY25-26/FPI/010 for â€œARC FOR SUPPLY INSTALLATION TESTING & COMMISSIONING OF NON COMMUNICABLE FAULT PASSAGE INDICATOR (FPI) UPTO 33KV NETWORK SYSTEM.â€</b>
                        </div>
                        {show161 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 18-06-2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>TENDER NOTIFICATION FOR â€œARC FOR SUPPLY INSTALLATION TESTING & COMMISSIONING OF NON COMMUNICABLE FAULT PASSAGE INDICATOR (FPI) UPTO 33KV NETWORK SYSTEM.â€</td>
                                <td> NIT No. NPCL/FY25-26/FPI/010 </td>
                              </tr>
                            </table>
                            <ul className="tariff_standard">
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26FPI010/Bid Document FPI.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                </a>
                              </li>
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26FPI010/FPI_Specification & GTP_Controlled Copy.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                </a>
                              </li>
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26FPI010/Submission of Prebid Query FPI.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                </a>
                              </li>
                            </ul>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow160(!show160)}
                        >
                          <b>NIT No. NPCL/FY25-26/DT/016 for â€œ2 YRS  RATE CONTRACT FOR SUPPLY OF DISTRIBUTION TRANSFORMERS.â€</b>
                        </div>
                        {show160 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 18-06-2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>TENDER NOTIFICATION FOR â€œ2 YRS  RATE CONTRACT FOR SUPPLY OF DISTRIBUTION TRANSFORMERS.â€</td>
                                <td> NIT No. NPCL/FY25-26/DT/016 </td>
                              </tr>
                            </table>
                            <ul className="tariff_standard">
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26DT016/Bid Document Supply of Distribution Transformer.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                </a>
                              </li>
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26DT016/TS_Distribution Transformer_Controlled Copy_Revision_F.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                </a>
                              </li>
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26DT016/Submission of Prebid Query Distribution Transformer.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                </a>
                              </li>
                            </ul>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow159(!show159)}
                        >
                          <b>Corrigendum-3 against NIT No. NPCL/FY25-26/SS GIS/07 for â€œSUPPLY AND ETC OF 33KV DOUBLE BUS INDOOR GAS INSULATED SWITCHGEAR.â€</b>
                        </div>
                        {show159 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 30-04-2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>Corrigendum-3 against TENDER NOTIFICATION FOR â€œSUPPLY AND ETC OF 33KV DOUBLE BUS INDOOR GAS INSULATED SWITCHGEAR.â€</td>
                                <td> NPCL/FY25-26/SS GIS/07 </td>
                              </tr>
                            </table>
                            <ul className="tariff_standard">
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26SSGIS07/CORRIGENDUM-3 - 33kV GIS.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                </a>
                              </li>
                            </ul>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow158(!show158)}
                        >
                          <b>Corrigendum-4 against NIT No. NPCL/FY25-26/SS AIS/06 for â€œSUPPLY OF 11kV & 33kV AIS INDOOR PANEL SWITCHBOARD.â€</b>
                        </div>
                        {show158 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 30-04-2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>Corrigendum-2 against TENDER NOTIFICATION FOR â€œSUPPLY OF 11kV & 33kV AIS INDOOR PANEL SWITCHBOARD.â€</td>
                                <td> NPCL/FY25-26/SS AIS/06 </td>
                              </tr>
                            </table>
                            <ul className="tariff_standard">
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26SSGIS06/CORRIGENDUM-4 - 11kV AIS.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                </a>
                              </li>
                            </ul>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow157(!show157)}
                        >
                          <b>Corrigendum -02 against NPCL/FY24-25/ DRDR Meter/044 Dated 28.03.2025 for â€œ3P4W Whole Current Dual Source DRDR dual account DLMS Energy Meter.â€</b>
                        </div>
                        {show157 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 11.04.2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>Corrigendum -01 against NPCL/FY24-25/AC/044 Dated 11.04.2025 for â€œ3P4W Whole Current Dual Source DRDR dual account DLMS Energy Meter.â€</td>
                                <td> NPCL/FY24-25/ DRDR Meter/044 </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY24-25DRDRMeter044/CORRIGENDUM-2 - DRDR Meter.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow156(!show156)}
                        >
                          <b>Corrigendum-3 against NIT No. NPCL/FY25-26/SS AIS/06 for â€œSUPPLY OF 11kV & 33kV AIS INDOOR PANEL SWITCHBOARD.â€</b>
                        </div>
                        {show156 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 30-04-2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>Corrigendum-2 against TENDER NOTIFICATION FOR â€œSUPPLY OF 11kV & 33kV AIS INDOOR PANEL SWITCHBOARD.â€</td>
                                <td> NPCL/FY25-26/SS AIS/06 </td>
                              </tr>
                            </table>
                            <ul className="tariff_standard">
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26SSGIS06/CORRIGENDUM-3 - 11kV AIS.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                </a>
                              </li>
                            </ul>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow152(!show152)}
                        >
                          <b>NIT No. NPCL/FY25-26/MS ITEMS (GALVANISED)/011 for â€œANNUAL RATE CONTRACT FOR SUPPLY OF MS ITEMS(GALVANISED).â€</b>
                        </div>
                        {show152 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 04-06-2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>TENDER NOTIFICATION FOR â€œANNUAL RATE CONTRACT FOR SUPPLY OF MS ITEMS(GALVANISED).â€</td>
                                <td> NIT No. NPCL/FY25-26/MS ITEMS(GALVANISED)/011 </td>
                              </tr>
                            </table>
                            <ul className="tariff_standard">
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26MSITEMS011/Bid Documents of Annual Rate Contract of Supply of MS items.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                </a>
                              </li>
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26MSITEMS011/GTP Tech Specs.zip"
                                  target="_blank" rel="noreferrer"
                                >
                                  Tender Documents
                                </a>
                              </li>
                            </ul>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow155(!show155)}
                        >
                          <b>Corrigendum-2 against NIT No. NPCL/FY25-26/SS GIS/07 for â€œSUPPLY AND ETC OF 33KV DOUBLE BUS INDOOR GAS INSULATED SWITCHGEAR.â€</b>
                        </div>
                        {show155 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 30-04-2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>Corrigendum-2 against TENDER NOTIFICATION FOR â€œSUPPLY AND ETC OF 33KV DOUBLE BUS INDOOR GAS INSULATED SWITCHGEAR.â€</td>
                                <td> NPCL/FY25-26/SS GIS/07 </td>
                              </tr>
                            </table>
                            <ul className="tariff_standard">
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26SSGIS07/CORRIGENDUM-2 - 33kV GIS.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                </a>
                              </li>
                            </ul>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow154(!show154)}
                        >
                          <b>Corrigendum-2 against NIT No. NPCL/FY25-26/SS AIS/06 for â€œSUPPLY OF 11kV & 33kV AIS INDOOR PANEL SWITCHBOARD.â€</b>
                        </div>
                        {show154 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 30-04-2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>Corrigendum-2 against TENDER NOTIFICATION FOR â€œSUPPLY OF 11kV & 33kV AIS INDOOR PANEL SWITCHBOARD.â€</td>
                                <td> NPCL/FY25-26/SS AIS/06 </td>
                              </tr>
                            </table>
                            <ul className="tariff_standard">
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26SSGIS06/CORRIGENDUM-2- 11kV AIS.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                </a>
                              </li>
                            </ul>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow153(!show153)}
                        >
                          <b>Corrigendum-2 against NIT No. NPCL/FY 25-26/SS-PTR/05 for â€œSupply of 33/11 kV 12.5 MVA & 16 MVA Power Transformers.â€</b>
                        </div>
                        {show153 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 30-04-2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>Corrigendum-2 against TENDER NOTIFICATION FOR â€œSupply of 33/11 kV 12.5 MVA & 16 MVA Power Transformers.â€</td>
                                <td> NPCL/FY 25-26/SS-PTR/05 </td>
                              </tr>
                            </table>
                            <ul className="tariff_standard">
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26SS-PTR05/CORRIGENDUM-2 - PTR.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                </a>
                              </li>
                            </ul>
                          </div>
                        ) : null}
                      </div>

                      {/* <div className="card">
                          <div
                            className="card-header"
                            onClick={() => setShow152(!show152)}
                          >
                            <b>Corrigendum-2 against NIT No. NPCL/FY25-26/AMC/04 for â€œAMC for 11kV & 33kV Network Maintenance.â€</b>
                          </div>
                          {show152 ? (

                            <div className="card-body">
                            <table className="table table-responsive table-striped">
                            <tr>
                              <th className="col-sm-1">Sr. No.</th>
                              <th className="col-sm-8">Tender Description</th>
                              <th className="col-sm-3">NIT No. &nbsp;  Date: 30-04-2025</th>
                            </tr>
                            <tr>
                              <td>1.</td>
                              <td>Corrigendum-2 against TENDER NOTIFICATION FOR â€œAMC for 11kV & 33kV Network Maintenance.â€</td>
                              <td> NPCL/FY25-26/AMC/04 </td>
                            </tr>
                            </table>
                            <ul className="tariff_standard">
                            <li>
                            <a
                                href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26AMC04/Corrigendum01 Final Uploaded Website.pdf"
                                target="_blank" rel="noreferrer"
                              >
                                <img src="assets/img/pdf.png" alt="" />
                              </a>
                            </li>
                          </ul>  
                            </div>
                            ) : null}
                   </div> */}

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow151(!show151)}
                        >
                          <b>Corrigendum-1 against NIT No. NPCL/FY25-26/SS GIS/07 for â€œSUPPLY AND ETC OF 33KV DOUBLE BUS INDOOR GAS INSULATED SWITCHGEAR.â€</b>
                        </div>
                        {show151 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 30-04-2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>Corrigendum-1 against TENDER NOTIFICATION FOR â€œSUPPLY AND ETC OF 33KV DOUBLE BUS INDOOR GAS INSULATED SWITCHGEAR.â€</td>
                                <td> NPCL/FY25-26/SS GIS/07 </td>
                              </tr>
                            </table>
                            <ul className="tariff_standard">
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26SSGIS07/CORRIGENDUM-1 - 33kV GIS.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                </a>
                              </li>
                            </ul>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow150(!show150)}
                        >
                          <b>Corrigendum-1 against NIT No. NPCL/FY25-26/SS AIS/06 for â€œSUPPLY OF 11kV & 33kV AIS INDOOR PANEL SWITCHBOARD.â€</b>
                        </div>
                        {show150 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 30-04-2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>Corrigendum-1 against TENDER NOTIFICATION FOR â€œSUPPLY OF 11kV & 33kV AIS INDOOR PANEL SWITCHBOARD.â€</td>
                                <td> NPCL/FY25-26/SS AIS/06 </td>
                              </tr>
                            </table>
                            <ul className="tariff_standard">
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26SSGIS06/CORRIGENDUM-1 - 11kV AIS.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                </a>
                              </li>
                            </ul>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow149(!show149)}
                        >
                          <b>Corrigendum-1 against NIT No. NPCL/FY 25-26/SS-PTR/05 for â€œSupply of 33/11 kV 12.5 MVA & 16 MVA Power Transformers.â€</b>
                        </div>
                        {show149 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 30-04-2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>Corrigendum-1 against TENDER NOTIFICATION FOR â€œSupply of 33/11 kV 12.5 MVA & 16 MVA Power Transformers.â€</td>
                                <td> NPCL/FY 25-26/SS-PTR/05 </td>
                              </tr>
                            </table>
                            <ul className="tariff_standard">
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26SS-PTR05/CORRIGENDUM-1 - PTR.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                </a>
                              </li>
                            </ul>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow148(!show148)}
                        >
                          <b>Corrigendum-1 against NIT No. NPCL/FY25-26/AMC/04 for â€œAMC for 11kV & 33kV Network Maintenance.â€</b>
                        </div>
                        {show148 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 30-04-2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>Corrigendum-1 against TENDER NOTIFICATION FOR â€œAMC for 11kV & 33kV Network Maintenance.â€</td>
                                <td> NPCL/FY25-26/AMC/04 </td>
                              </tr>
                            </table>
                            <ul className="tariff_standard">
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26AMC04/Corrigendum01 Final Uploaded Website.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                </a>
                              </li>
                            </ul>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow147(!show147)}
                        >
                          <b>Corrigendum-2 against NIT No. NPCL/IT/FY25-26/RMS/02 for TENDER NOTIFICATION FOR â€œRACK MOUNT SERVERS.â€</b>
                        </div>
                        {show147 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 18-04-2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>Corrigendum-2 against TENDER NOTIFICATION FOR â€œRACK MOUNT SERVERS".</td>
                                <td> NIT No. NPCL/IT/FY25-26/RMS/02 </td>
                                <td><a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLITFY25-26RMS02/Corrigendum2.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                </a></td>
                              </tr>
                            </table>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow146(!show146)}
                        >
                          <b>Corrigendum-1 against NIT No. NPCL/FY25-26/IT-FMS/08 for â€œTENDER NOTIFICATION FOR IMPLEMENTATION OF FUND MANAGEMENT SYSTEM.â€</b>
                        </div>
                        {show146 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 29-04-2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>Corrigendum-1 against TENDER NOTIFICATION FOR â€œTENDER NOTIFICATION FOR IMPLEMENTATION OF FUND MANAGEMENT SYSTEM".</td>
                                <td>NIT No. NPCL/FY25-26/IT-FMS/08 </td>
                              </tr>
                            </table>
                            <ul className="tariff_standard">
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26IT-FMS08/Corrigendum1.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                </a>
                              </li>
                            </ul>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow145(!show145)}
                        >
                          <b>Corrigendum-1 against NIT No. NPCL/IT/FY25-26/RMS/02 for TENDER NOTIFICATION FOR â€œRACK MOUNT SERVERS.â€</b>
                        </div>
                        {show145 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 18-04-2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>Corrigendum-1 against TENDER NOTIFICATION FOR â€œRACK MOUNT SERVERS".</td>
                                <td> NIT No. NPCL/IT/FY25-26/RMS/02 </td>
                                <td><a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLITFY25-26RMS02/Corrigendum1.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                </a></td>
                              </tr>
                            </table>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow144(!show144)}
                        >
                          <b>Corrigendum-1 against NIT No. NPCL/FY25-26/ERT/03 for TENDER NOTIFICATION FOR â€œARC FOR SUPPLY OF GI EARTHING ROD, PLATE & PIPE.â€</b>
                        </div>
                        {show144 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 18-04-2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>Corrigendum-1 against TENDER NOTIFICATION FOR â€œARC FOR SUPPLY OF GI EARTHING ROD, PLATE & PIPE".</td>
                                <td> NIT No. NPCL/FY25-26/ERT/03 </td>
                              </tr>
                            </table>
                            <ul className="tariff_standard">
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26ERT03/Corriegendum-1 dated 09,05.2025 Submission of Prebid Query & Extension of Bid Submission Date.docx"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/doc-icon.png" alt="" />
                                </a>
                              </li>
                            </ul>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow143(!show143)}
                        >
                          <b>NIT No. NPCL/FY25-26/SS GIS/07 for â€œSUPPLY AND ETC OF 33KV DOUBLE BUS INDOOR GAS INSULATED SWITCHGEAR.â€</b>
                        </div>
                        {show143 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 30-04-2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>TENDER NOTIFICATION FOR â€œSUPPLY AND ETC OF 33KV DOUBLE BUS INDOOR GAS INSULATED SWITCHGEAR.â€</td>
                                <td> NPCL/FY25-26/SS GIS/07 </td>
                              </tr>
                            </table>
                            <ul className="tariff_standard">
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26SSGIS07/33kV GIS SITC Tender Doc NPCL.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                </a>
                              </li>
                            </ul>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow142(!show142)}
                        >
                          <b>NIT No. NPCL/FY25-26/SS AIS/06 for â€œSUPPLY OF 11kV & 33kV AIS INDOOR PANEL SWITCHBOARD.â€</b>
                        </div>
                        {show142 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 30-04-2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>TENDER NOTIFICATION FOR â€œSUPPLY OF 11kV & 33kV AIS INDOOR PANEL SWITCHBOARD.â€</td>
                                <td> NPCL/FY25-26/SS AIS/06 </td>
                              </tr>
                            </table>
                            <ul className="tariff_standard">
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26SSGIS06/AIS 11kV & 33kV Supply NPCL.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                </a>
                              </li>
                            </ul>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow141(!show141)}
                        >
                          <b>NIT No. NPCL/FY 25-26/SS-PTR/05 for â€œSupply of 33/11 kV 12.5 MVA & 16 MVA Power Transformers.â€</b>
                        </div>
                        {show141 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 30-04-2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>TENDER NOTIFICATION FOR â€œSupply of 33/11 kV 12.5 MVA & 16 MVA Power Transformers.â€</td>
                                <td> NPCL/FY 25-26/SS-PTR/05 </td>
                              </tr>
                            </table>
                            <ul className="tariff_standard">
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26SS-PTR05/12.5 MVA & 16MVA PTR Tender Doc NPCL.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                </a>
                              </li>
                            </ul>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow140(!show140)}
                        >
                          <b>NIT No. NPCL/FY25-26/AMC/04 for â€œAMC for 11kV & 33kV Network Maintenance.â€</b>
                        </div>
                        {show140 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 30-04-2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>TENDER NOTIFICATION FOR â€œAMC for 11kV & 33kV Network Maintenance.â€</td>
                                <td> NPCL/FY25-26/AMC/04 </td>
                              </tr>
                            </table>
                            <ul className="tariff_standard">
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26AMC04/11kV & 33kV AMC Tender Doc_Final.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                </a>
                              </li>
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26AMC04/Pre-Bid Clarification AMC.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                </a>
                              </li>
                            </ul>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow139(!show139)}
                        >
                          <b>NIT No. NPCL/FY25-26/Vehicle/09 for â€œHiring of Vehicles on Rental Basis at NPCL ,Greater Noida.â€</b>
                        </div>
                        {show139 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 29-04-2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>TENDER NOTIFICATION FOR â€œHiring of Vehicles on Rental Basis at NPCL ,Greater Noida.â€</td>
                                <td> NIT No. NPCL/FY25-26/Vehicle/09 </td>
                              </tr>
                            </table>
                            <ul className="tariff_standard">
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26Vehicle09/Bid Document for Hiring of Vehicles.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                </a>
                              </li>
                            </ul>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow138(!show138)}
                        >
                          <b>NIT No. NPCL/FY25-26/IT-FMS/08 for â€œTENDER NOTIFICATION FOR IMPLEMENTATION OF FUND MANAGEMENT SYSTEM.â€</b>
                        </div>
                        {show138 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 29-04-2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>TENDER NOTIFICATION FOR â€œTENDER NOTIFICATION FOR IMPLEMENTATION OF FUND MANAGEMENT SYSTEM".</td>
                                <td> NIT No. NPCL/FY25-26/IT-FMS/08 </td>
                              </tr>
                            </table>
                            <ul className="tariff_standard">
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26IT-FMS08/Bid Document FMS.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                </a>
                              </li>
                            </ul>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow137(!show137)}
                        >
                          <b>Corrigendum-2 against NIT No. NIT No. NPCL/FY24-25/JTGK/034 for â€œTENDER NOTIFICATION FOR â€œAnnual Rate contract for SUPPLY OF LT/HT CABLE JOINTING KITS".â€</b>
                        </div>
                        {show137 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 29-03-2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>Corrigendum-2 against TENDER NOTIFICATION FOR â€œAnnual Rate contract for SUPPLY OF LT/HT CABLE JOINTING KITS".</td>
                                <td> NIT No. NIT No. NPCL/FY24-25/JTGK/034 </td>
                              </tr>
                            </table>
                            <ul className="tariff_standard">
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY24-25JTGK034/CORRIGENDUM-2 -  LTHT CABLE JOINTING KITS  Dated 23.04.2025 - Prebid Query & Extension of Bid document Submission date.docx"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/doc-icon.png" alt="" />
                                  CORRIGENDUM-2 - LTHT CABLE JOINTING KITS
                                </a>
                              </li>
                            </ul>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow136(!show136)}
                        >
                          <b>Corrigendum -01 against NPCL/FY24-25/ DRDR Meter/044 Dated 28.03.2025 for â€œ3P4W Whole Current Dual Source DRDR dual account DLMS Energy Meter.â€</b>
                        </div>
                        {show136 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 11.04.2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>Corrigendum -01 against NPCL/FY24-25/AC/044 Dated 11.04.2025 for â€œ3P4W Whole Current Dual Source DRDR dual account DLMS Energy Meter.â€</td>
                                <td> NPCL/FY24-25/ DRDR Meter/044 </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY24-25DRDRMeter044/Consolidated Pre-Bid Queries DRDR Meter.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY24-25DRDRMeter044/CORRIGENDUM-1 Dated 23.04.2025.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow135(!show135)}
                        >
                          <b>Corrigendum -01 against NIT No. NPCL/FY25-26/SS-Civil/01 for TENDER NOTIFICATION FOR â€œCivil Construction of 5 Nos. of 33/11kV Electric Substation Building at various locations in Greater Noida.â€</b>
                        </div>
                        {show135 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 18-04-2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>Corrigendum -03 against TENDER NOTIFICATION FOR â€œCivil Construction of 5 Nos. of 33/11kV Electric Substation Building at various locations in Greater Noida".</td>
                                <td> NIT No. NPCL/FY25-26/SS-Civil/01 </td>
                                <td>
                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26SS-Civil01/Corrigendum 01 NPCL Website Civil.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>
                                </td>
                              </tr>
                            </table>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow134(!show134)}
                        >
                          <b>Corrigendum -03 against NPCL/FY24-25/Security Services/042 Dated 28.03.2025 for â€œHiring of Security Agency for NPCL Offices.â€</b>
                        </div>
                        {show134 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 28.03.2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>Corrigendum -03 against NPCL/FY24-25/Security Services/042 Dated 28.03.2025 for â€œHiring of Security Agency for NPCL Offices.â€</td>
                                <td> NPCL/FY24-25/Security Services/042 </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY24-25SecurityServices042/CORRIGENDUM-3 Bid Extesnion.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow133(!show133)}
                        >
                          <b>NIT No. NPCL/FY25-26/ERT/03 for TENDER NOTIFICATION FOR â€œARC FOR SUPPLY OF GI EARTHING ROD, PLATE & PIPE.â€</b>
                        </div>
                        {show133 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 18-04-2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>TENDER NOTIFICATION FOR â€œARC FOR SUPPLY OF GI EARTHING ROD, PLATE & PIPE".</td>
                                <td> NIT No. NPCL/FY25-26/ERT/03 </td>
                                <td>
                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26ERT03/Tender Document For Earthing & GI Pipe.rar"
                                    target="_blank" rel="noreferrer"
                                  >
                                    Tender Document For Earthing & GI Pipe
                                  </a>
                                </td>
                              </tr>
                            </table>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow133(!show133)}
                        >
                          <b>NIT No. NPCL/FY25-26/SS-Civil/01 for TENDER NOTIFICATION FOR â€œCivil Construction of 5 Nos. of 33/11kV Electric Substation Building at various locations in Greater Noida.â€</b>
                        </div>
                        {show132 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 18-04-2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>TENDER NOTIFICATION FOR â€œCivil Construction of 5 Nos. of 33/11kV Electric Substation Building at various locations in Greater Noida".</td>
                                <td> NIT No. NPCL/FY25-26/SS-Civil/01 </td>
                                <td>
                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26SS-Civil01/Civil Works- 5 Nos. Substations NPCL.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>
                                </td>
                              </tr>
                            </table>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow132(!show132)}
                        >
                          <b>NIT No. NPCL/FY25-26/SS-Civil/01 for TENDER NOTIFICATION FOR â€œCivil Construction of 5 Nos. of 33/11kV Electric Substation Building at various locations in Greater Noida.â€</b>
                        </div>
                        {show132 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 18-04-2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>TENDER NOTIFICATION FOR â€œCivil Construction of 5 Nos. of 33/11kV Electric Substation Building at various locations in Greater Noida".</td>
                                <td> NIT No. NPCL/FY25-26/SS-Civil/01 </td>
                                <td>
                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY25-26SS-Civil01/Civil Works- 5 Nos. Substations NPCL.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>
                                </td>
                              </tr>
                            </table>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow131(!show131)}
                        >
                          <b>NIT No. NPCL/IT/FY25-26/RMS/02 for TENDER NOTIFICATION FOR â€œRACK MOUNT SERVERS.â€</b>
                        </div>
                        {show131 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 18-04-2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>TENDER NOTIFICATION FOR â€œRACK MOUNT SERVERS".</td>
                                <td> NIT No. NPCL/IT/FY25-26/RMS/02 </td>
                                <td><a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLITFY25-26RMS02/Bid Document Rack Mount Server.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                </a></td>
                              </tr>
                            </table>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow130(!show130)}
                        >
                          <b>Corrigendum-1 against NIT No. NIT No. NPCL/FY24-25/JTGK/034 for â€œTENDER NOTIFICATION FOR â€œAnnual Rate contract for SUPPLY OF LT/HT CABLE JOINTING KITS".â€</b>
                        </div>
                        {show130 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 29-03-2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>Corrigendum-1 against TENDER NOTIFICATION FOR â€œAnnual Rate contract for SUPPLY OF LT/HT CABLE JOINTING KITS".</td>
                                <td> NIT No. NIT No. NPCL/FY24-25/JTGK/034 </td>
                              </tr>
                            </table>
                            <ul className="tariff_standard">
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY24-25JTGK034/CORRIGENDUM-1 -  LTHT CABLE JOINTING KITS  Dated 18.04.2025.docx"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/doc-icon.png" alt="" />
                                  CORRIGENDUM-1 - LTHT CABLE JOINTING KITS
                                </a>
                              </li>
                            </ul>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow129(!show129)}
                        >
                          <b>Corrigendum -02 against NPCL/FY24-25/Security Services/042 Dated 28.03.2025 for â€œHiring of Security Agency for NPCL Offices.â€</b>
                        </div>
                        {show129 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 28.03.2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>Corrigendum -02 against NPCL/FY24-25/Security Services/042 Dated 28.03.2025 for â€œHiring of Security Agency for NPCL Offices.â€</td>
                                <td> NPCL/FY24-25/Security Services/042 </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY24-25SecurityServices042/CORRIGENDUM-2 - Security Services.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow128(!show128)}
                        >
                          <b>Corrigendum -01 against NPCL/FY24-25/Security Services/042 Dated 28.03.2025 for â€œHiring of Security Agency for NPCL Offices.â€</b>
                        </div>
                        {show128 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 28.03.2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>Corrigendum -01 against NPCL/FY24-25/Security Services/042 Dated 28.03.2025 for â€œHiring of Security Agency for NPCL Offices.â€</td>
                                <td> NPCL/FY24-25/Security Services/042 </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY24-25SecurityServices042/CORRIGENDUM-1 - Security Services NPCL.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY24-25SecurityServices042/Pre-Bid Clarification.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow127(!show127)}
                        >
                          <b>Corrigendum -01 against NPCL/FY24-25/AC/044 Dated 28.03.2025 for â€œSupply Installation Testing & Commissioning of Air Condition Unit at NPCL Office Building Greater Noida.â€</b>
                        </div>
                        {show127 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 28.03.2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>Corrigendum -01 against NPCL/FY24-25/AC/044 Dated 28.03.2025 for â€œSupply Installation Testing & Commissioning of Air Condition Unit at NPCL Office Building Greater Noida.â€</td>
                                <td> NPCL/FY24-25/AC/044 </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY24-25AC044/CORRIGENDUM-1 AC 11.04.2025.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow126(!show126)}
                        >
                          <b>NPCL/FY24-25/ DRDR Meter/044 Dated 28.03.2025 for â€œ3P4W Whole Current Dual Source DRDR dual account DLMS Energy Meter.â€</b>
                        </div>
                        {show126 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 11.04.2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>NPCL/FY24-25/AC/044 Dated 11.04.2025 for â€œ3P4W Whole Current Dual Source DRDR dual account DLMS Energy Meter.â€</td>
                                <td> NPCL/FY24-25/ DRDR Meter/044 </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY24-25DRDRMeter044/3P4W Whole Current Dual Source Dual Account DRDR Energy Meter.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY24-25DRDRMeter044/Bid Document DRDR Meter.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow125(!show125)}
                        >
                          <b>Corrigendum-1 against NIT No. NPCL/FY24-25/11 kV Metering Cubicle/030 Dated 03.03.2025 for â€œAnnual Rate Contract for the Supply of 11 kV Metering Cubicles.â€</b>
                        </div>
                        {show125 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 19.03.2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>Corrigendum-1 against NIT No. NPCL/FY24-25/11 kV Metering Cubicle/030 Dated 19.03.2025 for â€œAnnual Rate Contract for the Supply of 11 kV Metering Cubicles.â€</td>
                                <td> NIT No. NPCL/FY24-25/11 kV Metering Cubicle/030 </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY24-2511kVMeteringCubicle030/CORRIGENDUM-1 Dated 09.04.2025.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY24-2511kVMeteringCubicle030/11kV Metering Cubicle.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow124(!show124)}
                        >
                          <b>NIT No. NIT No. NPCL/FY24-25/JTGK/034 for â€œTENDER NOTIFICATION FOR â€œAnnual Rate contract for SUPPLY OF LT/HT CABLE JOINTING KITS".â€</b>
                        </div>
                        {show124 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 29-03-2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>TENDER NOTIFICATION FOR â€œAnnual Rate contract for SUPPLY OF LT/HT CABLE JOINTING KITS".</td>
                                <td> NIT No. NIT No. NPCL/FY24-25/JTGK/034 </td>
                              </tr>
                            </table>
                            <ul className="tariff_standard">
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY24-25JTGK034/NIT Bid Document.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                  NIT Bid Document
                                </a>
                              </li>
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY24-25JTGK034/GTP-OD & ST Jointing Kit for 11kV AB Cable_Controlled Copy.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                  GTP-OD & ST Jointing Kit for 11kV AB Cable Controlled Copy
                                </a>
                              </li>
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY24-25JTGK034/GTP FOR OD TERM KIT FR 4C 150 SQMM LT CABLE.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                  GTP FOR OD TERM KIT FR 4C 150 SQMM LT CABLE
                                </a>
                              </li>

                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY24-25JTGK034/GTP FOR OD TERM KIT FR 4C 300 SQMM LT CABLE.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                  GTP FOR OD TERM KIT FR 4C 300 SQMM LT CABLE
                                </a>
                              </li>
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY24-25JTGK034/GTP-11 kV ID, OD & ST Jointing Kit_Controlled Copy.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                  GTP-11 kV ID, OD & ST Jointing Kit_Controlled Copy
                                </a>
                              </li>
                            </ul>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow123(!show123)}
                        >
                          <b>NPCL/FY24-25/AC/044 Dated 28.03.2025 for â€œSupply Installation Testing & Commissioning of Air Condition Unit at NPCL Office Building Greater Noida.â€</b>
                        </div>
                        {show123 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 28.03.2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>NPCL/FY24-25/AC/044 Dated 28.03.2025 for â€œSupply Installation Testing & Commissioning of Air Condition Unit at NPCL Office Building Greater Noida.â€</td>
                                <td> NPCL/FY24-25/AC/044 </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY24-25AC044/Tender AC Final_Uploaded.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow122(!show122)}
                        >
                          <b>NPCL/FY24-25/Security Services/042 Dated 28.03.2025 for â€œHiring of Security Agency for NPCL Offices.â€</b>
                        </div>
                        {show122 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 28.03.2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>NPCL/FY24-25/Security Services/042 Dated 28.03.2025 for â€œHiring of Security Agency for NPCL Offices.â€</td>
                                <td> NPCL/FY24-25/Security Services/042 </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY24-25SecurityServices042/Security Tender _Final Upload.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow121(!show121)}
                        >
                          <b>Corrigendum-2 against NIT No. NPCL/FY24-25/ITOTFW/023 Dated 26.02.2025 for â€œTENDER NOTIFICATION FOR IT-OT FIREWALL (NETWORK & WEB APPLICATION).â€</b>
                        </div>
                        {show121 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 26.02.2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>Corrigendum-2 against NIT No. NPCL/FY24-25/ITOTFW/023 Dated 26.02.2025 for â€œTENDER NOTIFICATION FOR IT-OT FIREWALL (NETWORK & WEB APPLICATION).â€</td>
                                <td> NIT No. NPCL/FY24-25/ITOTFW/023 </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY24-25ITOTFW023/Corrigendum2.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow120(!show120)}
                        >
                          <b>Corrigendum-3 against NIT No. NPCL/FY24-25/ meters/024 Dated 27.02.2025 for â€œAnnual Rate Contract for the Supply of meters.â€</b>
                        </div>
                        {show120 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 27.02.2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>Corrigendum-3 against NIT No. NPCL/FY24-25/ meters/024 Dated 27.02.2025 for â€œAnnual Rate Contract for the Supply of meters.â€</td>
                                <td> NIT No. NPCL/FY24-25/ meters/024 </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY24-25meters024/CORRIGENDUM-3 Dated 19.03.2025.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow119(!show119)}
                        >
                          <b>NIT No. NPCL/FY24-25/11 kV Metering Cubicle/030 Dated 03.03.2025 for â€œAnnual Rate Contract for the Supply of 11 kV Metering Cubicles.â€</b>
                        </div>
                        {show119 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 19.03.2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>NIT No. NPCL/FY24-25/11 kV Metering Cubicle/030 Dated 19.03.2025 for â€œAnnual Rate Contract for the Supply of 11 kV Metering Cubicles.â€</td>
                                <td> NIT No. NPCL/FY24-25/11 kV Metering Cubicle/030 </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY24-2511kVMeteringCubicle030/Bid Document Metering Cubicle.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY24-2511kVMeteringCubicle030/11 kV Meter Cubicle.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow118(!show118)}
                        >
                          <b>Corrigendum-1 against NIT No. NPCL/FY24-25/ITOTFW/023 Dated 26.02.2025 for â€œTENDER NOTIFICATION FOR IT-OT FIREWALL (NETWORK & WEB APPLICATION).â€</b>
                        </div>
                        {show118 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 26.02.2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>Corrigendum-1 against NIT No. NPCL/FY24-25/ITOTFW/023 Dated 26.02.2025 for â€œTENDER NOTIFICATION FOR IT-OT FIREWALL (NETWORK & WEB APPLICATION).â€</td>
                                <td> NIT No. NPCL/FY24-25/ITOTFW/023 </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY24-25ITOTFW023/Corrigendum1.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow117(!show117)}
                        >
                          <b>Corrigendum-2 against NIT No. NPCL/FY24-25/ meters/024 Dated 27.02.2025 for â€œAnnual Rate Contract for the Supply of meters.â€</b>
                        </div>
                        {show117 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 27.02.2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>Corrigendum-2 against NIT No. NPCL/FY24-25/ meters/024 Dated 27.02.2025 for â€œAnnual Rate Contract for the Supply of meters.â€</td>
                                <td> NIT No. NPCL/FY24-25/ meters/024 </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY24-25meters024/CORRIGENDUM -2 dated 10.03.2025.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow116(!show116)}
                        >
                          <b>Corrigendum-4 against NIT No. NPCL/FY24-25/STP POLE/028 dated 24.01.2025 for â€œ01 Years Rate Contract for the Supply of Pole STP 12 M (SP-62) & Pole STP 13 M (SP-72).â€ </b>
                        </div>
                        {show116 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 27.02.2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>Corrigendum-4 against NIT No. NPCL/FY24-25/STP POLE/028 dated 24.01.2025 for â€œ01 Years Rate Contract for the Supply of Pole STP 12 M (SP-62) & Pole STP 13 M (SP-72)â€ </td>
                                <td> NIT No. NPCL/FY24-25/STP POLE/028 </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY24-25STP%20POLE028/CORRIGENDUM-4 Dated 10.03.2025.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow115(!show115)}
                        >
                          <b>Corrigendum-7 against NIT No. NPCL/CIV/ESS/FY24-25/GR. NOIDA/016 Dated 10.08.2024 for â€œCivil Construction of 5 Nos. of 33/11kV Electric Substation Building at various locations in Greater Noida.â€</b>
                        </div>
                        {show115 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 09-08-2024</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>Corrigendum-7 against NIT No. NPCL/CIV/ESS/FY24-25/GR. NOIDA/016 Dated 10.08.2024 for â€œCivil Construction of 5 Nos. of 33/11kV Electric Substation Building at various locations in Greater Noida.â€</td>
                                <td> NIT No. NPCL/CIV/ESS/FY24-25/GR. NOIDA/016 </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLCIVESSFY24-25GRNOIDA016/CORRIGENDUM-7 - 5 Site Civil Works Dated 10.03.2025.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow114(!show114)}
                        >
                          <b>Corrigendum-2 against NIT No. NPCL/FY24-25/HTCAB/029 Dated 11.02.2025 for â€œTENDER NOTIFICATION FOR ANNUAL RATE CONTRACT OF SUPPLY OF HT and HT ABC CABLE.â€</b>
                        </div>
                        {show114 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 11.02.2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>Corrigendum-2 against NIT No. NPCL/FY24-25/HTCAB/029 Dated 11.02.2025 for â€œTENDER NOTIFICATION FOR ANNUAL RATE CONTRACT OF SUPPLY OF HT and HT ABC CABLE.â€</td>
                                <td> NIT No. NPCL/FY24-25/HTCAB/029 </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY2425HTCAB029/CORRIGENDUM-2- HT Cable Dated 05.03.2025.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow113(!show113)}
                        >
                          <b>Corrigendum-2 against NIT No. NPCL/FY24-25/LTCAB/035 Dated 11.02.2025 for â€œTENDER NOTIFICATION FOR ANNUAL RATE CONTRACT OF SUPPLY OF LT CABLES LOT 2.â€</b>
                        </div>
                        {show113 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 11.02.2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>Corrigendum-2 against NIT No. NPCL/FY24-25/LTCAB/035 Dated 11.02.2025 for â€œTENDER NOTIFICATION FOR ANNUAL RATE CONTRACT OF SUPPLY OF LT CABLES LOT 2.â€</td>
                                <td> NIT No. NPCL/FY24-25/LTCAB/035 </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY2425LTCAB035/CORRIGENDUM-2 - LT Cable Lot 2 Dated 05.03.2025.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow112(!show112)}
                        >
                          <b>NIT No. NPCL/FY24-25/Junction Box 3 Ph SMC /038 Dated 03.03.2025 for â€œRate Contract for the Supply of Junction Box 3 Ph SMC.â€</b>
                        </div>
                        {show112 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 03.03.2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>NIT No. NPCL/FY24-25/Junction Box 3 Ph SMC /038 Dated 03.03.2025 for â€œRate Contract for the Supply of Junction Box 3 Ph SMC.â€</td>
                                <td> NIT No. NPCL/FY24-25/Junction Box 3 Ph SMC /038 </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY24-25JunctionBox3PhSMC038/Bid Document Junction Box.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY24-25JunctionBox3PhSMC038/DWG_300A SMC Junction Box_Controlled Copy.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY24-25JunctionBox3PhSMC038/GTP_300A SMC Junction Box_Controlled Copy.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow111(!show111)}
                        >
                          <b>Corrigendum-1 against NIT No. NPCL/FY24-25/HTCAB/029 Dated 11.02.2025 for â€œTENDER NOTIFICATION FOR ANNUAL RATE CONTRACT OF SUPPLY OF HT and HT ABC CABLE.â€</b>
                        </div>
                        {show111 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 11.02.2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>Corrigendum-1 against NIT No. NPCL/FY24-25/HTCAB/029 Dated 11.02.2025 for â€œTENDER NOTIFICATION FOR ANNUAL RATE CONTRACT OF SUPPLY OF HT and HT ABC CABLE.â€</td>
                                <td> NIT No. NPCL/FY24-25/HTCAB/029 </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY2425HTCAB029/CORRIGENDUM-1 - HT Cable Dated 28.02.25.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow110(!show110)}
                        >
                          <b>Corrigendum-1 against NIT No. NPCL/FY24-25/LTCAB/035 Dated 11.02.2025 for â€œTENDER NOTIFICATION FOR ANNUAL RATE CONTRACT OF SUPPLY OF LT CABLES LOT 2.â€</b>
                        </div>
                        {show110 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 11.02.2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>Corrigendum-1 against NIT No. NPCL/FY24-25/LTCAB/035 Dated 11.02.2025 for â€œTENDER NOTIFICATION FOR ANNUAL RATE CONTRACT OF SUPPLY OF LT CABLES LOT 2.â€</td>
                                <td> NIT No. NPCL/FY24-25/LTCAB/035 </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY2425LTCAB035/CORRIGENDUM-1 - LT Cable Lot 2 Dated 28.02.25.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow109(!show109)}
                        >
                          <b>Corrigendum-1 against NIT No. NPCL/FY24-25/COND/026 Dated 05.02.2025 for â€œTENDER NOTIFICATION FOR 2 YEAR RATE CONTRACT OF SUPPLY OF CONDUCTOR ACSR DOG.â€</b>
                        </div>
                        {show109 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 05.02.2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>Corrigendum-1 against NIT No. NPCL/FY24-25/COND/026 Dated 05.02.2025 for â€œTENDER NOTIFICATION FOR 2 YEAR RATE CONTRACT OF SUPPLY OF CONDUCTOR ACSR DOG.â€</td>
                                <td> NIT No. NPCL/FY24-25/COND/026 </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY24-25COND026/CORRIGENDUM-1 - Conductor ACSR DOG Dated 27.02.25.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow108(!show108)}
                        >
                          <b>Corrigendum-3 against NIT No. NPCL/FY24-25/STP POLE/028 dated 24.01.2025 for â€œ01 Years Rate Contract for the Supply of Pole STP 12 M (SP-62) & Pole STP 13 M (SP-72).â€ </b>
                        </div>
                        {show108 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 27.02.2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>Corrigendum-3 against NIT No. NPCL/FY24-25/STP POLE/028 dated 24.01.2025 for â€œ01 Years Rate Contract for the Supply of Pole STP 12 M (SP-62) & Pole STP 13 M (SP-72)â€ </td>
                                <td> NIT No. NPCL/FY24-25/STP POLE/028 </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY24-25STP%20POLE028/CORRIGENDUM-3%20Dated%2028.02.2025.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow107(!show107)}
                        >
                          <b>Corrigendum-1 against NIT No. NPCL/FY24-25/ meters/024 Dated 27.02.2025 for â€œAnnual Rate Contract for the Supply of meters.â€</b>
                        </div>
                        {show107 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 27.02.2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>Corrigendum-1 against NIT No. NPCL/FY24-25/ meters/024 Dated 27.02.2025 for â€œAnnual Rate Contract for the Supply of meters.â€</td>
                                <td> NIT No. NPCL/FY24-25/ meters/024 </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY24-25meters024/CORRIGENDUM-1%20Dated%2027.02.2025.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow106(!show106)}
                        >
                          <b>NIT No. NPCL/FY24-25/ITOTFW/023 Dated 26.02.2025 for â€œTENDER NOTIFICATION FOR IT-OT FIREWALL (NETWORK & WEB APPLICATION).â€</b>
                        </div>
                        {show106 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 26.02.2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>NIT No. NPCL/FY24-25/ITOTFW/023 Dated 26.02.2025 for â€œTENDER NOTIFICATION FOR IT-OT FIREWALL (NETWORK & WEB APPLICATION).â€</td>
                                <td> NIT No. NPCL/FY24-25/ITOTFW/023 </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY24-25ITOTFW023/Bid Document IT-OT Firewall.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow105(!show105)}
                        >
                          <b>Corrigendum-1 against NIT No. NPCL/FY24-25 /LTCAB/025 Dated 31.01.2025 for â€œTENDER NOTIFICATION FOR ANNUAL RATE CONTRACT OF SUPPLY OF LT CABLES LOT 1.â€</b>
                        </div>
                        {show105 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 31.01.2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>Corrigendum-1 against NIT No. NPCL/FY24-25 /LTCAB/025 Dated 31.01.2025 for â€œTENDER NOTIFICATION FOR ANNUAL RATE CONTRACT OF SUPPLY OF LT CABLES LOT 1.â€</td>
                                <td> NIT No. NPCL/FY24-25 /LTCAB/025 </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY24-25LTCAB025/CORRIGENDUM-1 - LT Cable Lot 1 Dated 24.02.25.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow104(!show104)}
                        >
                          <b>Corrigendum-2 against NIT No. NPCL/FY24-25/STP POLE/028 Dated 24.01.2025 for â€œ01 Years Rate Contract for the Supply of Pole STP 12 M (SP-62) & Pole STP 13 M (SP-72).â€</b>
                        </div>
                        {show104 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 24.01.2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>Corrigendum-1 against NIT No. NPCL/FY24-25/STP POLE/028 Dated 24.01.2025 for â€œ01 Years Rate Contract for the Supply of Pole STP 12 M (SP-62) & Pole STP 13 M (SP-72).â€</td>
                                <td> NIT No. NPCL/FY24-25/STP POLE/028 </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY24-25STP_POLE028/CORRIGENDUM-2 Dated 24.02.2025.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow103(!show103)}
                        >
                          <b>NIT No. NPCL/OTE/FY24-25/GREATER NOIDA/039 Dated 20.02.2025 for â€œRenewal of Insurance for Noida Power Company Limited (NPCL), Greater Noidaâ€.</b>
                        </div>
                        {show103 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 20.02.2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>NIT No. NPCL/OTE/FY24-25/GREATER NOIDA/039 Dated 20.02.2025 for â€œRenewal of Insurance for Noida Power Company Limited (NPCL), Greater Noidaâ€.</td>
                                <td>NIT No. NPCL/OTE/FY24-25/GREATER NOIDA/039</td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLOTEFY24-25GREATERNOIDA039/Tender Document (NIT).pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLOTEFY24-25GREATERNOIDA039/Pre-Bid Clarification Pertaines to Credentials.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLOTEFY24-25GREATERNOIDA039/Pre-Bid Clarification.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow102(!show102)}
                        >
                          <b>Corrigendum-1 against NIT No. NPCL/FY24-25/STP POLE/028 Dated 24.01.2025 for â€œ01 Years Rate Contract for the Supply of Pole STP 12 M (SP-62) & Pole STP 13 M (SP-72).â€</b>
                        </div>
                        {show102 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 24.01.2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>Corrigendum-1 against NIT No. NPCL/FY24-25/STP POLE/028 Dated 24.01.2025 for â€œ01 Years Rate Contract for the Supply of Pole STP 12 M (SP-62) & Pole STP 13 M (SP-72).â€</td>
                                <td> NIT No. NPCL/FY24-25/STP POLE/028 </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY24-25STP_POLE028/CORRIGENDUM-1 Dated 14.02.2025.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow101(!show101)}
                        >
                          <b>Corrigendum-3 against NIT No. NPCL/FY 24-25/HDPE PIPE/031 Dated 24.01.2025 for â€œ01 Years Rate Contract for the Supply of HDPE PIPES OF VARIOUS SIZE, BIS Certified, PE-80(PN 4) AS PER IS 14333-96â€.</b>
                        </div>
                        {show101 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 24-01-2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>NIT No. NPCL/FY 24-25/HDPE PIPE/031 Dated 24.01.2025 for â€œ01 Years Rate Contract for the Supply of HDPE PIPES OF VARIOUS SIZE, BIS Certified, PE-80(PN 4) AS PER IS 14333-96â€.</td>
                                <td> NIT No. NPCL/FY 24-25/HDPE PIPE/031 </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY24-25HDPE_PIPE031/Corrigendum -3 - dated 14.02.2025.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow100(!show100)}
                        >
                          <b>Corrigendum-2 against NIT No. NPCL/FY 24-25/HDPE PIPE/031 Dated 24.01.2025 for â€œ01 Years Rate Contract for the Supply of HDPE PIPES OF VARIOUS SIZE, BIS Certified, PE-80(PN 4) AS PER IS 14333-96â€.</b>
                        </div>
                        {show100 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 24-01-2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>NIT No. NPCL/FY 24-25/HDPE PIPE/031 Dated 24.01.2025 for â€œ01 Years Rate Contract for the Supply of HDPE PIPES OF VARIOUS SIZE, BIS Certified, PE-80(PN 4) AS PER IS 14333-96â€.</td>
                                <td> NIT No. NPCL/FY 24-25/HDPE PIPE/031 </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY24-25HDPE_PIPE031/Corrigendum -2 - dated 12.02.2025.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow99(!show99)}
                        >
                          <b>Corrigendum-6 against NIT No. NPCL/CIV/ESS/FY24-25/GR. NOIDA/016 Dated 10.08.2024 for â€œCivil Construction of 5 Nos. of 33/11kV Electric Substation Building at various locations in Greater Noida.â€</b>
                        </div>
                        {show99 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 09-08-2024</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>Corrigendum-6 against NIT No. NPCL/CIV/ESS/FY24-25/GR. NOIDA/016 Dated 10.08.2024 for â€œCivil Construction of 5 Nos. of 33/11kV Electric Substation Building at various locations in Greater Noida.â€</td>
                                <td> NIT No. NPCL/CIV/ESS/FY24-25/GR. NOIDA/016 </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLCIVESSFY24-25GRNOIDA016/CORRIGENDUM-6 Dated 12.02.2025.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow98(!show98)}
                        >
                          <b>NIT No. NPCL/FY24-25/LTCAB/035 Dated 11.02.2025 for â€œTENDER NOTIFICATION FOR ANNUAL RATE CONTRACT OF SUPPLY OF LT CABLES LOT 2.â€</b>
                        </div>
                        {show98 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 11.02.2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>NIT No. NPCL/FY24-25/LTCAB/035 Dated 11.02.2025 for â€œTENDER NOTIFICATION FOR ANNUAL RATE CONTRACT OF SUPPLY OF LT CABLES LOT 2.â€</td>
                                <td> NIT No. NPCL/FY24-25/LTCAB/035 </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY2425LTCAB035/TENDER NOTIFICATION FOR ARC FOR SUPPLY OF LT CABLES LOT 2.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                                <td>
                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY2425LTCAB035/ZIP.zip"
                                    target="_blank" rel="noreferrer"
                                  >
                                    Tender Documents
                                  </a>
                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow97(!show97)}
                        >
                          <b>NIT No. NPCL/FY24-25/HTCAB/029 Dated 11.02.2025 for â€œTENDER NOTIFICATION FOR ANNUAL RATE CONTRACT OF SUPPLY OF HT and HT ABC CABLE.â€</b>
                        </div>
                        {show97 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 11.02.2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>NIT No. NPCL/FY24-25/HTCAB/029 Dated 11.02.2025 for â€œTENDER NOTIFICATION FOR ANNUAL RATE CONTRACT OF SUPPLY OF HT and HT ABC CABLE.â€</td>
                                <td> NIT No. NPCL/FY24-25/HTCAB/029 </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY2425HTCAB029/TENDER NOTIFICATION FOR ARC FOR SUPPLY OF HT & HT ABC CABLES.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY2425HTCAB029/ZIP.zip"
                                    target="_blank" rel="noreferrer"
                                  >
                                    Tender Documents
                                  </a>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow96(!show96)}
                        >
                          <b>Corrigendum-1 against NIT No. NPCL/FY 24-25/HDPE PIPE/031 Dated 24.01.2025 for â€œ01 Years Rate Contract for the Supply of HDPE PIPES OF VARIOUS SIZE, BIS Certified, PE-80(PN 4) AS PER IS 14333-96â€.</b>
                        </div>
                        {show96 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 24-01-2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>NIT No. NPCL/FY 24-25/HDPE PIPE/031 Dated 24.01.2025 for â€œ01 Years Rate Contract for the Supply of HDPE PIPES OF VARIOUS SIZE, BIS Certified, PE-80(PN 4) AS PER IS 14333-96â€.</td>
                                <td> NIT No. NPCL/FY 24-25/HDPE PIPE/031 </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY24-25HDPE_PIPE031/Corrigendum -1 - dated 05.02.2025.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow95(!show95)}
                        >
                          <b>NIT No. NPCL/FY24-25/ meters/024 Dated 05.02.2025 for â€œAnnual Rate Contract for the Supply of meters.â€</b>
                        </div>
                        {show95 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-6">Tender Description</th>
                                <th className="col-sm-2">NIT No. &nbsp;  Date: 05.02.2025</th>
                                <th className="col-sm-3"></th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>NIT No. NPCL/FY24-25/ meters/024 Dated 05.02.2025 for â€œAnnual Rate Contract for the Supply of meters.â€</td>
                                <td>NIT No. NPCL/FY24-25/ meters/024 </td>
                                <td>
                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY24-25meters024/Meter Tender 1.zip"
                                    target="_blank" rel="noreferrer"
                                  >
                                    Meter Tender
                                  </a>
                                </td>
                                <td>
                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY24-25meters024/Pre Bid Reply.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    Pre Bid Reply against NIT No. NPCL/FY24-25/ meters/024
                                  </a>
                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow94(!show94)}
                        >
                          <b>NIT No. NPCL/FY24-25/COND/026 Dated 05.02.2025 for â€œTENDER NOTIFICATION FOR 2 YEAR RATE CONTRACT OF SUPPLY OF CONDUCTOR ACSR DOG.â€</b>
                        </div>
                        {show94 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 05.02.2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>NIT No. NPCL/FY24-25/COND/026 Dated 05.02.2025 for â€œTENDER NOTIFICATION FOR 2 YEAR RATE CONTRACT OF SUPPLY OF CONDUCTOR ACSR DOG.â€</td>
                                <td> NIT No. NPCL/FY24-25/COND/026 </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY24-25COND026/TENDER NOTIFICATION FOR 2 YEAR RC OF SUPPLY OF CONDUCTOR ACSR DOG.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY24-25COND026/NPCL_Technical Specification_GTP_ Drawing for ACSR Dog Conductor.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow93(!show93)}
                        >
                          <b>NIT No. NPCL/FY24-25 /LTCAB/025 Dated 31.01.2025 for â€œTENDER NOTIFICATION FOR ANNUAL RATE CONTRACT OF SUPPLY OF LT CABLES LOT 1.â€</b>
                        </div>
                        {show93 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 31.01.2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>NIT No. NPCL/FY24-25 /LTCAB/025 Dated 31.01.2025 for â€œTENDER NOTIFICATION FOR ANNUAL RATE CONTRACT OF SUPPLY OF LT CABLES LOT 1.â€</td>
                                <td> NIT No. NPCL/FY24-25 /LTCAB/025 </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY24-25LTCAB025/TENDER NOTIFICATION FOR ARC FOR SUPPLY OF LT CABLES LOT 1.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY24-25LTCAB025/GTP for 1.1 kV 2-Core 6 sqmm XLPE Insulated PVC Sheathed Cable - Controlled Copy.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY24-25LTCAB025/GTP For 1.1kV 4X50 SQ MM CABEL.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow92(!show92)}
                        >
                          <b>NIT No. NPCL/FY24-25/STP POLE/028 Dated 24.01.2025 for â€œ01 Years Rate Contract for the Supply of Pole STP 12 M (SP-62) & Pole STP 13 M (SP-72).â€</b>
                        </div>
                        {show92 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 24.01.2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>NIT No. NPCL/FY24-25/STP POLE/028 Dated 24.01.2025 for â€œ01 Years Rate Contract for the Supply of Pole STP 12 M (SP-62) & Pole STP 13 M (SP-72).â€</td>
                                <td> NIT No. NPCL/FY24-25/STP POLE/028 </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY24-25STP_POLE028/Bid Document STP Pole.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY24-25STP_POLE028/NPCL_Specification_GTP_Drawing_13Mtr SP-72 STP.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY24-25STP_POLE028/NPCL_Specification_GTP_Drawing_12Mtr SP-62 STP.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow91(!show91)}
                        >
                          <b>NIT No. NPCL/FY 24-25/HDPE PIPE/031 Dated 24.01.2025 for â€œ01 Years Rate Contract for the Supply of HDPE PIPES OF VARIOUS SIZE, BIS Certified, PE-80(PN 4) AS PER IS 14333-96â€.</b>
                        </div>
                        {show91 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 24-01-2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>NIT No. NPCL/FY 24-25/HDPE PIPE/031 Dated 24.01.2025 for â€œ01 Years Rate Contract for the Supply of HDPE PIPES OF VARIOUS SIZE, BIS Certified, PE-80(PN 4) AS PER IS 14333-96â€.</td>
                                <td> NIT No. NPCL/FY 24-25/HDPE PIPE/031 </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY24-25HDPE_PIPE031/Tender Documents for HDPE Pipe - 240125.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY24-25HDPE_PIPE031/GTP FOR HDPE PIPE HAVING NOMINAL DIAMATER OF 75 MM110 MM  250MM _CONTROLLED COPY.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow90(!show90)}
                        >
                          <b>Corrigendum-1 against NIT No. NPCL/FY24-25/NAS/027 Dated 21.01.2025 for â€œSupply & Installation of Network Analysis & Planning and GIS Integration softwareâ€.</b>
                        </div>
                        {show90 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 07-01-2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>Corrigendum-1 against NIT No. NPCL/FY24-25/NAS/027 Dated 21.01.2025 for â€œSupply & Installation of Network Analysis & Planning and GIS Integration softwareâ€.</td>
                                <td> NIT No. NPCL/FY24-25/NAS/027 </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY24-25_NAS_027/PRE BID QUERY.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow89(!show89)}
                        >
                          <b>Corrigendum-3 against NIT No. NPCL/FY24-25/ MCB & MCCB /020 Dated 11.12.2024 for â€œ02 Years Rate Contract for the Supply of MCB & MCCB.â€</b>
                        </div>
                        {show89 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 11-12-2024</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>Corrigendum-3 against NIT No. NPCL/FY24-25/ MCB & MCCB /020 Dated 11.12.2024 for â€œ02 Years Rate Contract for the Supply of MCB & MCCB.â€</td>
                                <td> NIT No. NPCL/FY24-25/ MCB & MCCB /020 </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY24-25_MCB_MCCB_020/CORRIGENDUM-3 Dated 13.01.2025.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY24-25_MCB_MCCB_020/GTP for Double Pole MCB having Rated Current up to 63 A - Controlled Copy.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY24-25_MCB_MCCB_020/Prebid Queries.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow88(!show88)}
                        >
                          <b>Corrigendum-2 against NIT No. NPCL/FY24-25/ MCB & MCCB /020 Dated 11.12.2024 for â€œ02 Years Rate Contract for the Supply of MCB & MCCB.â€</b>
                        </div>
                        {show88 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 11-12-2024</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>Corrigendum-2 against NIT No. NPCL/FY24-25/ MCB & MCCB /020 Dated 11.12.2024 for â€œ02 Years Rate Contract for the Supply of MCB & MCCB.â€</td>
                                <td> NIT No. NPCL/FY24-25/ MCB & MCCB /020 </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY24-25_MCB_MCCB_020/CORRIGENDUM-2 Dated 08.01.2025.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow87(!show87)}
                        >
                          <b>NIT No. NPCL/FY24-25/PAFW/021 Dated 07.01.2025 for â€œSUPPLY AND INSTALLATION OF PERIMETER FIREWALL.â€</b>
                        </div>
                        {show87 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 07-01-2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>NOTICE INVITING TENDER FOR â€œSUPPLY AND INSTALLATION OF PERIMETER FIREWALL.â€</td>
                                <td> NIT No. NPCL/FY24-25/PAFW/021 </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY24-25_PAFW_021/Bid Document Perimeter Firewall.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow86(!show86)}
                        >
                          <b>NIT No. NPCL/FY24-25/NAS/027 Dated 07.01.2025 for â€œTENDER NOTIFICATION FOR FOR SUPPLY AND INSTALLATION OF FOLLOWING SOFTWARES:- (I) LICENSES OF SOFTWARE MODULES FOR NETWORK ANALYSIS & PLANNING (II) INTEGRATION SOFTWARE BETWEEN GE SMALLWORLD EO GIS DATABASE & NETWORK ANALYSIS SOFTWARE.â€</b>
                        </div>
                        {show86 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 07-01-2025</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>â€œTENDER NOTIFICATION FOR FOR SUPPLY AND INSTALLATION OF FOLLOWING SOFTWARES:- (I) LICENSES OF SOFTWARE MODULES FOR NETWORK ANALYSIS & PLANNING (II) INTEGRATION SOFTWARE BETWEEN GE SMALLWORLD EO GIS DATABASE & NETWORK ANALYSIS SOFTWARE.â€</td>
                                <td> NIT No. NPCL/FY24-25/NAS/027 </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY24-25_NAS_027/Bid Document.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow85(!show85)}
                        >
                          <b>Corrigendum-1 against NIT No. NPCL/FY24-25/ MCB & MCCB /020 Dated 11.12.2024 for â€œ02 Years Rate Contract for the Supply of MCB & MCCB.â€</b>
                        </div>
                        {show85 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 11-12-2024</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>Corrigendum-1 against NIT No. NPCL/FY24-25/ MCB & MCCB /020 Dated 11.12.2024 for â€œ02 Years Rate Contract for the Supply of MCB & MCCB.â€</td>
                                <td> NIT No. NPCL/FY24-25/ MCB & MCCB /020 </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY24-25_MCB_MCCB_020/CORRIGENDUM-1 Dated 31.12.2024.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow84(!show84)}
                        >
                          <b>Corrigendum-3 against NIT No. NPCL/PRJ/FY24-25/16MVA PTR/019 Dated 03.12.2024 for â€œAUGMENTATION OF POWER TRANSFORMER FROM 12.5MVA TO 16MVA AT 33/11KV SUBSTATIONS.â€</b>
                        </div>
                        {show84 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 03-12-2024</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>Corrigendum-3 against NIT No. NPCL/PRJ/FY24-25/16MVA PTR/019 Dated 03.12.2024 for â€œAUGMENTATION OF POWER TRANSFORMER FROM 12.5MVA TO 16MVA AT 33/11KV SUBSTATIONS.â€</td>
                                <td> NIT No. NPCL/PRJ/FY24-25/16MVA PTR/019 </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLPRJFY24-2516MVAPTR019/CORRIGENDUM-3 Dated 31.12.2024.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow83(!show83)}
                        >
                          <b>Corrigendum-5 against NIT No. NPCL/CIV/ESS/FY24-25/GR. NOIDA/016 Dated 10.08.2024 for â€œCivil Construction of 5 Nos. of 33/11kV Electric Substation Building at various locations in Greater Noida.â€</b>
                        </div>
                        {show83 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 09-08-2024</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>Corrigendum-5 against NIT No. NPCL/CIV/ESS/FY24-25/GR. NOIDA/016 Dated 10.08.2024 for â€œCivil Construction of 5 Nos. of 33/11kV Electric Substation Building at various locations in Greater Noida.â€</td>
                                <td> NIT No. NPCL/CIV/ESS/FY24-25/GR. NOIDA/016 </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLCIVESSFY24-25GRNOIDA016/CORRIGENDUM-5 Dated 27.12.2024.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow82(!show82)}
                        >
                          <b>CORRIGENDUM-2: NIT No. NPCL/PRJ/FY24-25/16MVA PTR/019 Dated 03.12.2024 for â€œAUGMENTATION OF POWER TRANSFORMER FROM 12.5MVA TO 16MVA AT 33/11KV SUBSTATIONS.â€</b>
                        </div>
                        {show82 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 03-12-2024</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>CORRIGENDUM-2: NIT No. NPCL/PRJ/FY24-25/16MVA PTR/019 Dated 03.12.2024 for â€œAUGMENTATION OF POWER TRANSFORMER FROM 12.5MVA TO 16MVA AT 33/11KV SUBSTATIONS.â€</td>
                                <td> NIT No. NPCL/PRJ/FY24-25/16MVA PTR/019 </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLPRJFY24-2516MVAPTR019/CORRIGENDUM-2 Dated 23.12.2024.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow81(!show81)}
                        >
                          <b>CORRIGENDUM-1: NIT No. NPCL/PRJ/FY24-25/16MVA PTR/019 Dated 03.12.2024 for â€œAUGMENTATION OF POWER TRANSFORMER FROM 12.5MVA TO 16MVA AT 33/11KV SUBSTATIONS.â€</b>
                        </div>
                        {show81 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 03-12-2024</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>CORRIGENDUM-1: NIT No. NPCL/PRJ/FY24-25/16MVA PTR/019 Dated 03.12.2024 for â€œAUGMENTATION OF POWER TRANSFORMER FROM 12.5MVA TO 16MVA AT 33/11KV SUBSTATIONS.â€</td>
                                <td> NIT No. NPCL/PRJ/FY24-25/16MVA PTR/019 </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLPRJFY24-2516MVAPTR019/CORRIGENDUM-1 Dated 17.12.2024.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLPRJFY24-2516MVAPTR019/Pre-bid queries.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow80(!show80)}
                        >
                          <b>NIT No. NPCL/FY24-25/ MCB & MCCB /020 for â€œ02 Years Rate Contract for the Supply of MCB & MCCBâ€</b>
                        </div>
                        {show80 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 11-12-2024</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>02 Years Rate Contract for the Supply of MCB & MCCB</td>
                                <td> NIT No. NPCL/FY24-25/ MCB & MCCB /020 </td>
                              </tr>
                            </table>
                            <ul className="tariff_standard">
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY24-25_MCB_MCCB_020/NIT No. NPCL FY24-25 MCB & MCCB 020.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                  NPCL FY24-25 MCB & MCCB 020
                                </a>
                              </li>
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY24-25_MCB_MCCB_020/GTP FOR SINGLE POLE NEUTRAL MCB HAVING RATED CURRENT UP TO 63 A_Controlled copy.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                  GTP FOR SINGLE POLE +NEUTRAL MCB HAVING  RATED CURRENT UP TO 63 A_Controlled
                                </a>
                              </li>
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY24-25_MCB_MCCB_020/GTP FOR SINGLE POLE MCCB HAVING RATED CURRENT UP TO 160 A_Controlled Copy.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                  GTP FOR SINGLE POLE MCCB HAVING RATED CURRENT UP TO 160 A_Controlled
                                </a>
                              </li>

                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY24-25_MCB_MCCB_020/GTP FOR THREE POLE MCCB HAVING RATED CURRENT FROM 160 A TO 630 A_Controlled copy.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                  GTP FOR THREE POLE MCCB HAVING RATED CURRENT FROM 160 A TO 630 A_Controlled
                                </a>
                              </li>
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLFY24-25_MCB_MCCB_020/GTP FOR TRIPPLE POLE NEUTRAL MCB HAVING RATED CURRENT UP TO 63 A_Controlled copy.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                  GTP FOR TRIPPLE POLE +NEUTRAL MCB HAVING RATED CURRENT UP TO 63 A_Controlled
                                </a>
                              </li>
                            </ul>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow79(!show79)}
                        >
                          <b>NIT No. NPCL/PRJ/FY24-25/16MVA PTR/019 for â€œAUGMENTATION OF POWER TRANSFORMER FROM 12.5MVA TO 16MVA AT 33/11KV SUBSTATIONSâ€</b>
                        </div>
                        {show79 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 03-12-2024</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>Notice Inviting Tenders for "AUGMENTATION OF POWER TRANSFORMER FROM 12.5MVA TO 16MVA AT 33/11KV SUBSTATIONS".</td>
                                <td> NIT No. NPCL/PRJ/FY24-25/16MVA PTR/019 </td>
                              </tr>

                            </table>
                            <ul className="tariff_standard">
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLPRJFY24-2516MVAPTR019/Tech Spec_GTP_16 MVA & 20 MVA Power Transformer.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />

                                </a>
                              </li>

                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLPRJFY24-2516MVAPTR019/Bid Document.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />

                                </a>
                              </li>
                            </ul>

                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow78(!show78)}
                        >
                          <b>NIT No. NPCL/PRJ/FY24-25/CIVIL/018/Civil works at three locations of Greater Noida, a) Civil & Interior work to develop office facility at 33/11 kV Substation Building (ESS- 10) in Sector KP-5 b) Civil Work, PEB, EOT Crane & Fire Fighting Work of Kasna Store c) Civil work of Boundary walls for Pocket Substations</b>
                        </div>
                        {show78 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;&nbsp;&nbsp;  Date: 20-11-2024</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>Civil works at three locations of Greater Noida, a) Civil & Interior work to develop office facility at 33/11 kV Substation Building (ESS- 10) in Sector KP-5 b) Civil Work, PEB, EOT Crane & Fire Fighting Work of Kasna Store c) Civil work of Boundary walls for Pocket Substations.</td>
                                <td> NIT No. NPCL/PRJ/FY24-25/CIVIL/018 </td>
                                <td>
                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLPRJFY24-25_CIVIL_018/Drawings.zip"
                                    target="_blank" rel="noreferrer"
                                  >
                                    Drawings
                                  </a>

                                </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLPRJFY24-25_CIVIL_018/Annexure-8 of Bid Document.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />

                                  </a>

                                </td>
                                <td>
                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLPRJFY24-25_CIVIL_018/Annexure-9 of Bid Document.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />

                                  </a>
                                </td>
                                <td>
                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLPRJFY24-25_CIVIL_018/Bid Document.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />

                                  </a>
                                </td>
                                <td>
                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLPRJFY24-25_CIVIL_018/Pre-Bid Queries.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />

                                  </a>
                                </td>
                              </tr>
                            </table>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow77(!show77)}
                        >
                          <b>Corrigendum-4 against NIT No. NPCL/CIV/ESS/FY24-25/GR. NOIDA/016 Dated 10.08.2024 for â€œCivil Construction of 5 Nos. of 33/11kV Electric Substation Building at various locations in Greater Noida.â€</b>
                        </div>
                        {show77 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 09-08-2024</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>Corrigendum-4 against NIT No. NPCL/CIV/ESS/FY24-25/GR. NOIDA/016 Dated 10.08.2024 for â€œCivil Construction of 5 Nos. of 33/11kV Electric Substation Building at various locations in Greater Noida.â€</td>
                                <td> NIT No. NPCL/CIV/ESS/FY24-25/GR. NOIDA/016 </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLCIVESSFY24-25GRNOIDA016/CORRIGENDUM-4_Dated_15.11.2024.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow76(!show76)}
                        >
                          <b>"Request for Selection (RfS) for Long Term Procurement of 300 MW Wind Solar Hybrid Power from Grid Connected Projects Under Tariff Based Competitive Bidding, RfS No: NPCL/LT/Hybrid/24-25 dated 08-November-2024"</b>
                        </div>
                        {show76 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">RfS No. &nbsp;  Date: 08-11-2024</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>Notice Inviting Tenders for "Request for Selection (RfS) for Long Term Procurement of 300 MW Wind Solar Hybrid Power from Grid Connected Projects Under Tariff Based Competitive Bidding, RfS No: NPCL/LT/Hybrid/24-25 dated 08-November-2024".</td>
                                <td> RfS No: NPCL/LT/Hybrid/24-25 </td>
                              </tr>

                            </table>
                            <ul className="tariff_standard">
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLLTHybrid24-25/NPCL_PPA_Final.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                  Draft Power Purchase Document (PPA)
                                </a>
                              </li>

                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLLTHybrid24-25/NPCL_RFS_Final.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                  Request for Selection (Rfs) Document
                                </a>
                              </li>
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLLTHybrid24-25/Addendum-1.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                  Addendum-1
                                </a>
                              </li>

                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLLTHybrid24-25/Annexure-D.xlsx"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/excel-icon.png" alt="" />
                                  Annexure-D
                                </a>
                              </li>
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLLTHybrid24-25/Addendum-3.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                  Amendment to RFS
                                </a>
                              </li>
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLLTHybrid24-25/Addendum-2.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                  Response to the Queries
                                </a>
                              </li>
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLLTHybrid24-25/Reverse Auction (e-RA) Result.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />
                                  Reverse Auction Result
                                </a>
                              </li>
                            </ul>

                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow75(!show75)}
                        >
                          <b>Corrigendum-3 against NIT No. NPCL/CIV/ESS/FY24-25/GR. NOIDA/016 Dated 10.08.2024 for â€œCivil Construction of 5 Nos. of 33/11kV Electric Substation Building at various locations in Greater Noida.â€</b>
                        </div>
                        {show75 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 09-08-2024</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>Corrigendum-3 against NIT No. NPCL/CIV/ESS/FY24-25/GR. NOIDA/016 Dated 10.08.2024 for â€œCivil Construction of 5 Nos. of 33/11kV Electric Substation Building at various locations in Greater Noida.â€</td>
                                <td> NIT No. NPCL/CIV/ESS/FY24-25/GR. NOIDA/016 </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLCIVESSFY24-25GRNOIDA016/CORRIGENDUM-3_Dated_09.10.2024.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow74(!show74)}
                        >
                          <b>Corrigendum-1 against NPCL/AUT/FY24-25/EOI/017 for â€œExpression of Interest from Intended Bidders for leasing Optical Fiber Cable.â€</b>
                        </div>
                        {show74 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 12-09-2024</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>Corrigendum-1 dated 03.10.2024 against NIT No. NPCL/AUT/FY24-25/EOI/017  DT: 11.09.2024 For â€œEXPRESSION OF INTEREST FROM INTENDED BIDDERS FOR LEASING OPTICAL FIBER CABLEâ€. "Bid submission date is extended till 18th Octoberâ€™2024"</td>
                                <td> NIT No. NPCL/AUT/FY24-25/EOI/017 </td>
                                <td>
                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/CORRIGENDUM1.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>
                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow73(!show73)}
                        >
                          <b>NPCL/AUT/FY24-25/EOI/017 for â€œExpression of Interest from Intended Bidders for leasing Optical Fiber Cable.â€</b>
                        </div>
                        {show73 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 12-09-2024</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>NPCL/AUT/FY24-25/EOI/017 for â€œExpression of Interest from Intended Bidders for leasing Optical Fiber Cable.â€</td>
                                <td> NIT No. NPCL/AUT/FY24-25/EOI/017 </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/EOI for leasing OFC.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow72(!show72)}
                        >
                          <b>Corrigendum-2 against NIT No. NPCL/CIV/ESS/FY24-25/GR. NOIDA/016 Dated 10.08.2024 for â€œCivil Construction of 5 Nos. of 33/11kV Electric Substation Building at various locations in Greater Noida.â€</b>
                        </div>
                        {show72 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 09-08-2024</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>Corrigendum-2 against NIT No. NPCL/CIV/ESS/FY24-25/GR. NOIDA/016 Dated 10.08.2024 for â€œCivil Construction of 5 Nos. of 33/11kV Electric Substation Building at various locations in Greater Noida.â€</td>
                                <td> NIT No. NPCL/CIV/ESS/FY24-25/GR. NOIDA/016 </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLCIVESSFY24-25GRNOIDA016/CORRIGENDUM-2_Dated_28.08.2024.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow71(!show71)}
                        >
                          <b>Corrigendum-1 against NIT No. NPCL/CIV/ESS/FY24-25/GR. NOIDA/016 Dated 10.08.2024 for â€œCivil Construction of 5 Nos. of 33/11kV Electric Substation Building at various locations in Greater Noida.â€</b>
                        </div>
                        {show71 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 09-08-2024</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>Corrigendum-1 against NIT No. NPCL/CIV/ESS/FY24-25/GR. NOIDA/016 Dated 10.08.2024 for â€œCivil Construction of 5 Nos. of 33/11kV Electric Substation Building at various locations in Greater Noida.â€</td>
                                <td> NIT No. NPCL/CIV/ESS/FY24-25/GR. NOIDA/016 </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLCIVESSFY24-25GRNOIDA016/CORRIGENDUM-1_Dated_14.08.2024.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow70(!show70)}
                        >
                          <b>NIT No. NPCL/CIV/ESS/FY24-25/GR. NOIDA/016 for â€œCivil Construction of 5 Nos. of 33/11kV Electric Substation Building at various locations in Greater Noidaâ€</b>
                        </div>
                        {show70 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 09-08-2024</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>Notice Inviting Tenders for "Civil Construction of 5 Nos. of 33/11kV Electric Substation Building at various locations in Greater Noida".</td>
                                <td> NIT No. NIT No. NPCL/CIV/ESS/FY24-25/GR. NOIDA/016 </td>
                              </tr>

                            </table>
                            <ul className="tariff_standard">
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLCIVESSFY24-25GRNOIDA016/ANNEXURE-TYPICAL DRAWINGS.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />

                                </a>
                              </li>

                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NPCLCIVESSFY24-25GRNOIDA016/Bid Document.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />

                                </a>
                              </li>
                            </ul>

                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow69(!show69)}
                        >
                          <b>NOTIFICATION for CORRIGENDUM-4: NIT No. NPCL/AUT/FY24-25/Meter Test Bench Cl:0.02, Position:10 /015 dated 02.05.2024 for â€œPROCUREMENT OF 10 POSITION FULLY AUTOMATIC METER TESTING EQUIPMENT WITH REFERENCE METER OF CLASS 0.02â€</b>
                        </div>
                        {show69 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 02.05.2024</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>Corrigendum-4 against NIT No. NPCL/AUT/FY24-25/Meter Test Bench Cl:0.02, Position:10 /015 dated 02.05.2024 for â€œPROCUREMENT OF 10 POSITION FULLY AUTOMATIC METER TESTING EQUIPMENT WITH REFERENCE METER OF CLASS 0.02â€</td>
                                <td> NIT No. NPCL/AUT/FY24-25/Meter Test Bench Cl:0.02, Position:10 /015 </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NITNo_NPCLAUTFY24-25Meter_Test BenchCl002_Position10015/CORRIGENDUM-4_Dated_22.07.24.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow68(!show68)}
                        >
                          <b>NOTIFICATION for CORRIGENDUM-2: NIT No. NPCL/AUT/FY24-25/Meter Test Bench Cl:0.02, Position:10 /015 dated 02.05.2024 for â€œPROCUREMENT OF 10 POSITION FULLY AUTOMATIC METER TESTING EQUIPMENT WITH REFERENCE METER OF CLASS 0.02â€</b>
                        </div>
                        {show68 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 02.05.2024</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>Corrigendum-2 against NIT No. NPCL/AUT/FY24-25/Meter Test Bench Cl:0.02, Position:10 /015 dated 02.05.2024 for â€œPROCUREMENT OF 10 POSITION FULLY AUTOMATIC METER TESTING EQUIPMENT WITH REFERENCE METER OF CLASS 0.02â€</td>
                                <td> NIT No. NPCL/AUT/FY24-25/Meter Test Bench Cl:0.02, Position:10 /015 </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NITNo_NPCLAUTFY24-25Meter_Test BenchCl002_Position10015/CORRIGENDUM-2_Dated_14.06.24.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow67(!show67)}
                        >
                          <b>NOTIFICATION for CORRIGENDUM-3: NIT No. NPCL/PRJ/FY24-25/EPC/013 DATED 18.04.2024 for â€œSupply of Balance of Plant and Erection, Testing & Commissioning of 33/11kV Substations and 33kV Switching Stations at Greater Noidaâ€</b>
                        </div>
                        {show67 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 18.04.2024</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>Corrigendum-3 against NIT No. NPCL/PRJ/FY24-25/EPC/013 DATED 18.04.2024 for â€œSupply of Balance of Plant and Erection, Testing & Commissioning of 33/11kV Substations and 33kV Switching Stations at Greater Noidaâ€</td>
                                <td> NIT No. NPCL/PRJ/FY24-25/EPC/013 </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NIT_No-NPCLPRJFY24-25EPC-013/CORRIGENDUM-3_Dated_30.05.2024.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow66(!show66)}
                        >
                          <b>NOTIFICATION for CORRIGENDUM-1: NIT No. NPCL/AUT/FY24-25/Meter Test Bench Cl:0.02, Position:10 /015 dated 02.05.2024 for â€œPROCUREMENT OF 10 POSITION FULLY AUTOMATIC METER TESTING EQUIPMENT WITH REFERENCE METER OF CLASS 0.02â€</b>
                        </div>
                        {show66 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 02.05.2024</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>Corrigendum-1 against NIT No. NPCL/AUT/FY24-25/Meter Test Bench Cl:0.02, Position:10 /015 dated 02.05.2024 for â€œPROCUREMENT OF 10 POSITION FULLY AUTOMATIC METER TESTING EQUIPMENT WITH REFERENCE METER OF CLASS 0.02â€</td>
                                <td> NIT No. NPCL/AUT/FY24-25/Meter Test Bench Cl:0.02, Position:10 /015 </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NITNo_NPCLAUTFY24-25Meter_Test BenchCl002_Position10015/CORRIGENDUM-1_dt_22.05.24.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow65(!show65)}
                        >
                          <b>NOTIFICATION for CORRIGENDUM-2: NIT No. NPCL/PRJ/FY24-25/EPC/013 DATED 18.04.2024 for â€œSupply of Balance of Plant and Erection, Testing & Commissioning of 33/11kV Substations and 33kV Switching Stations at Greater Noidaâ€</b>
                        </div>
                        {show65 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 18.04.2024</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>Corrigendum-2 against NIT No. NPCL/PRJ/FY24-25/EPC/013 DATED 18.04.2024 for â€œSupply of Balance of Plant and Erection, Testing & Commissioning of 33/11kV Substations and 33kV Switching Stations at Greater Noidaâ€</td>
                                <td> NIT No. NPCL/PRJ/FY24-25/EPC/013 </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NIT_No-NPCLPRJFY24-25EPC-013/CORRIGENDUM-2_Dated_20.05.2024.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow64(!show64)}
                        >
                          <b>NOTIFICATION for CORRIGENDUM-1: NIT No. NPCL/PRJ/FY24-25/EPC/013 DATED 18.04.2024 for â€œSupply of Balance of Plant and Erection, Testing & Commissioning of 33/11kV Substations and 33kV Switching Stations at Greater Noidaâ€</b>
                        </div>
                        {show64 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 18.04.2024</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>Corrigendum-1 against NIT No. NPCL/PRJ/FY24-25/EPC/013 DATED 18.04.2024 for â€œSupply of Balance of Plant and Erection, Testing & Commissioning of 33/11kV Substations and 33kV Switching Stations at Greater Noidaâ€</td>
                                <td> NIT No. NPCL/PRJ/FY24-25/EPC/013 </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NIT_No-NPCLPRJFY24-25EPC-013/CORRIGENDUM-1_Dated_09.05.24.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow63(!show63)}
                        >
                          <b>NOTIFICATION for CORRIGENDUM-1: NIT No. NPCL/PRJ/FY24-25/33 & 11KV AIS/012 DATED 18.04.2024 for â€œSUPPLY OF 1250 AMPS 33kV AIS INDOOR SWITCHBOARD WITH TRANSFORMER PROTECTION & 1250 AMPS 11kV INDOOR AIR INSULATED SWITCHGEARâ€</b>
                        </div>
                        {show63 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 18.04.2024</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>Corrigendum-1 against NIT No. NPCL/PRJ/FY24-25/33 & 11KV AIS/012 DATED 18.04.2024 for â€œSUPPLY OF 1250 AMPS 33kV AIS INDOOR SWITCHBOARD WITH TRANSFORMER PROTECTION & 1250 AMPS 11kV INDOOR AIR INSULATED SWITCHGEARâ€</td>
                                <td> NIT No. NPCL/PRJ/FY24-25/33 & 11KV AIS/012 </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NIT-No-NPCLPRJFY24-2533&11KVAIS-012/CORRIGENDUM-1_Dated_08.05.24_AIS.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow62(!show62)}
                        >
                          <b>NOTIFICATION for CORRIGENDUM-1: NIT No. NPCL/PRJ/FY24-25/GIS/011 DATED 18.04.2024 for â€œSUPPLY AND ETC OF 33KV DOUBLE BUS INDOOR GAS INSULATED SWITCHGEAR (9 PANEL BOARDS)â€</b>
                        </div>
                        {show62 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 03-05-2024</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>Corrigendum-1 against NIT No. NPCL/PRJ/FY24-25/GIS/011 DATED 18.04.2024 for â€œSUPPLY AND ETC OF 33KV DOUBLE BUS INDOOR GAS INSULATED SWITCHGEAR (9 PANEL BOARDS)â€</td>
                                <td> NIT No. NPCL/PRJ/FY24-25/GIS/011 </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NIT-No-NPCLPRJFY24-25GIS-011/CORRIGENDUM-1_Dated_08.05.24_GIS.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow61(!show61)}
                        >
                          <b>NOTIFICATION for CORRIGENDUM-1: NIT No. NPCL/PRJ/FY24-25/PTR/010 Dated 18.04.2024 for â€œSUPPLY OF 33/11 kV 12.5 MVA Power Transformersâ€</b>
                        </div>
                        {show61 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 18.04.2024</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>Corrigendum-1 against NIT No. NPCL/PRJ/FY24-25/PTR/010 Dated 18.04.2024 for â€œSUPPLY OF 33/11 kV 12.5 MVA Power Transformersâ€</td>
                                <td> NIT No. NPCL/PRJ/FY24-25/PTR/010 </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NIT-No-NPCLPRJFY24-25PTR-010/CORRIGENDUM_1_Dated_08.05.24_PTR.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow60(!show60)}
                        >
                          <b>NIT No. NPCL/AUT/FY24-25/Meter Test Bench Cl:0.02, Position:10 /015 for â€œPROCUREMENT OF 10 POSITION FULLY AUTOMATIC METER TESTING EQUIPMENT WITH REFERENCE METER OF CLASS 0.02â€</b>
                        </div>
                        {show60 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 03-05-2024</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>Notice Inviting Tenders for "PROCUREMENT OF 10 POSITION FULLY AUTOMATIC METER TESTING EQUIPMENT WITH REFERENCE METER OF CLASS 0.02".</td>
                                <td> NIT No. NPCL/AUT/FY24-25/Meter Test Bench Cl:0.02, Position:10 /015 </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NITNo_NPCLAUTFY24-25Meter_Test BenchCl002_Position10015/RFP for Meter_Test_Bench.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow59(!show59)}
                        >
                          <b>NIT No. NPCL/AUT/FY24-25/TESTING OF HT METERING SYSTEM/014 for â€œTESTING OF HT METERING SYSTEMâ€</b>
                        </div>
                        {show59 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 19-04-2024</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>Notice Inviting Tenders for "TESTING OF HT METERING SYSTEM".</td>
                                <td> NIT No. NPCL/AUT/FY24-25/TESTING OF HT METERING SYSTEM/014 </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NIT-No-NPCLAUTFY24-25TESTINGOFHTMETERINGSYSTEM-014/Testing of HT connection-RFP-F.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow58(!show58)}
                        >
                          <b> NIT No. NPCL/PRJ/FY24-25/EPC/013 for â€œSupply of Balance of Plant and Erection, Testing & Commissioning of 33/11kV Substations and 33kV Switching Stations at Greater Noidaâ€ </b>
                        </div>
                        {show58 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 18-04-2024</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>Notice Inviting Tenders for "Supply of Balance of Plant and Erection, Testing & Commissioning of 33/11kV Substations and 33kV Switching Stations at Greater Noida".</td>
                                <td>NIT No. NPCL/PRJ/FY24-25/EPC/013</td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NIT_No-NPCLPRJFY24-25EPC-013/Bid Document_Balance of Plant.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NIT_No-NPCLPRJFY24-25EPC-013/Technical Specifications.zip"
                                    target="_blank" rel="noreferrer"
                                  >
                                    Technical Specifications
                                  </a>

                                </td>
                              </tr>

                            </table>


                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow57(!show57)}
                        >
                          <b>NIT No. NPCL/PRJ/FY24-25/33 & 11KV AIS/012 for "SUPPLY OF  1250 AMPS 33kV AIS INDOOR SWITCHBOARD WITH TRANSFORMER PROTECTION & 1250 AMPS 11kV INDOOR AIR INSULATED SWITCHGEAR" </b>
                        </div>
                        {show57 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-7">Tender Description</th>
                                <th className="col-sm-4">NIT No. &nbsp;  Date: 18-04-2024</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td> Notice Inviting Tenders for "SUPPLY OF  1250 AMPS 33kV AIS INDOOR SWITCHBOARD WITH TRANSFORMER PROTECTION & 1250 AMPS 11kV INDOOR AIR INSULATED SWITCHGEAR".</td>
                                <td> NIT No. NPCL/PRJ/FY24-25/33 & 11KV AIS/012 </td>
                              </tr>

                            </table>
                            <ul className="tariff_standard">
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NIT-No-NPCLPRJFY24-2533&11KVAIS-012/Bid Document_AIS.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />

                                </a>
                              </li>

                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NIT-No-NPCLPRJFY24-2533&11KVAIS-012/TS_GTP_33KV_AIS_CONTROLLED_REV_A.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />

                                </a>
                              </li>

                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NIT-No-NPCLPRJFY24-2533&11KVAIS-012/TS_GTP_11KV_AIS_CONTROLLED_REV_B.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />

                                </a>
                              </li>
                            </ul>

                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow56(!show56)}
                        >
                          <b>NIT No. NPCL/PRJ/FY24-25/GIS/011 for "SUPPLY AND ETC OF 33KV DOUBLE BUS INDOOR GAS INSULATED SWITCHGEAR (9 PANEL BOARDS)" </b>
                        </div>
                        {show56 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-7">Tender Description</th>
                                <th className="col-sm-4">NIT No. &nbsp;  Date: 18-04-2024</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td> Notice Inviting Tenders for "SUPPLY AND ETC OF 33KV DOUBLE BUS INDOOR GAS INSULATED SWITCHGEAR (9 PANEL BOARDS)".</td>
                                <td> NIT No. NPCL/PRJ/FY24-25/GIS/011 </td>
                              </tr>

                            </table>
                            <ul className="tariff_standard">
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NIT-No-NPCLPRJFY24-25GIS-011/Bid Document_GIS.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />

                                </a>
                              </li>

                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NIT-No-NPCLPRJFY24-25GIS-011/TS_GTP_33KV_DOUBLE_BUS_GIS_CONTROLLED_R-B.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />

                                </a>
                              </li>
                            </ul>

                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow55(!show55)}
                        >
                          <b>NIT No. NPCL/PRJ/FY24-25/PTR/010 for "SUPPLY OF 33/11 kV 12.5 MVA Power Transformers" </b>
                        </div>
                        {show55 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-7">Tender Description</th>
                                <th className="col-sm-4">NIT No. &nbsp;  Date: 18-04-2024</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td> Notice Inviting Tenders for "SUPPLY OF 33/11 kV 12.5 MVA Power Transformers".</td>
                                <td> NIT No. NPCL/PRJ/FY24-25/PTR/010 </td>
                              </tr>

                            </table>
                            <ul className="tariff_standard">
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NIT-No-NPCLPRJFY24-25PTR-010/Bid Document_PTR.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />

                                </a>
                              </li>

                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NIT-No-NPCLPRJFY24-25PTR-010/ANNEXURE-1 TS_12.5MVA_33_11kV_ONAN_Three_Phase_Power_Transformer.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />

                                </a>
                              </li>
                            </ul>

                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow54(!show54)}
                        >
                          <b>NOTIFICATION for CORRIGENDUM-1: NIT No. NPCL/CIV/ESS/FY24-25/GR. NOIDA/009 </b>
                        </div>
                        {show54 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3">NIT No. &nbsp;  Date: 29-03-2024</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td> Corrigendum-1 against NIT No. NPCL/CIV/ESS/FY24-25/GR. NOIDA/009 Dated 29.03.2024 for â€œCivil Construction of 5 Nos. of 33/11kV Electric Substation cum 33kV Switching Station and 33kV Switching Station Building at various locations in Greater Noidaâ€.</td>
                                <td> NIT No. NPCL/CIV/ESS/FY24-25/GR. NOIDA/009 </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/NIT-No-NPCLCIVESSFY24-25GRNOIDA-009/CORRIGENDUM-1.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow53(!show53)}
                        >
                          <b>NIT No. NPCL/CIV/ESS/FY24-25/GR. NOIDA/009 for "Civil Construction of 5 Nos. of 33/11kV Electric Substation cum 33kV Switching Station and 33kV Switching Station Building at various locations in Greater Noida" </b>
                        </div>
                        {show53 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-7">Tender Description</th>
                                <th className="col-sm-4">NIT No. &nbsp;  Date: 29-03-2024</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td> Notice Inviting Tenders for "Civil Construction of 5 Nos. of 33/11kV Electric Substation cum 33kV Switching Station and 33kV Switching Station Building at various locations in Greater Noida".</td>
                                <td> NIT No. NPCL/CIV/ESS/FY24-25/GR. NOIDA/009 </td>
                              </tr>

                            </table>
                            <ul className="tariff_standard">
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NIT-No-NPCLCIVESSFY24-25GRNOIDA-009/Bid Document for GR NOIDA009.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />


                                </a>
                              </li>

                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NIT-No-NPCLCIVESSFY24-25GRNOIDA-009/ANNEXURE-TYPICAL DRAWINGS.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />

                                  {/* ANNEXURE-TYPICAL DRAWINGS */}
                                </a>
                              </li>
                            </ul>

                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow51(!show51)}
                        >
                          <b> NOTIFICATION for Corrigendum-1 :(NIT No. NPCL/EPC/ESS/FY23-24/GR. NOIDA/007)  </b>
                        </div>
                        {show51 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3"> NIT No. </th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td> Corrigendum-1 against NIT No. NPCL/EPC/ESS/FY23-24/GR. NOIDA/007 dated 28.09.2023 for " Supply, Installation, Testing and Commissioning including all necessary Civil Works for 33/11 kV Substation cum 33kV Switching Stations and 33kV Switching Stations in various sectors of Greater Noida City" .
                                </td>
                                <td>
                                  NIT No. NPCL/EPC/ESS/FY23-24/GR. NOIDA/007

                                </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/12-10/CORRIGENDUM-1%20dt%2012.10.23.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/12-10/Proposed Substation Layout & SLD.rar"
                                    target="_blank" rel="noreferrer"
                                  >
                                    Substation Proposed Layouts & SLDs
                                  </a>

                                </td>
                              </tr>

                            </table>


                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow50(!show50)}
                        >
                          <b> NIT No. NPCL/EPC/ESS/FY23-24/GR. NOIDA/007 for â€œSupply, Installation, Testing and Commissioning including all necessary Civil Works for 33/11 kV Substation cum 33kV Switching Stations and 33kV Switching Stations in various sectors of Greater Noida Cityâ€ </b>
                        </div>
                        {show50 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3"> NIT No. </th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td> TENDER NOTIFICATION For â€œSupply, Installation, Testing and Commissioning including all necessary Civil Works for 33/11 kV Substation cum 33kV Switching Stations and 33kV Switching Stations in various sectors of Greater Noida City ".
                                </td>
                                <td>
                                  NIT No. NPCL/EPC/ESS/FY23-24/GR. NOIDA/007 Dated 28.09.2023

                                </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/12-08/Bid Document for Turnkey EPC Project 28-09-2023.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/12-08/SECTION-XI.rar"
                                    target="_blank" rel="noreferrer"
                                  >
                                    SECTION-XI
                                  </a>

                                </td>
                              </tr>

                            </table>


                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow49(!show49)}
                        >
                          <b> Notification for Corrigendum 2: (NIT No: Notification for Corrigendum 2: (NIT No: NPCL/AUT/FY23-24/P2P ET/006)) </b>
                        </div>
                        {show49 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3"> NPCL/AUT/FY23-24/P2P ET/006 </th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td> Corrigendum-2 against NIT No: NPCL/AUT/FY23-24/P2P ET/006 DT: 16.08.2023 For " Expression of Interest(EOI)-For P2P Energy Trading using Blockchainâ€, technical queries & addendum document is attached for reference. </td>
                                <td>
                                  NPCL/AUT/FY23-24/P2P ET/006
                                </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/12-08/Corrigendum 2_NIT No_NPCL_AUT_FY23-24_P2P ET_006.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/12-08/Technical Queries for NIT No. NPCL_AUT_FY23-24_P2P_ ET006.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>


                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div className="card-header"
                          onClick={() => setShow48(!show48)}
                        >
                          <b> NIT No: NPCL/CIV/ESS/FY23-24/SECTOR-01 </b>
                        </div>
                        {show48 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>

                                <th className="col-sm-11">Tender Description</th>

                              </tr>
                              <tr>
                                <td> Following is the Technically Qualified bidder for NIT No.: NPCL/CIV/ESS/FY23-24/SECTOR-01 dated: 06.07.2023 for " Civil Construction of 33/11kV Electric Substation cum 33kV Switching Station Building with Outdoor Transformer Yard & Boundary Wall at Sector-01, Greater Noida " </td>
                              </tr>
                              <tr>
                                <td>
                                  <strong> 1. M/s Sanmul Construction P. Ltd.   </strong>
                                </td>
                              </tr>
                            </table>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow47(!show47)}
                        >
                          <b> NIT No: NPCL/CIV/ESS/FY23-24/SECTOR-10 </b>
                        </div>
                        {show47 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>

                                <th className="col-sm-11">Tender Description</th>

                              </tr>
                              <tr>

                                <td> Following are the Technically Qualified bidders for NIT No.: NPCL/CIV/ESS/FY23-24/SECTOR-10 dated: 06.07.2023 for " Civil Construction of 33/11kV Electric Substation cum 33kV Switching Station Building with Outdoor Transformer Yard at Sector-10, Greater Noida " </td>


                              </tr>

                              <tr>

                                <td>

                                  <strong> 1. M/s Intercon Buildtech P. Ltd.  </strong>
                                  <strong> 2. M/s Sanmul Construction P. Ltd.   </strong>

                                </td>
                              </tr>

                            </table>


                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow46(!show46)}
                        >
                          <b> NIT No: NPCL/CIV/ESS/FY23-24/ECOTECH-10 </b>
                        </div>
                        {show46 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>

                                <th className="col-sm-11">Tender Description</th>

                              </tr>
                              <tr>

                                <td> Following are the Technically Qualified bidders for NIT No.: NPCL/CIV/ESS/FY23-24/ECOTECH-10 dated: 06.07.2023 for " Civil Construction of 33/11kV Electric Substation cum 33kV Switching Station Building with Outdoor Transformer Yard & Boundary Wall at Sector Ecotech-10, Greater Noida " </td>


                              </tr>

                              <tr>

                                <td>

                                  <strong> 1. M/s Intercon Buildtech P. Ltd.  </strong>
                                  <strong> 2. M/s Sanmul Construction P. Ltd.   </strong>

                                </td>
                              </tr>

                            </table>


                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow45(!show45)}
                        >
                          <b> NIT No: NPCL/CIV/ESS/FY23-24/SECTOR-04 </b>
                        </div>
                        {show45 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>

                                <th className="col-sm-8">Tender Description</th>

                              </tr>
                              <tr>

                                <td> Following are the Technically Qualified bidders for NIT No.: NPCL/CIV/ESS/FY23-24/SECTOR-04 dated: 06.07.2023 for " Civil Construction of 33/11kV Electric Substation cum 33kV Switching Station Building with Outdoor Transformer Yard & Boundary Wall at Sector-04, Greater Noida " </td>


                              </tr>

                              <tr>

                                <td>

                                  <strong> 1. M/s Intercon Buildtech P. Ltd.  </strong>
                                  <strong> 2. M/s Sanmul Construction P. Ltd.   </strong>

                                </td>
                              </tr>


                            </table>


                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow44(!show44)}
                        >
                          <b> Notification for Corrigendum 1: (NIT No: NPCL/AUT/FY23-24/P2P ET/006) </b>
                        </div>
                        {show44 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3"> NPCL/AUT/FY23-24/P2P ET/006 </th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td> Corrigendum-1 against NIT No: NPCL/AUT/FY23-24/P2P ET/006 DT: 16.08.2023 For " Expression of Interest(EOI)-For P2P Energy Trading using Blockchain." <b>"Bid submission date is extended till 19th-October-2023."</b></td>
                                <td>
                                  NPCL/AUT/FY23-24/P2P ET/006
                                </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/12-08/NIT for P2P.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/12-08/Corrigendum Document.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>


                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow43(!show43)}
                        >
                          <b> Notification for Corrigendum 3: (NPCL/PRJ/FY23-24/11KVAIS/004) </b>
                        </div>
                        {show43 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3"> NPCL/PRJ/FY23-24/11KVAIS/004 </th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td> Corrigendum-3 dated 23.08.2023 against NIT No. NPCL/PRJ/FY23-24/11KVAIS/004 DT: 10.07.2023 For â€˜â€™ SUPPLY OF 1250 AMPS 11kV INDOOR AIR INSULATED SWITCHGEAR." "Bid submission date is extended till 28th-August-2023."</td>
                                <td>
                                  NPCL/PRJ/FY23-24/11KVAIS/004
                                </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/12-08/EXTENSION IN BID SUBMISSION DATE NPCL PRJ FY 23_24 11 kV AIS 004.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>


                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow42(!show42)}
                        >
                          <b> Notification for Corrigendum 3 : (NPCL/PRJ/FY23-24/33KVAIS/003) </b>
                        </div>
                        {show42 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3"> NPCL/PRJ/FY23-24/33KVAIS/003</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td> Corrigendum-3 dated 23.08.2023 against NIT No. Tender Enquiry No.: NPCL/PRJ/FY23-24/33KVAIS/003 for 1250 AMPS 33kV AIS INDOOR SWITCHBOARD WITH TRANSFORMER PROTECTION " "Bid submission date is extended till 28th-August-2023."</td>
                                <td>
                                  NPCL/PRJ/FY23-24/33KVAIS/003
                                </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/12-08/EXTENSION IN BID SUBMISSION DATE NPCL PRJ FY 23_24 33 kV AIS 003.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>


                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow41(!show41)}
                        >
                          <b> Notification for Corrigendum 3: (NIT no. NPCL/PRJ/FY23-24/GIS/002) </b>
                        </div>
                        {show41 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3"> NIT no. NPCL/PRJ/FY23-24/GIS/002 </th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td> Corrigendum-3 dated 23.08.2023 against NIT No.: NPCL/PRJ/FY23-24/GIS/002 for 33KV DOUBLE BUS INDOOR GAS INSULATED SWITCHGEAR (9 PANEL BOARDS) "Bid submission date is extended till 28th-August-2023."</td>
                                <td>
                                  NIT no. NPCL/PRJ/FY23-24/GIS/002
                                </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/12-08/EXTENSION IN BID SUBMISSION DATE NPCL PRJ FY23_ 24 GIS 002.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>


                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow40(!show40)}
                        >
                          <b> Tender Notification for "Expression of Interest(EOI)-For P2P Energy Trading using Blockchain" </b>
                        </div>
                        {show40 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-8">Tender Description</th>
                                <th className="col-sm-3"> NIT No. Dated 16.08.2023 </th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td> Notice Inviting Tenders for â€œExpression of Interest(EOI)-For P2P Energy Trading using Blockchain.</td>
                                <td>
                                  NPCL/AUT/FY23-24/P2P ET/006
                                </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/12-08/EOI.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>


                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow39(!show39)}
                        >
                          <b>Notification for Corrigendum 2: (NIT No: NPCL/PRJ/FY23-24/CAB/005)</b>
                        </div>
                        {show39 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-10">Tender Description</th>
                                <th className="col-sm-1">  </th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>Corrigendum-2 against NIT No: NPCL/PRJ/FY23-24/CAB/005 DT: 10.07.2023 For " SUPPLY OF 33kV 3C X 400 SQ. MM ALUMINIUM XLPE GRADE CABLE & 11kV 3C X 300 SQ. MM ALUMINIUM XLPE GRADE CABLE." "Bid submission date is extended till 23rd-August-2023."</td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/12-08/NIT for Cable.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>


                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow38(!show38)}
                        >
                          <b>Notification for Corrigendum 2: (NIT no. NPCL/PRJ/FY23-24/GIS/002)</b>
                        </div>
                        {show38 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-10">Tender Description</th>
                                <th className="col-sm-1">  </th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>Corrigendum-2 against NIT No: NPCL/PRJ/FY23-24/GIS/002 DT: 10.07.2023 For " SUPPLY & ETC OF 33KV DOUBLE BUS INDOOR GAS INSULATED SWITCHGEAR (9 PANEL BOARDS." "Bid submission date is extended till 23rd-August-2023."</td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/12-08/NIT for 33KV GIS.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>


                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow37(!show37)}
                        >
                          <b> Notification for Corrigendum 2 (NIT No. NPCL/PRJ/FY23-24/PTR/001) </b>
                        </div>
                        {show37 ? (
                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-10">Tender Description</th>
                                <th className="col-sm-1">  </th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>Corrigendum-2 against NIT No: NPCL/PRJ/FY23-24/PTR/001 DT: 10.07.2023 For " SUPPLY OF 33/11 kV 12.5 MVA Power Transformers." "Bid submission date is extended till 23rd-August-2023." </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/12-08/NIT for PTR.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>


                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow36(!show36)}
                        >
                          <b> Notification for Corrigendum 2: (NPCL/PRJ/FY23-24/33KVAIS/003) </b>
                        </div>
                        {show36 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-10">Tender Description</th>
                                <th className="col-sm-1">  </th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td> Corrigendum-2 against NIT No: NPCL/PRJ/FY23-24/33KVAIS/003 DT: 10.07.2023 For " SUPPLY OF 1250 AMPS 33kV AIS INDOOR SWITCHBOARD WITH TRANSFORMER PROTECTION." "Bid submission date is extended till 23rd-August-2023." </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/12-08/NIT for 33KV AIS.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>


                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow35(!show35)}
                        >
                          <b>Notification for Corrigendum 2: (NPCL/PRJ/FY23-24/11KVAIS/004)</b>
                        </div>
                        {show35 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-10">Tender Description</th>
                                <th className="col-sm-1">  </th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td> Corrigendum-2 against NIT No: NPCL/PRJ/FY23-24/11KVAIS/004 DT: 10.07.2023 For " SUPPLY OF 1250 AMPS 11kV INDOOR AIR INSULATED SWITCHGEAR." "Bid submission date is extended till 23rd-August-2023." </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/12-08/NIT for 11KV AISY.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>


                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow34(!show34)}
                        >
                          <b> Notification for Corrigendum2: (: NIT No: NPCL/CIV/ESS/FY23-24/SECTOR-01)</b>
                        </div>
                        {show34 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-10">Tender Description</th>
                                <th className="col-sm-1">  </th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td> Corrigendum-2 against NIT No: NPCL/CIV/ESS/FY23-24/SECTOR-01 DT: 06.07.2023 For "Civil Construction of 33/11kV Electric Substation cum 33kV Switching Station Building with Outdoor Transformer Yard & Boundary Wall at Sector-01, Greater Noida." "Bid submission date is extended till 22nd-August-2023."</td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/06-07/NIT for SECTOR 01.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>


                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow33(!show33)}
                        >
                          <b> Notification for Corrigendum2: (NIT No: NPCL/CIV/ESS/FY23-24/ECOTECH-08)</b>
                        </div>
                        {show33 ? (
                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-10">Tender Description</th>
                                <th className="col-sm-1">  </th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>Corrigendum-2 against NIT No: NPCL/CIV/ESS/FY23-24/ECOTECH-08 DT: 06.07.2023 For " Civil Construction of 33/11kV Electric Substation cum 33kV Switching Station Building with Outdoor Transformer Yard & Boundary Wall at Sector Ecotech-08, Greater Noida, Greater Noida." "Bid submission date is extended till 22nd-August-2023." </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/06-07/NIT for ECOTECH 08.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>


                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow32(!show32)}
                        >
                          <b> Notification for Corrigendum2: (NIT No: NPCL/CIV/ESS/FY23-24/ECOTECH-10) </b>
                        </div>
                        {show32 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-10">Tender Description</th>
                                <th className="col-sm-1">  </th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td> Corrigendum-2 against NIT No: NPCL/CIV/ESS/FY23-24/ECOTECH-10 DT: 06.07.2023 For " Civil Construction of 33/11kV Electric Substation cum 33kV Switching Station Building with Outdoor Transformer Yard & Boundary Wall at Sector Ecotech-10, Greater Noida." "Bid submission date is extended till 22nd-August-2023." </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/06-07/NIT for ECOTECH 10.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>


                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow31(!show31)}
                        >
                          <b>Notification for Corrigendum2: (NIT No: NPCL/CIV/ESS/FY23-24/SECTOR-04)</b>
                        </div>
                        {show31 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-10">Tender Description</th>
                                <th className="col-sm-1">  </th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td> Corrigendum-2 against NIT No: NPCL/CIV/ESS/FY23-24/SECTOR-04 DT: 06.07.2023 For "Civil Construction of 33/11kV Electric Substation cum 33kV Switching Station Building with Outdoor Transformer Yard & Boundary Wall at Sector-04, Greater Noida." "Bid submission date is extended till 22nd-August-2023." </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/06-07/NIT for SECTOR 04.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>


                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow30(!show30)}
                        >
                          <b> Notification for Corrigendum2 (NIT No: NPCL/CIV/ESS/FY23-24/SECTOR-10) </b>
                        </div>
                        {show30 ? (
                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-10">Tender Description</th>
                                <th className="col-sm-1">  </th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td> Corrigendum-2 against NIT No: NPCL/CIV/ESS/FY23-24/SECTOR-10 DT: 06.07.2023 For " Civil Construction of 33/11kV Electric Substation cum 33kV Switching Station Building with Outdoor Transformer Yard at Sector-10, Greater Noida." "Bid submission date is extended till 22nd-August-2023." </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/06-07/NIT for SECTOR 10.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>


                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow7(!show7)}
                        >
                          <b> Notification for Corrigendum: (NPCL/PRJ/FY23-24/33KVAIS/003)</b>
                        </div>
                        {show7 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-10">Tender Description</th>
                                <th className="col-sm-1">  </th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td> Corrigendum-1 against NIT No. Tender Enquiry No.: NPCL/PRJ/FY23-24/33KVAIS/003 for 1250 AMPS 33kV AIS INDOOR SWITCHBOARD WITH TRANSFORMER PROTECTION " "Bid submission date is extended till 11th-August-2023."</td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/26-07/CORRIGENDUM -1 DATEDâ€“ EXTENSION IN BID SUBMISSION DATE for NIT NPCL PRJ FY23 24 33KV AIS 003.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>


                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow29(!show29)}
                        >
                          <b> Notification for Corrigendum: (NPCL/PRJ/FY23-24/11KVAIS/004)</b>
                        </div>
                        {show29 ? (
                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-10">Tender Description</th>
                                <th className="col-sm-1">  </th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>Corrigendum-1 against NIT No. NPCL/PRJ/FY23-24/11KVAIS/004 DT: 10.07.2023 For â€˜â€™ SUPPLY OF 1250 AMPS 11kV INDOOR AIR INSULATED SWITCHGEAR." "Bid submission date is extended till 11th-August-2023." </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/26-07/CORRIGENDUM -1 DATED - EXTENSION IN BID SUBMISSION DATE NPCL PRJ FY23-24 11KV AIS 004.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>


                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow28(!show28)}
                        >
                          <b> Pre Bid Queries against NIT No. NPCL/PRJ/FY23-24/PTR/001 </b>
                        </div>
                        {show28 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-10">Tender Description</th>
                                <th className="col-sm-1">  </th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td> Pre Bid Queries against NIT No. NPCL/PRJ/FY23-24/PTR/001 dated 10-07-2023 For " SUPPLY OF 33/11 kV 12.5 MVA Power Transformers."  </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/26-07/Pre Bid Queries Power Tfr.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>


                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow6(!show6)}
                        >
                          <b>Notification for Corrigendum: (NIT no. NPCL/PRJ/FY23-24/GIS/002)</b>
                        </div>
                        {show6 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-10">Tender Description</th>
                                <th className="col-sm-1">  </th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td> Corrigendum-1 against NIT No.: NPCL/PRJ/FY23-24/GIS/002 for 33KV DOUBLE BUS INDOOR GAS INSULATED SWITCHGEAR (9 PANEL BOARDS) "Bid submission date is extended till 11th-August-2023." </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/26-07/CORRIGENDUM -1 DATED â€“ EXTENSION IN BID SUBMISSION DATE NIT NPCL PRJ FY 23-24 GIS 002.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>


                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow27(!show27)}
                        >
                          <b> Notification for Corrigendum (NIT No: NPCL/PRJ/FY23-24/CAB/005) </b>
                        </div>
                        {show27 ? (
                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-10">Tender Description</th>
                                <th className="col-sm-1">  </th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td> Corrigendum-1 against NIT No: NPCL/PRJ/FY23-24/CAB/005 DT: 10.07.2023 For " SUPPLY OF 33kV 3C X 400 SQ. MM ALUMINIUM XLPE GRADE CABLE & 11kV 3C X 300 SQ. MM ALUMINIUM XLPE GRADE CABLE." "Bid submission date is extended till 16th-August-2023." </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/26-07/NIT for Cable.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>


                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow26(!show26)}
                        >
                          <b> Notification for Corrigendum (NIT No. NPCL/PRJ/FY23-24/PTR/001) </b>
                        </div>
                        {show26 ? (
                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-10">Tender Description</th>
                                <th className="col-sm-1">  </th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td> Corrigendum-1 against NIT No: NPCL/PRJ/FY23-24/PTR/001 DT: 10.07.2023 For " SUPPLY OF 33/11 kV 12.5 MVA Power Transformers." "Bid submission date is extended till 16th-August-2023." </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/26-07/NIT for PTR.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>


                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow25(!show25)}
                        >
                          <b>Notification for Corrigendum: (NIT No: NPCL/CIV/ESS/FY23-24/SECTOR-01) </b>
                        </div>
                        {show25 ? (
                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-10">Tender Description</th>
                                <th className="col-sm-1">  </th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td> Corrigendum-1 against NIT No: NPCL/CIV/ESS/FY23-24/SECTOR-01 DT: 06.07.2023 For "Civil Construction of 33/11kV Electric Substation cum 33kV Switching Station Building with Outdoor Transformer Yard & Boundary Wall at Sector-01, Greater Noida." "Bid submission date is extended till 9th-August-2023." </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/26-07/Sector-01.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>


                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow24(!show24)}
                        >
                          <b> Notification for Corrigendum: (NIT No: NPCL/CIV/ESS/FY23-24/ECOTECH-08) </b>
                        </div>
                        {show24 ? (
                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-10">Tender Description</th>
                                <th className="col-sm-1">  </th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td> Corrigendum-1 against NIT No: NPCL/CIV/ESS/FY23-24/ECOTECH-08 DT: 06.07.2023 For " Civil Construction of 33/11kV Electric Substation cum 33kV Switching Station Building with Outdoor Transformer Yard & Boundary Wall at Sector Ecotech-08, Greater Noida, Greater Noida." "Bid submission date is extended till 9th-August-2023." </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/26-07/Ecotech-08.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>


                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow23(!show23)}
                        >
                          <b> Notification for Corrigendum: (NIT No: NPCL/CIV/ESS/FY23-24/ECOTECH-10) </b>
                        </div>
                        {show23 ? (
                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-10">Tender Description</th>
                                <th className="col-sm-1">  </th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td> Corrigendum-1 against NIT No: NPCL/CIV/ESS/FY23-24/ECOTECH-10 DT: 06.07.2023 For " Civil Construction of 33/11kV Electric Substation cum 33kV Switching Station Building with Outdoor Transformer Yard & Boundary Wall at Sector Ecotech-10, Greater Noida." "Bid submission date is extended till 9th-August-2023." </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/26-07/Ecotech-10.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>


                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow22(!show22)}
                        >
                          <b> Notification for Corrigendum: (NIT No: NPCL/CIV/ESS/FY23-24/SECTOR-04) </b>
                        </div>
                        {show22 ? (
                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-10">Tender Description</th>
                                <th className="col-sm-1">  </th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td> Corrigendum-1 against NIT No: NPCL/CIV/ESS/FY23-24/SECTOR-04 DT: 06.07.2023 For "Civil Construction of 33/11kV Electric Substation cum 33kV Switching Station Building with Outdoor Transformer Yard & Boundary Wall at Sector-04, Greater Noida." "Bid submission date is extended till 9th-August-2023." </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/26-07/Sector-04.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>


                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow21(!show21)}
                        >
                          <b> Notification for Corrigendum: (NIT No: NPCL/CIV/ESS/FY23-24/SECTOR-10) </b>
                        </div>
                        {show21 ? (
                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-10">Tender Description</th>
                                <th className="col-sm-1">  </th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td> Corrigendum-1 against NIT No: NPCL/CIV/ESS/FY23-24/SECTOR-10 DT: 06.07.2023 For " Civil Construction of 33/11kV Electric Substation cum 33kV Switching Station Building with Outdoor Transformer Yard at Sector-10, Greater Noida." "Bid submission date is extended till 9th-August-2023." </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/26-07/Sector-10.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>


                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow20(!show20)}
                        >
                          <b> Pre Bid Queries for NIT No: NPCL/CIV/ESS/FY23-24/ECOTECH-08 </b>
                        </div>
                        {show20 ? (
                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-10">Tender Description</th>
                                <th className="col-sm-1">  </th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td> Pre Bid Queries against NIT No: NPCL/CIV/ESS/FY23-24/ECOTECH-08 DT: 06.07.2023 For "Civil Construction of 33/11kV Electric Substation cum 33kV Switching Station Building with Outdoor Transformer Yard & Boundary Wall at Sector Ecotech-08, Greater Noida, Greater Noida."  </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/26-07/Pre Bid Queries Ecotech 08.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>
                                </td>
                              </tr>
                            </table>
                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow19(!show19)}
                        >
                          <b> Pre Bid Queries for NIT No: NPCL/CIV/ESS/FY23-24/ECOTECH-10 </b>
                        </div>
                        {show19 ? (
                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-10">Tender Description</th>
                                <th className="col-sm-1">  </th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td> Pre Bid Queries against NIT No: NPCL/CIV/ESS/FY23-24/ECOTECH-10 DT: 06.07.2023 For " Civil Construction of 33/11kV Electric Substation cum 33kV Switching Station Building with Outdoor Transformer Yard & Boundary Wall at Sector Ecotech-10, Greater Noida."  </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/26-07/Pre Bid Queries Ecotech 10.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>


                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow18(!show18)}
                        >
                          <b> Pre Bid Queries for NIT No: NPCL/CIV/ESS/FY23-24/SECTOR-04 </b>
                        </div>
                        {show18 ? (
                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-10">Tender Description</th>
                                <th className="col-sm-1">  </th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td> Pre Bid Queries against NIT No: NPCL/CIV/ESS/FY23-24/SECTOR-04 DT: 06.07.2023 For " Civil Construction of 33/11kV Electric Substation cum 33kV Switching Station Building with Outdoor Transformer Yard & Boundary Wall at Sector-04, Greater Noida."  </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/26-07/Pre Bid Queries Sector 04.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>


                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow17(!show17)}
                        >
                          <b> Pre Bid Queries for NIT No: NPCL/CIV/ESS/FY23-24/SECTOR-01 </b>
                        </div>
                        {show17 ? (
                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-10">Tender Description</th>
                                <th className="col-sm-1">  </th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td> Pre Bid Queries against NIT No: NPCL/CIV/ESS/FY23-24/SECTOR-01 DT: 06.07.2023 For " Civil Construction of 33/11kV Electric Substation cum 33kV Switching Station Building with Outdoor Transformer Yard & Boundary Wall at Sector-01, Greater Noida." </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/26-07/Pre Bid Queries Sector 01.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>


                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow16(!show16)}
                        >
                          <b> Pre Bid Queries for NIT No: NPCL/CIV/ESS/FY23-24/SECTOR-10  </b>
                        </div>
                        {show16 ? (
                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-10">Tender Description</th>
                                <th className="col-sm-1">  </th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td> Pre Bid Queries against NIT No: NPCL/CIV/ESS/FY23-24/SECTOR-10 DT: 06.07.2023 For " Civil Construction of 33/11kV Electric Substation cum 33kV Switching Station Building with Outdoor Transformer Yard at Sector-10, Greater Noida."  </td>
                                <td>

                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/26-07/Pre Bid Queries Sector 10.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>


                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow15(!show15)}
                        >
                          <b> Pre Bid Queries for NIT No. NPCL/PRJ/FY23-24/CAB/005 </b>
                        </div>
                        {show15 ? (
                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-10">Tender Description</th>
                                <th className="col-sm-1">  </th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td> Pre Bid Queries against NIT No: NPCL/PRJ/FY23-24/CAB/005 DT: 06.07.2023 For "SUPPLY OF 33kV 3C X 400 SQ. MM ALUMINIUM XLPE GRADE CABLE & 11kV 3C X 300 SQ. MM ALUMINIUM XLPE GRADE CABLE." </td>
                                <td>


                                  <a
                                    href="https://iwebapps.noidapower.com:8032/download/NIT/26-07/Pre Bid Queries for Cables.pdf"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <img src="assets/img/pdf.png" alt="" />
                                  </a>

                                </td>
                              </tr>

                            </table>


                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow14(!show14)}
                        >
                          <b> Tender Notification for Supply 33kV 3C X 400 Sq. mm. Aluminium XLPE Grade Cable & 11kV 3C X 300 Sq. mm. Aluminium XLPE Grade Cable: NIT No. NPCL/PRJ/FY23-24/CAB/005 </b>
                        </div>
                        {show14 ? (
                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-7">Tender Description</th>
                                <th className="col-sm-4">NIT No. &nbsp;  Date: 10-07-2023 </th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td> Notice Inviting Tenders for â€œSUPPLY OF 33kV 3C X 400 SQ. MM ALUMINIUM XLPE GRADE CABLE & 11kV 3C X 300 SQ. MM ALUMINIUM XLPE GRADE CABLE".</td>
                                <td>

                                  NPCL/PRJ/FY23-24/CAB/005 </td>
                              </tr>

                            </table>
                            <ul className="tariff_standard">
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/10-07/Bid Document Supply of 33kV  11kV XLPE Cable.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />


                                </a>
                              </li>

                              <li>
                                <img src="assets/img/pdf.png" alt="" />
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/10-07/TS_GTP_DWG_11kV_300sqmm_XLPE_Cable_Rev_A.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  TS GTP DWG 11kV 300sqmm XLPE Cable Rev A
                                </a>
                              </li>
                              <li>
                                <img src="assets/img/pdf.png" alt="" />
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/10-07/TS_GTP_DWG_33kV_400sqmm_XLPE_Cable_Rev_A.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  TS GTP DWG 33kV 400sqmm XLPE Cable Rev A
                                </a>
                              </li>
                            </ul>

                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow13(!show13)}
                        >
                          <b> Tender Notification for Supply of 1250 Amps 11kV Indoor Air Insulated Switchgear (AIS): NIT No. NPCL/PRJ/FY23-24/11KVAIS/004. </b>
                        </div>
                        {show13 ? (
                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-7">Tender Description</th>
                                <th className="col-sm-4">NIT No. &nbsp;  Date: 10-07-2023 </th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>Notice Inviting Tenders for â€œ SUPPLY OF 1250 AMPS 11kV INDOOR AIR INSULATED SWITCHGEAR ".</td>
                                <td>


                                  NPCL/PRJ/FY23-24/11KVAIS/004</td>
                              </tr>

                            </table>
                            <ul className="tariff_standard">
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/10-07/Bid Document Supply of 11kV ID AIS.pdf"
                                  target="_blank" rel="noreferrer"
                                >

                                  <img src="assets/img/pdf.png" alt="" />

                                </a>
                              </li>

                              <li>
                                <img src="assets/img/pdf.png" alt="" />
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/10-07/TS_GTP_11kV_ID_VCB_BOARD1250A_CONTROLLED.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  TS GTP 11kV ID VCB BOARD1250A CONTROLLED
                                </a>
                              </li>
                            </ul>

                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow12(!show12)}
                        >
                          <b> Tender Notification for Supply of 1250 Amps 33kV AIS Indoor Switchboard: NIT No. NPCL/PRJ/FY23-24/33KVAIS/003 </b>
                        </div>
                        {show12 ? (
                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-7">Tender Description</th>
                                <th className="col-sm-4">NIT No.  &nbsp;  Date: 10-07-2023</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td> Notice Inviting Tenders for â€œ SUPPLY OF 1250 AMPS 33kV AIS INDOOR SWITCHBOARD WITH TRANSFORMER PROTECTION  ".</td>
                                <td>NPCL/PRJ/FY23-24/33KVAIS/003</td>
                              </tr>

                            </table>
                            <ul className="tariff_standard">
                              <li>
                                <img src="assets/img/pdf.png" alt="" />
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/10-07/Bid Document Supply of 33kV ID AIS.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  Bid Document Supply of 33kV ID AIS
                                </a>
                              </li>

                              <li>
                                <img src="assets/img/pdf.png" alt="" />
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/10-07/TS_GTP_33KV_AIS_ID_BOARD_CONTROLLED.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  TS GTP 33KV AIS ID BOARD CONTROLLED
                                </a>
                              </li>
                            </ul>

                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow11(!show11)}
                        >
                          <b> Tender Notification for Supply & ETC of 1600 Amps 33KV Double Bus Indoor Gas Insulated Switchgear (GIS): NIT No. NPCL/PRJ/FY23-24/GIS/002. </b>
                        </div>
                        {show11 ? (
                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-7">Tender Description</th>
                                <th className="col-sm-4">NIT No. &nbsp;  Date: 10-07-2023 </th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>Notice Inviting Tenders for â€œ SUPPLY & ETC OF 33KV DOUBLE BUS INDOOR GAS INSULATED SWITCHGEAR (9 PANEL BOARDS) ".</td>
                                <td>


                                  NPCL/PRJ/FY23-24/GIS/002 </td>
                              </tr>

                            </table>
                            <ul className="tariff_standard">
                              <li>
                                <img src="assets/img/pdf.png" alt="" />
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/10-07/Bid Document Supply & ETC of 33kV DB ID GIS.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  Bid Document Supply & ETC of 33kV DB ID GIS
                                </a>
                              </li>

                              <li>
                                <img src="assets/img/pdf.png" alt="" />
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/10-07/TS_GTP_33KV_DOUBLE_BUS_GIS_CONTROLLED_R-A.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  TS GTP 33KV DOUBLE BUS GIS CONTROLLED R-A
                                </a>
                              </li>
                            </ul>

                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow10(!show10)}
                        >
                          <b> Tender Notification for Supply of 33/11 kV 12.5 MVA Power Transformers: NIT No. NPCL/PRJ/FY23-24/PTR/001 </b>
                        </div>
                        {show10 ? (
                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-7"> Tender Description</th>
                                <th className="col-sm-4">NIT No.  &nbsp;  Date: 10-07-2023</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>Notice Inviting Tenders for â€œ SUPPLY OF 33/11 kV 12.5 MVA Power Transformers </td>
                                <td>NPCL/PRJ/FY23-24/PTR/001</td>
                              </tr>

                            </table>
                            <ul className="tariff_standard">
                              <li>
                                <img src="assets/img/pdf.png" alt="" />
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/10-07/Bid Document 12.5 MVA Power Transformer.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  Bid Document 12.5 MVA Power Transformer
                                </a>
                              </li>

                              <li>
                                <img src="assets/img/pdf.png" alt="" />
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/10-07/TS_12.5MVA_33_11kV_ONAN_Three_Phase_Power_Transformer_Controlled_Copy.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  TS 12.5MVA 33 11kV ONAN Three Phase Power Transformer Controlled
                                </a>
                              </li>
                            </ul>

                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow1(!show1)}
                        >
                          <b> Notice Inviting Tenders for "Civil Construction of 33/11kV Electric Substation cum 33kV Switching Station Building with Outdoor Transformer Yard & Boundary Wall at Sector Ecotech-08, Greater Noida".  </b>
                        </div>
                        {show1 ? (
                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-7">Tender Description</th>
                                <th className="col-sm-4">NIT No. &nbsp;  Date: 06-07-2023 </th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>Notice Inviting Tenders for "Civil Construction of 33/11kV Electric Substation cum 33kV Switching Station Building with Outdoor Transformer Yard & Boundary Wall at Sector Ecotech-08, Greater Noida".</td>
                                <td>

                                  NPCL/CIV/ESS/FY23-24/ECOTECH-08</td>
                              </tr>

                            </table>
                            <ul className="tariff_standard">
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NIT-No-NPCLCIVESSFY23-24ECOTECH-08/Bid Document of Civil Works- Ecotech-08.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />


                                </a>
                              </li>

                              <li>
                                <img src="assets/img/pdf.png" alt="" />
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NIT-No-NPCLCIVESSFY23-24ECOTECH-08/ANNEXURE-TYPICAL DRAWINGS.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  ANNEXURE-TYPICAL DRAWINGS
                                </a>
                              </li>
                            </ul>

                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow2(!show2)}
                        >
                          <b> Notice Inviting Tenders for "Civil Construction of 33/11kV Electric Substation cum 33kV Switching Station Building with Outdoor Transformer Yard & Boundary Wall at Sector Ecotech-10, Greater Noida </b>
                        </div>
                        {show2 ? (
                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-7">Tender Description</th>
                                <th className="col-sm-4">NIT No.  &nbsp;  Date: 06-07-2023</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>Notice Inviting Tenders for "Civil Construction of 33/11kV Electric Substation cum 33kV Switching Station Building with Outdoor Transformer Yard & Boundary Wall at Sector Ecotech-10, Greater Noida".</td>
                                <td>NPCL/CIV/ESS/FY23-24/ECOTECH-10</td>
                              </tr>

                            </table>
                            <ul className="tariff_standard">
                              <li>
                                <img src="assets/img/pdf.png" alt="" />
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NIT-No-NPCLCIVESSFY23-24ECOTECH-10/Bid Document of Civil Works- Ecotech-10.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  Bid Document of Civil Works- Ecotech-10
                                </a>
                              </li>

                              <li>
                                <img src="assets/img/pdf.png" alt="" />
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NIT-No-NPCLCIVESSFY23-24ECOTECH-10/ANNEXURE-TYPICAL DRAWINGS.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  ANNEXURE-TYPICAL DRAWINGS
                                </a>
                              </li>
                            </ul>

                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow9(!show9)}
                        >
                          <b>  Notice Inviting Tenders for "Civil Construction of 33/11kV Electric Substation cum 33kV Switching Station Building with Outdoor Transformer Yard & Boundary Wall at Sector-01, Greater Noida </b>
                        </div>
                        {show9 ? (
                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-7">Tender Description</th>
                                <th className="col-sm-4">NIT No.  &nbsp;  Date: 06-07-2023</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td> Notice Inviting Tenders for "Civil Construction of 33/11kV Electric Substation cum 33kV Switching Station Building with Outdoor Transformer Yard & Boundary Wall at Sector-01, Greater Noida".</td>
                                <td> NPCL/CIV/ESS/FY23-24/SECTOR-01 </td>
                              </tr>

                            </table>
                            <ul className="tariff_standard">
                              <li>
                                <img src="assets/img/pdf.png" alt="" />
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NIT-No-NPCLCIVESSFY23-24SECTOR-01/Bid Document of Civil Works- Sector-01.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  Bid Document of Civil Works- Sector-01
                                </a>
                              </li>

                              <li>
                                <img src="assets/img/pdf.png" alt="" />
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NIT-No-NPCLCIVESSFY23-24SECTOR-01/ANNEXURE-TYPICAL DRAWINGS.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  ANNEXURE-TYPICAL DRAWINGS
                                </a>
                              </li>
                            </ul>


                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow8(!show8)}
                        >
                          <b> Notice Inviting Tenders for "Civil Construction of 33/11kV Electric Substation cum 33kV Switching Station Building with Outdoor Transformer Yard & Boundary Wall at Sector-04, Greater Noida </b>
                        </div>
                        {show8 ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-7">Tender Description</th>
                                <th className="col-sm-4">NIT No.  &nbsp;  Date: 06-07-2023</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td>Notice Inviting Tenders for "Civil Construction of 33/11kV Electric Substation cum 33kV Switching Station Building with Outdoor Transformer Yard & Boundary Wall at Sector-04, Greater Noida".</td>
                                <td> NPCL/CIV/ESS/FY23-24/SECTOR-04 </td>
                              </tr>

                            </table>
                            <ul className="tariff_standard">
                              <li>
                                <img src="assets/img/pdf.png" alt="" />
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NIT-No-NPCLCIVESSFY23-24SECTOR-04/Bid Document of Civil Works- Sector-04.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  NPCL/CIV/ESS/FY23-24/SECTOR-04
                                </a>
                              </li>

                              <li>
                                <img src="assets/img/pdf.png" alt="" />
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NIT-No-NPCLCIVESSFY23-24SECTOR-04/ANNEXURE-TYPICAL DRAWINGS.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  ANNEXURE-TYPICAL DRAWINGS
                                </a>
                              </li>
                            </ul>

                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow(!show)}
                        >
                          <b> Notice Inviting Tenders for "Civil Construction of 33/11kV Electric Substation cum 33kV Switching Station Building with Outdoor Transformer Yard at Sector-10, Greater Noida </b>
                        </div>
                        {show ? (

                          <div className="card-body">
                            <table className="table table-responsive table-striped">
                              <tr>
                                <th className="col-sm-1">Sr. No.</th>
                                <th className="col-sm-7">Tender Description</th>
                                <th className="col-sm-4">NIT No.  &nbsp;  Date: 06-07-2023</th>
                              </tr>
                              <tr>
                                <td>1.</td>
                                <td> Notice Inviting Tenders for "Civil Construction of 33/11kV Electric Substation cum 33kV Switching Station Building with Outdoor Transformer Yard at Sector-10, Greater Noida".</td>
                                <td> NPCL/CIV/ESS/FY23-24/SECTOR-10 </td>
                              </tr>

                            </table>
                            <ul className="tariff_standard">
                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NIT-No-NPCLCIVESSFY23-24SECTOR-10/Bid Document of Civil Works- Sector-10.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />


                                </a>
                              </li>

                              <li>
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/NIT/NIT-No-NPCLCIVESSFY23-24SECTOR-10/ANNEXURE-TYPICAL DRAWINGS.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  <img src="assets/img/pdf.png" alt="" />

                                  {/* ANNEXURE-TYPICAL DRAWINGS */}
                                </a>
                              </li>
                            </ul>

                          </div>
                        ) : null}
                      </div>

                      <div className="card">
                        <div
                          className="card-header"
                          onClick={() => setShow5(!show5)}
                        >
                          <b> Tender for banking of power for 01.11.2022 to 30.09.2023
                            on Short Term Basis</b>
                        </div>
                        {show5 ? (

                          <div className="card-body">
                            <ul className="tariff_standard">
                              <li>
                                <img src="assets/img/pdf.png" alt="" />
                                <a
                                  href="https://iwebapps.noidapower.com:8032/download/Banking_tender_for_01.11.2022_to_30.09.2023.pdf"
                                  target="_blank" rel="noreferrer"
                                >
                                  Tender
                                </a>
                              </li>
                            </ul>
                          </div>
                        ) : null}
                      </div>

                      {/*    
                   <div className="card">
                          <div
                            className="card-header"
                            onClick={() => setShow4(!show4)}
                          >
                            <b> Inviting Bids for Pilot of â€œP2P Energy trading using
                        Blockchainâ€. Submission of Technical queries - Date
                        extended to 24/01/2022</b>
                          </div>
                          {show4 ? (

                            <div className="card-body">
                            <ul className="tariff_standard">
                            <li>
                              <img src="assets/img/pdf.png" alt="" />
                              <a
                                href="https://iwebapps.noidapower.com:8032/download/RFP_P2P_Energy_Trading_Using_Blockchin_Pilot_at_NPCL.pdf"
                                target="_blank" rel="noreferrer"
                              >
                                RfP
                              </a>
                            </li>
                          </ul>
                            </div>
                            ) : null}
                   </div>


                   
                   <div className="card">
                          <div
                            className="card-header"
                            onClick={() => setShow3(!show3)}
                          >
                            <b>  Inviting Bids for Pilot of â€œP2P Energy trading using
                        Blockchainâ€-Pre-bid Query Response and Addendum</b>
                          </div>
                          {show3 ? (

                            <div className="card-body">
                            <ul className="tariff_standard">
                            <li>
                              <img src="assets/img/pdf.png" alt="" />
                              <a
                                href="https://iwebapps.noidapower.com:8032/download/P2P_Energy_Trading_using_Blockchain_Pilot_Pre-bid_Queries_Response.pdf"
                                target="_blank" rel="noreferrer"
                              >
                                Response
                              </a>
                            </li>
                            <li>
                              <img src="assets/img/pdf.png" alt="" />
                              <a
                                href="https://iwebapps.noidapower.com:8032/download/P2P_Energy_Trading_using_Blockchain_Pilot_Addendum.pdf"
                                target="_blank" rel="noreferrer"
                              >
                                Addendum
                              </a>
                            </li>
                            <li>
                              <img src="assets/img/pdf.png" alt="" />
                              <a
                                href="https://iwebapps.noidapower.com:8032/download/P2P_Energy_Trading_using_Blockchain_Pilot-Addendum-2.pdf"
                                target="_blank" rel="noreferrer" 
                              >
                                Addendum - 2
                              </a>
                            </li>
                          </ul>
                            </div>
                            ) : null}
                   </div>
                   
                   
                   */}


                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Tender;